/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the User Profile page component. The component displays the User Profile page details.
 * 
 * App Name: SDI-Walmart
 * Author: M.Sushmitha
 * Created Date: 08/21/2020 
 */
import React, { Component } from 'react';
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Input from "@material-ui/core/Input";
import swal from 'sweetalert';
/* Ref no: UP_PC_01
 * ProfileAction has the action method used to call the API method for data response.
 * */
import * as ProfileAction from '../actions/ProfileAction';
/*Ref no: UP_PC_01
 * ProfileStore has the store case whhich emits the action response and invokes the response method.
 * */
import ProfileStore from '../stores/ProfileStore';
/*
 * MenuAction has the action method used to call the API method for data response.
 * When an item is added to cart or the page is made to favorite.Menu bar has to reloaded.
 * For this purpose manuaction is used in Shoppingcartcomponent.
 * */
import * as MenuAction from '../actions/MenuAction';
/*
 * The below react plugin are used for the Multi select drop down used in the user profile tab 1
 * React checkbox tree is used for the user privileges tree.
 * */
import MultiSelect from "react-multi-select-component";
import CheckboxTree from 'react-checkbox-tree';
/*
 * CookieService is used for the Usage of the local database values in the component. 
 * The Local database is used for maintaining the login user falgs 
 * 
 * */
import * as CookieService from '../CookieService';
import SDIConstants,{ ConvertToEst } from '../SDIConstants';
/*
 * react select plugin in place of select drop down in the user profile, in place of normal down drop.
 * This plugin has the search value feature too.
 * */
import Select, { components } from 'react-select';
/*
 *Import the Jquery to use jquery feature for binding the value to the field and so on.
 */
import * as $ from 'jquery';
/*
 *Thes are global varaiable used for validation check ,disable or enable a field etc. 
 * */
import { withTranslation, Trans } from 'react-i18next'
import i18n from '../i18n';
import { fontFamily } from '@material-ui/system';
let TabclickTitle = "";
let AddTSTUSERSuccess = 1;
let MultiSiteCHeckB = false;
//let DisableTypeDD = false;
let currentPagePath;
//let AccountActive = 0;
let approvalAccordian = 0;
let checkboxCount = 0;
let SelectAll = true

//15/08/23, 3962 - Adding the regular expression pattern which allows any whitespaces, Vishwa S]
const passwrdRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\s]).{10,}$");
const spaceregexp = /^\S*$/;
const languageOptions = [
    {
        value: 'en', label: 'English', icon:
            "http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
    },
    {
        value: 'es', label: 'Español', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/MX.svg"
    },
    {
        value: 'fr', label: 'Français', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg"
    }
]
const { Option } = components;
const IconOption = props => (
    <Option {...props}>
        <img
            src={props.data.icon}
            alt={props.data.label}
            style={{ "width": "12px" }}
        />
        {" "}
        {props.data.label}
    </Option>
);
class Profile extends Component {
    /**
     * UP_PC_03
     * Declare a “constructor” method with “props” as its parameters.
     * @param props
   */
    constructor(props) {

        super(props);

        this.handleFavorite = this.handleFavorite.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.BuildUserProfile = this.BuildUserProfile.bind(this);
        this.refreshMenu = this.refreshMenu.bind(this);
        this.BuildUserProfileForm = this.BuildUserProfileForm.bind(this);
        this.TabClick = this.TabClick.bind(this);
        this.BuildTabClick = this.BuildTabClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.BuildUserProfileDetails = this.BuildUserProfileDetails.bind(this);
        this.handleChangeSite = this.handleChangeSite.bind(this);

        this.ShowThirdParty = this.ShowThirdParty.bind(this);
        this.handleChangeTab2Site = this.handleChangeTab2Site.bind(this);
        this.handleChangeTab2Role = this.handleChangeTab2Role.bind(this);
        this.handleChangeDepart = this.handleChangeDepart.bind(this);
        this.handleChangeUserROle = this.handleChangeUserROle.bind(this);
        this.handleMultiSiteDD = this.handleMultiSiteDD.bind(this);
        this.OnCheckTree = this.OnCheckTree.bind(this);
        this.handleChangeAppro = this.handleChangeAppro.bind(this);
        this.handleChangeShipto = this.handleChangeShipto.bind(this);
        this.handleChangeDepartPref = this.handleChangeDepartPref.bind(this);
        this.handleChangeCrib = this.handleChangeCrib.bind(this);

        this.handleChangeEmplyee = this.handleChangeEmplyee.bind(this);
        this.UserTypeRadio = this.UserTypeRadio.bind(this);
        this.BuildSearchOnUserTypeChg = this.BuildSearchOnUserTypeChg.bind(this);
        this.ChgPwd = this.ChgPwd.bind(this);
        this.MultiSiteCheckBtn = this.MultiSiteCheckBtn.bind(this);
        this.BindMultiSiteDD = this.BindMultiSiteDD.bind(this);
        this.btnSave_Click = this.btnSave_Click.bind(this);
        this.UpdateUserProfile = this.UpdateUserProfile.bind(this);
        this.AddUser = this.AddUser.bind(this);
        this.EditUser = this.EditUser.bind(this);
        this.ShowEditMessage = this.ShowEditMessage.bind(this);
        this.logout = this.logout.bind(this);
        //this.VendorIdChaneg = this.VendorIdChaneg.bind(this);

        //this.BindVendorSite = this.BindVendorSite.bind(this);
        this.OnchangePrivType = this.OnchangePrivType.bind(this);
        this.BindPrivilegeOnType = this.BindPrivilegeOnType.bind(this);
        this.BindPrivilegeOnRole = this.BindPrivilegeOnRole.bind(this);
        this.updatePrivilege = this.updatePrivilege.bind(this);
        this.ShowUpdateMesPri = this.ShowUpdateMesPri.bind(this);
        this.UpdateApprovals = this.UpdateApprovals.bind(this);
        this.ShowApprovalStatus = this.ShowApprovalStatus.bind(this);
        this.ShowBudApprovalStatus = this.ShowBudApprovalStatus.bind(this);
        this.UpdateOSE = this.UpdateOSE.bind(this);
        this.ShowOSEMessage = this.ShowOSEMessage.bind(this);
        this.UpdatePref = this.UpdatePref.bind(this);

        this.ShowPrefMessage = this.ShowPrefMessage.bind(this);
        this.UpdateCrib = this.UpdateCrib.bind(this);
        this.ShowMobMessage = this.ShowMobMessage.bind(this);
        this.UpdateZeus = this.UpdateZeus.bind(this);
        this.ShowZeusMessage = this.ShowZeusMessage.bind(this);
        this.LoadApprover = this.LoadApprover.bind(this);
        this.BuildReqApprovalForm = this.BuildReqApprovalForm.bind(this);
        this.BuildBudApprovalForm = this.BuildBudApprovalForm.bind(this);
        this.UpdateTST = this.UpdateTST.bind(this);

        this.ShowTrackMessage = this.ShowTrackMessage.bind(this);
        this.BindSelectUserTrackData = this.BindSelectUserTrackData.bind(this);
        this.COStatus = this.COStatus.bind(this);
        this.PrivTreeAction = this.PrivTreeAction.bind(this);
        this.ShowActivateStatus = this.ShowActivateStatus.bind(this)
        this.handleProfileFormChange = this.handleProfileFormChange.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.handleMouseDownPassword = this.handleMouseDownPassword.bind(this);
        {/*WW-1229 Home tiles -Nandhini L*/ }
        this.BindHomeTiles = this.BindHomeTiles.bind(this);
        this.onClickHomeTiles = this.onClickHomeTiles.bind(this);
        /*
         * UP_PC_04
        * All the below mentioned State variable are used in the component to bind,update,show popup and so on.
        * */
        this.state = {
            Login_UserId: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Login_UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            AccountActive: 0,
            SelectUserDetails: [],
            VendorIdValidate: 0,
            PrivTree: [],
            DisableTypeDD: false,
            MultiSiteChecked: false,
            DisablePrivRole: false,
            adduser: false,
            isFavorited: false,
            selectedMultiSites: [],
            ChangePasswordEnable: "N",
            ManuallyAddUserId: "",
            ExistReqAppr: "",
            ExistBudAppr: "",
            UserRoleDD: [],
            SelectUserRole: {},
            SiteTitleValue: "",
            SelectedUserId: "",
            selectedOption: [],
            selectSiteID: "",
            SiteList: [],
            MultiSite: [],
            MultiSiteSelected: [],
            SearchUser: [],
            Depart: [],
            ThirdPartyList: [],
            AutoAssignFlag: "",
            //5722 - In user profile change password screen all field enabled [4/18/2025] Nachiappan
            DisableFields: false, // New state variable to manage field disabling
            FirstName: "",
            LastName: "",
            LoginHideuserId: "",
            HideuserId: "",
            PhoneNum: "",
            EmailAddres: "",
            LoginUserType: "",
            LoginUserRole: "",
            UserType: "",
            UserRole: "",
            DepartMent: [],
            SelectSite: [],
            MultiSiteEnable: "N",
            UserActiveStatus: "",
            EmployeeAccountActiveStatus: "",
            VendorGroup: "",
            VendorId: "",
            Tab2SiteList: [],
            Tab2RoleList: [],
            SelectROleList: [],
            Tab2AlacartList: [],
            Tab2RoleTree: [],
            Tab2BindTree: [],
            Tab2SiteTreeValue: [],
            SelectTab2Site: [],
            checked: [],
            expanded: [],
            ApproverList: [],
            ExistApproveValue: [],
            ExistAppLimit: "",
            initialApprover: "",
            DepartPref: [],
            DepartmentPref: [],
            ShiptoList: [],
            Shipto: [],
            CribValue: [],
            CribList: [],
            TSTEmployeeValue: [],
            TSTDefaultValue: [],
            TSTUserID: "",
            PageAction: "EDIT",
            SelectUsertype: "",
            SelectedThirdParty: "",
            PrivTreeDisable: false,
            GroupID: "",
            SDIEMp: false,
            Customer: false,
            vendor: false,
            PassNTB: "",
            showPassword: false, showConPassword: false,
            RoleExist: "",
            Tab2SiteTitle: "",
            ZeusTitle: "", PageLoadSiteList: [], MultiSiteExist: "N",
            UserIDAdded: "",
            UserRoleAdded: "",
            UserEmailAdded: "",
            IsNewUserCreated: false,
            NewUserOSEDefMsg: "",
            /*[07/19/22, PC_WW-448_01], Priyanka D */
            HomeStore: "", DivisionDD: [], DivisionValue: "", isExpandAll: true, CurrentUserName: "", CurrentUserLimit: "", NextApprover: "", NextApproverLimit: "", ApproverPopupFlag: true, selectedApprvValue: [], updateAltBudgetary: [],
            delAltBudCheck: [], delAltBudIcon: [],
            userProfileErr: "",
            //WW-1229 Home tiles -Nandhini L
            UserHomeTilesList: [], TilesList: [], UserTilesList: [], isSelectAll: true, selectDisplay: true, onlyHomeTile: "", tabrole: "", tabtype: "",
            flagOptions: [], flagValues: [],
            language: CookieService.getLocalStorageValues("newlanguage") ? CookieService.getLocalStorageValues("newlanguage") : languageOptions[0]

        }
    }
    /*
     * RF No: UP_PC_05
     * componentDidMount is the method which is loaded and exceute first.
     * When the User profile page loaded.
     * */
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        CookieService.updateLocalStorageValues("IsProfilePageLoad", true);
        let orderStatusOrigin = false
        /*
         *  RF No: UP_PC_06
         *  BuildUserProfile is the method used to get the pageload data from the database.
         * */
        if (this.props.location.state != null && this.props.location.state != undefined) {
            if (this.props.location.state.origin == 'Inventory') {
                this.TabClick("MOB")
                $(`#mobility`).addClass('active')
                $(`#user-details-tab`).removeClass('active')
                $(`#mobility-link`).addClass('active show')
                $(`#user-details`).removeClass('active show')
            } else if (this.props.location.state.origin == 'Orderstatus') {
                orderStatusOrigin = true
                this.BuildUserProfile();
                this.TabClick("PREF")
                $(`#preferences`).addClass('active')
                $(`#preferences-link`).addClass('active show')
                $(`#user-details-tab`).removeClass('active')
                $(`#user-details`).removeClass('active show')
            }
        }
        if (!orderStatusOrigin) {
            this.BuildUserProfile();
        }
        /*
         * 
        * RF No: UP_PC_08 && UP_PC_09 &&  UP_PC_10
        * This emit call is done when the GetEditUser action has the response.
        * */
        ProfileStore.on("UserDetail", this.BuildUserProfileForm.bind(this));
        /*
        * RF No: UP_PC_11
        * This emit call is done when the GetSearchUserOnUTypeChange action has the response.
        * */
        ProfileStore.on("RadioUserType", this.BuildSearchOnUserTypeChg.bind(this));
        /*
        * RF No: UP_PC_12
        * This emit call is done when the GetSearchUsers action has the response.
        * */
        ProfileStore.on("SelectUser", this.BuildUserProfileDetails);
        //PC_1044_150 WW-1044 Approval Issue [07/05/2024] Pavithra R
        ProfileStore.on('LoadAltBudApprovals', this.BuildAltBudApprovalForm.bind(this));
        ProfileStore.on('UpdateAltBudApprovals', this.ShowAltBudApprovalStatus.bind(this));

        /*
        * RF No: UP_PC_13
        * This emit call is done when the GetVendorGroup action has the response.
        * */
        //ProfileStore.on("VendorIdCheck", this.BindVendorSite.bind(this));
        /*
        * RF No: UP_PC_14 &&  UP_PC_16
        * This emit call is done when the UpdateUserDetails action has the response.
        * */
        ProfileStore.on("AddUser", this.ShowEditMessage);
        /*
        * RF No:UP_PC_15
        * This emit call is done when the GetMultiSite action has the response.
        * */
        ProfileStore.on("MultiSite", this.BindMultiSiteDD.bind(this));
        /*
        * RF No: UP_PC_17 &&  UP_PC_35 &&  UP_PC_33 &&  UP_PC_30 &&  UP_PC_26 &&  UP_PC_28
        * This emit call is done when the GetTabBasedDetails action has the response.
        * */
        ProfileStore.on("TabClick", this.BuildTabClick.bind(this));
        /*
        * RF No: UP_PC_18
        * This emit call is done when the GetPrivilegesType action has the response.
        * */
        ProfileStore.on("PrivilegeType", this.BindPrivilegeOnType.bind(this));
        /*
        * RF No:UP_PC_19
        * This emit call is done when the GetPrivilegeRole action has the response.
        * */
        ProfileStore.on("PrivilegeRole", this.BindPrivilegeOnRole.bind(this));
        /*
        * RF No: UP_PC_20
        * This emit call is done when the UpdatePrivilege action has the response.
        * */
        ProfileStore.on("UpdatePrivilege", this.ShowUpdateMesPri);
        /*
        * RF No: UP_PC_23
        * This emit call is done when the GetReqApprovals action has the response.
        * */
        ProfileStore.on("LoadReqApprovals", this.BuildReqApprovalForm.bind(this));
        /*
        * RF No: UP_PC_21
        * This emit call is done when the GetBudApprovals action has the response.
        * */
        ProfileStore.on("LoadBudApprovals", this.BuildBudApprovalForm.bind(this));
        /*
         * RF No: UP_PC_24
         * This emit call is done when the UpdateReqApp action has the response.
         * */
        ProfileStore.on("UpdateReqApprovals", this.ShowApprovalStatus.bind(this));
        /*
        * RF No: UP_PC_22
        * This emit call is done when the UpdateBudgetApp action has the response.
        * */
        ProfileStore.on("UpdateApprovals", this.ShowBudApprovalStatus.bind(this));
        /*
        * RF No: UP_PC_27
        * This emit call is done when the UpdateOSE action has the response.
        * */
        ProfileStore.on("UpdateOSE", this.ShowOSEMessage.bind(this));
        /*
        * RF No: UP_PC_29
        * This emit call is done when the UpdatePreferences action has the response.
        * */
        ProfileStore.on("UpdatePref", this.ShowPrefMessage.bind(this));
        /*
        * RF No: UP_PC_31
        * This emit call is done when the GetSearchUserTrack action has the response.
        * */
        ProfileStore.on("Selecttrack", this.BindSelectUserTrackData.bind(this));
        /*
        * RF No: UP_PC_32
        * This emit call is done when the AddTrackUser action has the response.
        * */
        ProfileStore.on("AddTrack", this.ShowTrackMessage.bind(this));
        /*
        * RF No: UP_PC_34
        * This emit call is done when the UpdateCrib action has the response.
        * */
        ProfileStore.on("UpdateCrib", this.ShowMobMessage.bind(this));
        /*
        * RF No: UP_PC_36
        * This emit call is done when the UpdateZeus action has the response.
        * */
        ProfileStore.on("UpdateZeus", this.ShowZeusMessage.bind(this));
        /*
        * RF No: UP_PC_64
        * This emit call is done when the GetThirdParty action has the response.
        * */
        ProfileStore.on("ThirdParty", this.ShowThirdParty.bind(this));
        /*
         * This emit call is done when the getCurrentFavPage action has the response.
         * */
        ProfileStore.on('favpage', this.loadFavPageResponse);
        /*
         * This emit call is done when the insertFavPage,deleteFavPage action has the response.
         * */
        ProfileStore.on('updateFavPage', this.updateFavPageResponse);
        /*
         * RF No: UP_PC_37
         * This emit call is done when the ActivateSite, DeActivateSite, ActivateEmpyAcc, DeActivateEmpyAcc, action has the response.
         * */
        ProfileStore.on("ActivateSiteAcct", this.ShowActivateStatus);
    }
    /*
     * componentWillUnmount is used to remove the memory leakage.
     * */
    componentWillUnmount() {

        ProfileStore.removeListener("UserDetail", this.BuildUserProfileForm.bind(this));
        ProfileStore.removeListener("RadioUserType", this.BuildSearchOnUserTypeChg.bind(this));
        ProfileStore.removeListener("SelectUser", this.BuildUserProfileDetails);
        //ProfileStore.removeListener("VendorIdCheck", this.BindVendorSite.bind(this));
        ProfileStore.removeListener("AddUser", this.ShowEditMessage);
        ProfileStore.removeListener("MultiSite", this.BindMultiSiteDD.bind(this));
        ProfileStore.removeListener("TabClick", this.BuildTabClick.bind(this));
        ProfileStore.removeListener("PrivilegeType", this.BindPrivilegeOnType.bind(this));
        ProfileStore.removeListener("PrivilegeRole", this.BindPrivilegeOnRole.bind(this));
        //WW-1229 Home tiles -Nandhini L
        ProfileStore.removeListener("UpdatePrivilege", this.ShowUpdateMesPri.bind(this));
        ProfileStore.removeListener("LoadReqApprovals", this.BuildReqApprovalForm.bind(this));
        ProfileStore.removeListener("LoadBudApprovals", this.BuildBudApprovalForm.bind(this));
        ProfileStore.removeListener("UpdateReqApprovals", this.ShowApprovalStatus.bind(this));
        ProfileStore.removeListener("UpdateApprovals", this.ShowBudApprovalStatus.bind(this));
        ProfileStore.removeListener("UpdateOSE", this.ShowOSEMessage.bind(this));
        ProfileStore.removeListener("UpdatePref", this.ShowPrefMessage.bind(this));
        ProfileStore.removeListener("Selecttrack", this.BindSelectUserTrackData.bind(this));
        ProfileStore.removeListener("AddTrack", this.ShowTrackMessage.bind(this));
        ProfileStore.removeListener("UpdateCrib", this.ShowMobMessage.bind(this));
        ProfileStore.removeListener("UpdateZeus", this.ShowZeusMessage.bind(this));
        ProfileStore.removeListener("ThirdParty", this.ShowThirdParty.bind(this));
        ProfileStore.removeListener('favpage', this.loadFavPageResponse);
        ProfileStore.removeListener('updateFavPage', this.updateFavPageResponse);
        ProfileStore.removeListener("ActivateSiteAcct", this.ShowActivateStatus);
        //PC_1044_151 WW-1044 Approval Issue [07/05/2024] Pavithra R
        ProfileStore.removeListener('LoadAltBudApprovals', this.BuildAltBudApprovalForm.bind(this));
        ProfileStore.removeListener('UpdateAltBudApprovals', this.ShowAltBudApprovalStatus.bind(this));

    }
    /*
     * Ref no: UP_PC_51
     * In BuildUserProfile method the page load action call is made to fetch the action response from the api.
     * */
    BuildUserProfile = () => {
        //document.getElementsByClassName("rct-option-expand-all").setAttribute("id", "ExpnadBtn")
        //document.getElementsByClassName("rct-option-collapse-all").setAttribute("id", "CollapeBtn")
        /**
        * Invoke the action to check the current page is favorited
        */
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: this.state.Login_UserId,
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        ProfileAction.getCurrentFavPage(getFavPageBO);
        let UserProfileBO = {
            Session_USERID: this.state.Login_UserId,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            Session_ThirdParty_CompanyID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
            Session_TrackDBType: CookieService.getLocalStorageValues("Session_TrackDBType"),
            Query_IsVendor: false,
            Query_IsMexicoVendor: false,
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_APPRTYPE: CookieService.getLocalStorageValues("Session_APPRTYPE"),
            //Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"), 
        }
        ProfileAction.GetEditUser(UserProfileBO);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /*
     * Handle change method for favorite page checkbox
     */
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "User Profile",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ProfileAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ProfileAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /*
     * Listener method for loading favorite page icon
     */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ProfileStore.currentFavPageResponse);
        console.log("favPageResponse", favPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    /*
    * Listener method for the response of Save/Delete favorite page
    */
    updateFavPageResponse = () => {
        if (ProfileStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ProfileStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ProfileStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        this.refreshMenu();
    };
    /*
     * This method is used to refresh the menu bar.
     * */
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true
        };
        MenuAction.getMasterData(masterBO);
    };
    /*
     * Ref no:UP_PC_52
     * This method is intialize by the store emit.
     * In this method the user profile tab 1 from details are based up on the login user type and role.
     * The drop down are binded with the stroe response value.
     * */
    BuildUserProfileForm = () => {
        //debugger
        let PageloadDetails = JSON.parse(ProfileStore.UserDetailOBO);
        CookieService.updateLocalStorageValues("IsProfilePageLoad", false);
        console.log("PageloadDetails", PageloadDetails);
        let FirstNameL = "";
        let lastNameL = "";
        let PhoneL = "";
        let DepartL = "";
        let userTypeL = "";
        let userRoleL = "";
        let HideuseridL = "";
        let EmailAddL = "";
        let Site = "";
        let SelectedUserIdL = "";
        let ActiveStatus = "";
        let MultiSiteEnableL = "";
        let GroupIdL = "";
        let GroupTable = [];
        let SiteList = [];
        let MultiSiteList = [];
        let ManuallyAddUserIdL = "";
        let MultiSiteChecked = [];
        let searchUserL = [];
        let DepartmentL = [];
        let UserDetails = [];
        let ThirdPartyListL = [];
        let VendorIdL = "";
        let VendorGroupL = "";
        let selectedOptionL = [];
        let SiteValue = "";
        let Departvalue = "";
        let SiteTitle = "";
        let btnActivateAccount = "";
        let btnInactivateAccount = "";
        let btnEmplInactivateAccount = "";
        let btnEmplActivateAccount = "";
        let ShowEmplLabel = "";
        let ShowAcctLabel = "";
        let SelectedThirdPartyL = "";
        let EmployeeActiveStatus = "";
        let ShowEmplyActiveLabel = false
        let ShowActiveLabel = false
        let HomeStore = ""
        //let ManagerList = ""
        //let EmployeeDD=""
        UserDetails = PageloadDetails.UserProfileDeatils;
        if (UserDetails.length > 0) {
            SelectedUserIdL = UserDetails[0].Employee_ID;
            SelectedThirdPartyL = UserDetails[0].ThirdParty_Id
            userTypeL = UserDetails[0].UserType;
            userRoleL = UserDetails[0].UserRole;
            FirstNameL = UserDetails[0].First_Name;
            lastNameL = UserDetails[0].Last_Name;
            PhoneL = UserDetails[0].Phone_No;
            EmailAddL = UserDetails[0].Email_Address;
            DepartL = UserDetails[0].Departement;
            HideuseridL = UserDetails[0].Hide_User_ID;
            ActiveStatus = UserDetails[0].active_status;
            EmployeeActiveStatus = UserDetails[0].Employee_active_status;
            Site = UserDetails[0].Businees_Unit;
            MultiSiteEnableL = UserDetails[0].Enable_MultiSite;
            VendorIdL = UserDetails[0].MainvndrID;
            btnActivateAccount = UserDetails[0].btnActivateAccount;
            btnInactivateAccount = UserDetails[0].btnInactivateAccount;
            btnEmplInactivateAccount = UserDetails[0].btnEmplInactivateAccount;
            btnEmplActivateAccount = UserDetails[0].btnEmplActivateAccount;
            ShowEmplLabel = UserDetails[0].lblEmplAccountDisabled;
            ShowAcctLabel = UserDetails[0].lblAccountDisabled;
            ShowEmplyActiveLabel = UserDetails[0].lblEmplAccountVisible;
            ShowActiveLabel = UserDetails[0].lblAccountVisible;
            VendorGroupL = UserDetails[0]['Vendor Name'];
            ThirdPartyListL = PageloadDetails.ThirdPartytable;
            searchUserL = PageloadDetails.SearchUsertable;
            SiteList = PageloadDetails.SisterSiteTable;
            MultiSiteList = PageloadDetails.Multisite;
            MultiSiteChecked = PageloadDetails.MultiSite_Checked;
            DepartmentL = PageloadDetails.DepartmentTable;
            GroupTable = PageloadDetails.GroupTable;
            ManuallyAddUserIdL = PageloadDetails.AddUserFlag[0].AUTO_ASSIGN_FLG;
            /*[07/19/22, PC_WW-448_04], Priyanka D */
            // Default_HomeStore = PageloadDetails.AddUserFlag[0].HOME_STORE;
            CookieService.updateLocalStorageValues("HOME_STORE", PageloadDetails.AddUserFlag[0].HOME_STORE);
            CookieService.updateLocalStorageValues("Division", UserDetails[0].DIVISION);
            //HomeStore = PageloadDetails.HomeStore;
            //ManagerList = PageloadDetails.ManagerList;
            //EmployeeDD= PageloadDetails.EmpDDTable
            //if (GroupTable.length > 0) {
            SiteTitle = UserDetails[0].txtGroup;
            GroupIdL = UserDetails[0].txtGroupID;
            //}
        }


        if (Site == "I0W01" || userTypeL == "V") {
            $('#MultiDiv').addClass('hide');
        } else {
            $('#MultiDiv').removeClass('hide');
        }
        console.log("SiteTitle", SiteTitle)
        let SDIEMp = false
        let CustomerL = false
        let vendor = false
        if (VendorIdL == null) {
            VendorIdL = ""
        }
        if (GroupTable != null && GroupTable != undefined) {
            if (GroupTable.length > 0) {
                GroupIdL = GroupTable[0].txtGroupID
            }
        }
        let Hidetab = []
        Hidetab = PageloadDetails.HideTabList
        if (Hidetab[0].APPTab.toUpperCase() == "TRUE") {
            $('#approvalsTab').addClass('hide');
        }
        if (Hidetab[0].OSETab.toUpperCase() == "TRUE") {
            $('#orderSETab').addClass('hide');
        }
        if (Hidetab[0].PREFTab.toUpperCase() == "TRUE") {
            $('#preferencesTab').addClass('hide');
        }
        if (Hidetab[0].SDITrackTab.toUpperCase() == "TRUE") {
            $('#sditrackTab').addClass('hide');
        }
        if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
            $('#mobilityTab').addClass('hide');
        }
        //WW-1229 Home tiles -Nandhini L
        {/* if (Hidetab[0].UPVLTab.toUpperCase() == "TRUE") {
            $('#privilegesTab').addClass('hide');
        } */}
        if (Hidetab[0].ZeusTab.toUpperCase() == "TRUE") {
            $('#zeusTab').addClass('hide');
        }

        let conditionvalue = "false"
        if (btnEmplActivateAccount.toUpperCase() == conditionvalue.toUpperCase() && btnEmplInactivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
            $('#EmpyAcctBtn').addClass('hide');
        }
        else {
            if (userRoleL !== "USER" && userTypeL !== "S") {
                if (btnEmplActivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
                    document.getElementById("EmpyAcctBtn").innerText = "In-Activate Employee Account"
                }
                else {
                    document.getElementById("EmpyAcctBtn").innerText = "Activate Employee Account"
                }
            } else {
                $('#EmpyAcctBtn').addClass('hide');
            }
        }
        if (btnActivateAccount.toUpperCase() == conditionvalue.toUpperCase() && btnInactivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
            $('#AcctBtn').addClass('hide');
        }
        else {
            if (btnActivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
                document.getElementById("AcctBtn").innerText = "In-Activate Account"
            }
            else {
                document.getElementById("AcctBtn").innerText = "Activate Account"
            }
        }
        if (ShowActiveLabel.toUpperCase() == conditionvalue.toUpperCase()) {
            $('#AcctLabel').addClass('hide');
        }
        else {
            document.getElementById("AcctLabel").innerText = ShowAcctLabel;
        }
        if (ShowEmplyActiveLabel.toUpperCase() == conditionvalue.toUpperCase()) {
            $('#EmpLabel').addClass('hide');
        }
        else {
            document.getElementById("EmpLabel").innerText = ShowEmplLabel;
        }
        MultiSiteCHeckB = MultiSiteEnableL.toUpperCase() == "Y" || MultiSiteEnableL.toLowerCase() == "y" ? true : false
        $('#PassDiv').addClass('hide');
        $('#ConfPassDiv').addClass('hide');
        $('#EditMode').addClass('hide');
        if (MultiSiteEnableL.toUpperCase() == "Y" || MultiSiteEnableL.toLowerCase() == "y") {
            //document.getElementById("customCheck7").checked = true;
            MultiSiteCHeckB = true
        }
        else {
            $('#MultiSelectDD').addClass('hide');
            MultiSiteEnableL = "N"
        }
        if (userTypeL != "S") {
            $('#DepartDiv').addClass('hide');
            $('#UserTypeDiv').addClass('hide');
        }
        if (userTypeL != "V") {
            $('#VendorDiv').addClass('hide');
        }
        if (userTypeL == "S") {
            SDIEMp = true
            CustomerL = false
            vendor = false

            // document.getElementById("UtypeSDI").checked = true;
        }
        else if (userTypeL == "C") {
            CustomerL = true
            vendor = false
            SDIEMp = false
            //document.getElementById("UtypeCustomer").checked = true;
        }
        else {
            vendor = true
            CustomerL = false
            SDIEMp = false
            //document.getElementById("UtypeVendor").checked = true;
        }

        if (userRoleL != null) {
            if (userRoleL.toLowerCase() == "user" || userRoleL.toUpperCase() == "USER") {
                $('#AddUserBtn').addClass('hide');
                $('#SearchDIv').addClass('hide');
            }
            if (userRoleL.toLowerCase() != "super") {
                $('#UserTypeDiv').addClass('hide');
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let SearchDDlist = [];
        searchUserL.map((val, index) => {

            let localArray = {
                value: val.ISA_EMPLOYEE_ID,
                label: val.USERANDBU
            }
            if (val.ISA_EMPLOYEE_ID == SelectedUserIdL) {
                selectedOptionL.push(localArray)
            }
            SearchDDlist.push(localArray)
        });

        //let employidDrop = PageloadDetails.EmployeeCC
        ////employidDrop.push(Loginempolyeeid)
        //let employidDropDown = employidDrop.filter((v, i, a) => a.findIndex(t => (t.EMP_ID.trim().toUpperCase() === v.EMP_ID.trim().toUpperCase())) === i)
        //let EmployeeDDlist = []
        //if (employidDropDown != null && employidDropDown != undefined) {
        //    /*[04/07/22WW-243] Regression bug-Cannot able to add an item from quick item entryPriyanka D */
        //    let EmployeeID = (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"))
        //    EmployeeDDlist = employidDropDown.filter((iresult, idx) => iresult.EMP_ID.toUpperCase() == EmployeeID.toUpperCase())
        //}
        //this.EmployeeDD(employidDropDown);



        let SiteListDD = []
        console.log("Site", Site)
        SiteList.map((val, index) => {

            let localArray = {
                value: val.GROUPID,
                label: val.GROUPNAME
            }
            if (val.GROUPID == Site) {
                SiteValue = localArray
            }
            if (val.GROUPID != undefined && val.GROUPNAME != undefined) {
                SiteListDD.push(localArray)
            }
        });
        if (SiteListDD.length == 0) {
            SiteList.map((val, index) => {

                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCRIPTION
                }
                if (val.BUSINESS_UNIT == Site) {
                    SiteValue = localArray
                }
                SiteListDD.push(localArray)
            });
        }
        let DepartmentLocal = []
        DepartmentL.map((val, index) => {
            if (index == 0) {
                let localArray1 = {
                    value: "",
                    label: "-----Select Department-----"
                }
                DepartmentLocal.push(localArray1)
                if (val.DEPT_ID != DepartL) {
                    Departvalue = localArray1
                }
            }
            let localArray = {
                value: val.DEPT_ID,
                label: val.DEPT_NAME
            }
            if (val.DEPT_ID == DepartL) {
                Departvalue = localArray
            }
            DepartmentLocal.push(localArray)
        });



        let Usertypes = []
        if (userRoleL.toUpperCase() == "CORPADMIN") {
            userRoleL = "CORP ADMIN"
            $('#MultiDiv').addClass('hide');
        }
        if (userRoleL.toUpperCase() == "SUPER" || userRoleL.toUpperCase() == "CORP ADMIN") {
            Usertypes = [{ Role: "Super" }, { Role: "Corp Admin" }, { Role: "Admin" }, { Role: "User" }]
        }
        else if (userRoleL.toUpperCase() == "ADMIN" && userTypeL == "S") {
            Usertypes = [{ Role: "Corp Admin" }, { Role: "Admin" }, { Role: "User" }]
        }
        else {
            Usertypes = [{ Role: "Admin" }, { Role: "User" }]
        }
        let UserROleLocal = [];
        let UserRoleSelect = {};
        if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") == "0" || CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") == null) {
            //debugger
            if (ThirdPartyListL.length > 0 && userTypeL == "C") {

                ThirdPartyListL.map((ThirdParty, index1) => {

                    if (index1 == 0) {
                        Usertypes.map((val, index2) => {
                            let localArray = {
                                value: val.Role,
                                label: val.Role,
                                key: Site,
                                Role: val.Role,
                                Third: "0",
                            }
                            if (userTypeL == "S" && val.Role != "Corp Admin") {
                                UserROleLocal.push(localArray)
                            }
                            if (userTypeL == "C" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (userTypeL == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            //debugger;
                            if (val.Role.toUpperCase() == userRoleL.toUpperCase()) {
                                UserRoleSelect = localArray
                            }
                        });
                    }
                    Usertypes.map((val, index3) => {

                        let localArray = {
                            value: ThirdParty.COMPANY_NAME + "  " + val.Role,
                            label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                            key: Site,
                            Role: val.Role,
                            Third: ThirdParty.THIRDPARTY_COMP_ID,
                        }
                        if (userTypeL == "S" && val.Role != "Corp Admin" && val.Role != "Super") {
                            UserROleLocal.push(localArray)
                        }
                        if (userTypeL == "C" && val.Role != "Super" && val.Role != "Corp Admin") {
                            UserROleLocal.push(localArray)
                        }
                        if (userTypeL == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                            UserRoleSelect = localArray
                        }
                    });
                });
            }
            else {
                Usertypes.map((val, index2) => {

                    let localArray = {
                        value: val.Role,
                        label: val.Role,
                        key: Site,
                        Role: val.Role,
                        Third: "0",
                    }
                    if (userTypeL == "S" && val.Role != "Corp Admin") {
                        UserROleLocal.push(localArray)
                    }
                    if (userTypeL == "C" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (userTypeL == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (val.Role.toUpperCase() == userRoleL) {
                        UserRoleSelect = localArray
                    }
                });
            }
        }
        else {
            let childItems = ThirdPartyListL.filter((item, index) => item.THIRDPARTY_COMP_ID == CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"));
            childItems.map((ThirdParty, index1) => {

                Usertypes.map((val, index2) => {

                    let localArray = {
                        value: ThirdParty.COMPANY_NAME + "  " + val.Role,
                        label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                        key: Site,
                        Role: val.Role,
                        Third: ThirdParty.THIRDPARTY_COMP_ID,
                    }
                    if (userTypeL == "S" && val.Role != "Corp Admin") {
                        UserROleLocal.push(localArray)
                    }
                    if (userTypeL == "C" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (userTypeL == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (val.Role.toUpperCase() == userRoleL) {
                        UserRoleSelect = localArray
                    }
                });
            });
        }
        let MultiSlectList = []
        MultiSiteList.map((val, index) => {
            if (val.BUSINESS_UNIT == Site) {
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCRIPTION,
                    disabled: true
                }
                SiteTitle = val.DESCRIPTION;
                MultiSlectList.push(localArray)
            }
            else {
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCRIPTION
                }
                MultiSlectList.push(localArray)
            }
        });
        let MultiSelectValue = []
        MultiSiteChecked.map((val, index) => {
            let ChildSiteValue = MultiSiteList.filter((item, index) => item.BUSINESS_UNIT == val.BUSINESS_UNIT);

            let localArray = {
                value: ChildSiteValue[0].BUSINESS_UNIT,
                label: ChildSiteValue[0].DESCRIPTION
            }
            MultiSelectValue.push(localArray)

        });
        let DisableTypeDDL = false
        console.log("userRoleL", userRoleL);
        if (userRoleL.toUpperCase() == "USER") {
            DisableTypeDDL = true
        }
        else if (userRoleL.toUpperCase() == "ADMIN" && userTypeL == "S") {
            DisableTypeDDL = true
        }
        console.log("MultiSlectList", MultiSlectList)
        console.log("MultiSlectList", UserRoleSelect)
        console.log("Site", SiteTitle)
        console.log("Site", SiteValue)
        console.log("Site", SiteListDD)
        if (SiteTitle == null) {
            SiteTitle = ""
        }/******NEW*(User Profile Settings Adjustable)wal-158****/
        PhoneL = PhoneL.replaceAll("-", "");
        console.log("PhoneL", PhoneL);
        /************END********/
        //if (PhoneL == "") {

        //    document.getElementById("ErrorMagPhone").innerHTML = "Please enter phone Number";
        //}
        this.setState({
            SelectedUserId: SelectedUserIdL, selectedOption: selectedOptionL, FirstName: FirstNameL, LastName: lastNameL, PhoneNum: PhoneL, EmailAddres: EmailAddL, MultiSiteEnable: MultiSiteEnableL, MultiSiteExist: MultiSiteEnableL,
            VendorGroup: VendorGroupL, VendorId: VendorIdL, SelectSite: SiteValue, UserType: userTypeL, UserRole: userRoleL, DepartMent: Departvalue, LoginHideuserId: HideuseridL, HideuserId: HideuseridL,
            UserActiveStatus: ActiveStatus, EmployeeAccountActiveStatus: EmployeeActiveStatus, SearchUser: SearchDDlist, MultiSite: MultiSlectList, MultiSiteSelected: MultiSelectValue, Depart: DepartmentLocal, SiteList: SiteListDD,
            ThirdPartyList: ThirdPartyListL, SelectUserRole: UserRoleSelect, UserRoleDD: UserROleLocal, SiteTitleValue: SiteTitle, selectSiteID: Site, LoginUserRole: userRoleL, LoginUserType: userTypeL,
            SelectUsertype: userTypeL, ManuallyAddUserId: ManuallyAddUserIdL, SelectedThirdParty: SelectedThirdPartyL, MultiSiteChecked: MultiSiteCHeckB, GroupID: GroupIdL,
            SDIEMp: SDIEMp, vendor: vendor, Customer: CustomerL, DisableTypeDD: DisableTypeDDL, PageLoadSiteList: SiteList,// ManagerList: ManagerList
        })
        console.log("Role", this.state.SelectUserRole)

    }
    /*
     * Ref no:UP_PC_44 && UP_PC_45
     * This method is invoked when the tab is click.
     * Api call is method by using the action GetTabBasedDetails() to fetch the data with respect to the tab name.
     * */
    //PC_1044_153 WW-1044 Approval Issue [07/05/2024] Pavithra R
    TabClick = (TabName) => {
        if (TabName == "APP") {
            // document.getElementById("customCheckk").checked = false
            if (document.getElementById("customCheckk")) {
                document.getElementById("customCheckk").checked = false;
            }
            let n = ['BudReq', 'AltReq', 'AltBud'];
            let len = 2
            while (len != -1) {
                let accElement = document.getElementById(`arrow-${n[len]}`);
                let classTest = accElement.classList.contains("accordion-arrow-change");
                if (classTest) {
                    $(`#arrow-${n[len]}`).toggleClass('accordion-arrow-change');
                    $(`#contentrow-${n[len]}`).addClass('d-none');
                }
                len--;
            }

        }
        if (TabName == "UD") { document.getElementById('StatusMsg').innerText = ""; }
        else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            let loginuserrole = this.state.LoginUserRole.toUpperCase()
            let userrole = this.state.UserRole.toUpperCase()
            let SiteValue = ""
            SiteValue = this.state.selectSiteID
            if (this.state.SiteList.length > 0) {
                SiteValue = this.state.SelectSite.value
            }
            else {
                SiteValue = this.state.GroupID
            }
            if (loginuserrole == "CORP ADMIN") {
                loginuserrole = "CORPADMIN"
            }
            if (userrole == "CORP ADMIN") {
                userrole = "CORPADMIN"
            }
            approvalAccordian = (loginuserrole == "SUPER" || loginuserrole == "ADMIN") ? 1 : 2;
            let TabclickBo = {
                TabName: TabName,
                UserId: this.state.SelectedUserId == "" || this.state.SelectedUserId == null ? this.state.Login_UserId : this.state.SelectedUserId,
                Page_Action: "EDIT",
                Session_USERTYPE: loginuserrole,
                Query_IsMexicoVendor: false,
                Session_ThirdParty_CompanyID: (this.state.SelectedThirdParty == "0" || this.state.SelectedThirdParty == null || this.state.SelectedThirdParty == "" || this.state.SelectedThirdParty == " " ? "0" : this.state.SelectedThirdParty),
                Session_UserRole: this.state.LoginUserType.toUpperCase(),
                Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_UserId: this.state.Login_UserId,
                Query_IsVendor: false,
                SiteValue: SiteValue,
                UserType: this.state.UserType.toUpperCase(),
                UserRole: userrole,
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            }
            TabclickTitle = TabName;
            ProfileAction.GetTabBasedDetails(TabclickBo)
            //WW-1229 Home tiles -Nandhini L
            this.setState({ RoleExist: "", isExpandAll: true, selectDisplay: true, tabrole: this.state.LoginUserRole.toUpperCase(), tabtype: this.state.LoginUserType.toUpperCase() });
        }
    }

    /*[07/19/22, PC_WW-448_06], Priyanka D */
    BuildTabClick = () => {
        const { t } = this.props;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Tabdetails = JSON.parse(ProfileStore.TabClickBO);
        console.log("Tabdetails", Tabdetails);
        document.getElementById('StatusMsg').innerText = ""
        switch (TabclickTitle) {
            case "UPVL": {
                let ProgramTree = [];
                let AlacartTree = [];
                let ROleBasedTree = [];
                let ROleList = [];
                let EXistrole = [];
                let SiteList = [];
                let Disrole = false
                let Tab2SiteTitleL = ""
                //WW-1229 Home tiles -Nandhini L
                let UserHomeTilesList = []
                let UserTiles = []
                let TilesList = []
                ProgramTree = Tabdetails.ProgramsList;
                AlacartTree = Tabdetails.AlacartProgramTable;
                ROleBasedTree = Tabdetails.RoleProgramTable;
                ROleList = Tabdetails.RoleDDList;
                EXistrole = Tabdetails.UserRoleExist;
                SiteList = Tabdetails.SisterSiteList;
                let flagOptions = Tabdetails.flagOptions && Tabdetails.flagOptions.length > 0 ? Tabdetails.flagOptions : [];
                let flagValues = Tabdetails.flagValues && Tabdetails.flagValues.length > 0 ? Tabdetails.flagValues : [];;
                //WW-1229 Home tiles -Nandhini L
                if (Tabdetails.UserHomeTilesList != undefined && Tabdetails.UserHomeTilesList != null && Tabdetails.UserHomeTilesList != []) {
                    UserHomeTilesList = Tabdetails.UserHomeTilesList
                }
                if (Tabdetails.UserTilesList != undefined && Tabdetails.UserTilesList != null && Tabdetails.UserTilesList != []) {
                    UserTiles = Tabdetails.UserTilesList
                }
                if (Tabdetails.TilesList != undefined && Tabdetails.TilesList != null && Tabdetails.TilesList != []) {
                    TilesList = Tabdetails.TilesList
                }

                let SiteValue = []
                let SiteListDD = []
                if (SiteList != null && SiteList != undefined) {
                    if (SiteList.length > 0) {
                        SiteList.map((val, index) => {
                            let localArray = {
                                value: val.GROUPID,
                                label: val.GROUPNAME
                            }
                            if (val.GROUPID == this.state.selectSiteID) {
                                SiteValue = localArray
                                Tab2SiteTitleL = val.GROUPNAME
                            }
                            SiteListDD.push(localArray)
                        });
                        if (SiteListDD != null && SiteListDD != undefined) {
                            if (SiteListDD.length > 0) {
                                if (SiteListDD[0].value == undefined) {
                                    SiteListDD = []
                                    SiteList.map((val, index) => {
                                        let localArray = {
                                            value: val.BUSINESS_UNIT,
                                            label: val.DESCRIPTION
                                        }
                                        if (val.BUSINESS_UNIT == this.state.selectSiteID) {
                                            SiteValue = localArray
                                            Tab2SiteTitleL = val.DESCRIPTION
                                        }
                                        SiteListDD.push(localArray)
                                    });
                                }
                            }
                        }
                    }
                }
                let RoleValue = ""
                let RoleListDD = []
                let checkvalues = []
                let PrivTreeDisableL = false
                let TreeValueList = [];

                if ((this.state.LoginUserType.toUpperCase() != "C" && this.state.tabrole.toUpperCase() != "USER") || this.state.tabrole.toUpperCase() != "USER") {
                    if (ROleList != null && ROleList != undefined && ROleList != []) {
                        ROleList.forEach((val, index) => {
                            let localArray = {
                                value: val.ROLENUM,
                                label: val.ROLENAME
                            }
                            if (EXistrole != undefined) {
                                if (EXistrole.length > 0) {
                                    if (val.ROLENUM == EXistrole[0].RoleId) {
                                        RoleValue = localArray
                                    }
                                }
                            }

                            RoleListDD.push(localArray)
                        });
                    }
                    if (ProgramTree != null && ProgramTree != undefined && ProgramTree != []) {
                        //WW-703 Menu Revamping-Deepthi N H
                        ProgramTree = ProgramTree.filter((x) => x.ISA_IDENTIFIER != 1 && x.ISA_IDENTIFIER != 156 && x.ISA_IDENTIFIER != 319 && x.ISA_IDENTIFIER != 320);
                        let CatTreeWithChild = ProgramTree.filter((x) => x.ISA_CATEGORY_ID != null && x.ISA_CATEGORY_ID != "");
                        let WithoutCategory = ProgramTree.filter((x) => x.ISA_CATEGORY_ID == null || x.ISA_CATEGORY_ID == "");
                        CatTreeWithChild = CatTreeWithChild.filter((v, i, a) => a.findIndex(t => (t.ISA_CATEGORY_ID === v.ISA_CATEGORY_ID)) === i);
                        if (CatTreeWithChild.length > 0) {
                            CatTreeWithChild.forEach((catVal, catInd) => {
                                let ParentTree = [];
                                let ParentValue = [];
                                let ParentWithChild = [];
                                let WithoutParent = [];
                                ParentTree = ProgramTree.filter((x) => x.ISA_CATEGORY_ID == catVal.ISA_CATEGORY_ID);
                                WithoutParent = ParentTree.filter((x) => x.ISA_PARENT_IDENT == null || x.ISA_PARENT_IDENT == "");
                                ParentWithChild = ParentTree.filter((x) => x.ISA_PARENT_IDENT != null && x.ISA_PARENT_IDENT != "");
                                ParentWithChild = ParentWithChild.filter((v, i, a) => a.findIndex(t => (t.ISA_PARENT_IDENT === v.ISA_PARENT_IDENT)) === i);
                                if (ParentWithChild.length > 0) {
                                    ParentWithChild.forEach((parentVal, parentInd) => {
                                        let ChildTree = [];
                                        let ChildValue = [];
                                        ChildTree = ProgramTree.filter((x) => x.ISA_PARENT_IDENT == parentVal.ISA_PARENT_IDENT);
                                        if (ChildTree.length > 0) {
                                            ChildTree.forEach((childVal, childInd) => {
                                                let localArray;
                                                if (childVal.ACTIVE == 1) {
                                                    //Zeus 243 - Program Master Panel - Deepthi N H
                                                    if (childVal.SITE_NAME.includes("M") && !childVal.SITE_NAME.includes("W")) {
                                                        localArray = {
                                                            value: childVal.SECURITYALIAS,
                                                            label: childVal.ISA_IDENTIFIER_NAME + "(Only in Mobile)",
                                                            key: childVal.ISA_IDENTIFIER,
                                                            Parent: childVal.ISA_PARENT_IDENT
                                                        };
                                                    }
                                                    else {
                                                        localArray = {
                                                            value: childVal.SECURITYALIAS,
                                                            label: childVal.ISA_IDENTIFIER_NAME,
                                                            key: childVal.ISA_IDENTIFIER,
                                                            Parent: childVal.ISA_PARENT_IDENT
                                                        };
                                                    }

                                                    ChildValue.push(localArray);
                                                }
                                                else {
                                                    localArray = {
                                                        value: childVal.SECURITYALIAS,
                                                        label: childVal.ISA_IDENTIFIER_NAME,
                                                        key: childVal.ISA_IDENTIFIER,
                                                        //disabled: true,
                                                        className: 'disabled-child',
                                                        showCheckbox: false,
                                                        Parent: childVal.ISA_PARENT_IDENT
                                                    };
                                                    ChildValue.push(localArray);
                                                }
                                            });
                                        }

                                        let parentLocObj = {
                                            value: parentVal.PARENTSECALIAS,
                                            label: parentVal.ISA_PARENT_NAME + "(" + parentVal.PARENTSECALIAS + ")",
                                            children: ChildValue,
                                            key: parentVal.ISA_PARENT_IDENT,
                                            Parent: parentVal.ISA_CATEGORY_ID
                                        }
                                        ParentValue.push(parentLocObj);
                                    });
                                }
                                if (WithoutParent.length > 0) {
                                    WithoutParent.forEach((parentVal, parentInd) => {
                                        let parentLocObj
                                        //Zeus 243 - Program Master Panel - Deepthi N H
                                        if (parentVal.SITE_NAME.includes("M") && !parentVal.SITE_NAME.includes("W")) {
                                            parentLocObj = {
                                                value: parentVal.SECURITYALIAS,
                                                label: parentVal.ISA_IDENTIFIER_NAME + "(Only in Mobile)",
                                                children: "0",
                                                key: parentVal.ISA_IDENTIFIER,
                                                Parent: parentVal.ISA_CATEGORY_ID
                                            }
                                        }
                                        else {
                                            parentLocObj = {
                                                value: parentVal.SECURITYALIAS,
                                                label: parentVal.ISA_IDENTIFIER_NAME,
                                                children: "0",
                                                key: parentVal.ISA_IDENTIFIER,
                                                Parent: parentVal.ISA_CATEGORY_ID
                                            }
                                        }
                                        ParentValue.push(parentLocObj);
                                    });
                                };
                                let catLocObj = {
                                    value: catVal.CATSECALIAS,
                                    label: catVal.ISA_CATEGORY_NAME + "(" + catVal.CATSECALIAS + ")",
                                    children: ParentValue,
                                    key: catVal.ISA_CATEGORY_ID,
                                    Parent: "0"
                                }
                                TreeValueList.push(catLocObj);
                            });
                        }
                        if (WithoutCategory.length > 0) {
                            WithoutCategory.forEach((catVal, catInd) => {
                                let catLocObj;
                                if (catVal.ACTIVE == 1) {
                                    //Zeus 243 - Program Master Panel - Deepthi N H
                                    if (catVal.SITE_NAME.includes("M") && !catVal.SITE_NAME.includes("W")) {
                                        catLocObj = {
                                            value: catVal.SECURITYALIAS,
                                            label: catVal.ISA_IDENTIFIER_NAME + "(Only in Mobile)",
                                            children: "0",
                                            key: catVal.ISA_IDENTIFIER,
                                            Parent: "0"
                                        }
                                    }
                                    else {
                                        catLocObj = {
                                            value: catVal.SECURITYALIAS,
                                            label: catVal.ISA_IDENTIFIER_NAME,
                                            children: "0",
                                            key: catVal.ISA_IDENTIFIER,
                                            Parent: "0"
                                        }
                                    }

                                    TreeValueList.push(catLocObj);
                                }
                                else {
                                    catLocObj = {
                                        value: catVal.SECURITYALIAS,
                                        label: catVal.ISA_IDENTIFIER_NAME,
                                        children: "0",
                                        key: catVal.ISA_IDENTIFIER,
                                        Parent: "0"
                                    }
                                    TreeValueList.push(catLocObj);
                                }
                            })
                        }
                    }
                    if (EXistrole != undefined) {
                        if (EXistrole.length > 0 && EXistrole[0].RoleId != null) {
                            if (ROleBasedTree.length > 0) {
                                ROleBasedTree.forEach((val, index) => {
                                    checkvalues.push(val.ALIAS_NAME)
                                });
                            }
                            document.getElementById("Role").checked = true;
                            PrivTreeDisableL = true
                            SelectAll = false
                        }
                        else {
                            if (AlacartTree.length > 0) {
                                AlacartTree.forEach((val, index) => {
                                    checkvalues.push(val.SECURITYALIAS)
                                    Disrole = true
                                });

                            }
                            //5724 - selectall state will be updated once alacartree length is 1 [4/21/2025] Nachiappan
                            if (AlacartTree.length == 1) {
                                this.setState({ isSelectAll: true })
                            }
                            if (AlacartTree.length > 1) {
                                this.setState({ isSelectAll: false })
                            }
                            document.getElementById("Alacart").checked = true;
                            $('#PriviRoleDD').attr("disabled", true)
                        }
                    }
                }
                //WW-1229 Home tiles -Nandhini L
                let homeTilesChecked = [];
                if (UserTiles && UserTiles.length > 0) {
                    UserTiles.forEach(item => {
                        homeTilesChecked.push(item.SECURITYALIAS);
                    });
                }
                let userHomeTilesMap = new Map(UserHomeTilesList.map(tile => [tile.SECURITYALIAS, tile]));

                TilesList.forEach(tile => {
                    if (tile.DEFAULT_TILE === 'Y' && !userHomeTilesMap.has(tile.SECURITYALIAS)) {
                        UserHomeTilesList.push(tile);
                        userHomeTilesMap.set(tile.SECURITYALIAS, tile);
                    }
                });

                UserHomeTilesList.forEach(tile => {
                    tile.tilePrivCheck = homeTilesChecked.includes(tile.SECURITYALIAS);
                });

                this.setState({ UserHomeTilesList: UserHomeTilesList, TilesList: TilesList });

                $('#PrivTypeDIv').removeClass('hide');
                $('#PrivtopButton').removeClass('hide');
                $('#PrivProgramTree').removeClass('hide');
                $('#PrivProgramTitle').removeClass('hide');
                $('#CollapseALL').removeClass('hide');
                $('#ExpandALL').removeClass('hide');
                //WW-1229 Home tiles -Nandhini L
                $('#PrivRoleTypeDD').removeClass('hide');
                $('#PrefFlagsDD').removeClass('hide');

                if (this.state.LoginUserRole.toUpperCase() == "CORP ADMIN") {
                    $('#PrivTypeDIv').addClass('hide');
                    $('#PrivtopButton').addClass('hide');
                    $('#PrivProgramTree').addClass('hide');
                    $('#PrivProgramTitle').addClass('hide');
                    $('#privsavecandiv').addClass('hide');
                    $('#ProgramleftId').addClass('hide');
                    this.setState({ onlyHomeTile: "true" })
                }
                //WW-1229 Home tiles -Nandhini L
                else if ((this.state.LoginUserType.toUpperCase() == "C" && this.state.tabrole.toUpperCase() == "USER") || this.state.tabrole.toUpperCase() == "USER") {
                    $('#PrivTypeDIv').addClass('hide');
                    $('#PrivtopButton').addClass('hide');
                    $('#PrivProgramTree').addClass('hide');
                    $('#PrivProgramTitle').addClass('hide');
                    $('#privsavecandiv').addClass('hide');
                    $('#CollapseALL').addClass('hide');
                    $('#ExpandALL').addClass('hide');
                    $('#PrivRoleTypeDD').addClass('hide');
                    $('#PrefFlagsDD').removeClass('hide');
                    $('#ProgramleftId').addClass('hide');
                    this.setState({ onlyHomeTile: "true" })
                }

                if (this.state.UserType == "V") {
                    Tab2SiteTitleL = "SUPPLIER"
                    $('#CollapseALL').addClass('hide');
                    $('#ExpandALL').addClass('hide');
                }
                if (RoleValue == null || RoleValue == undefined || RoleValue == "") {
                    //debugger
                    document.getElementById("Alacart").checked = true;
                    $('#PriviRoleDD').attr("disabled", true);
                    PrivTreeDisableL = false
                    Disrole = true
                    SelectAll = true
                    // $('#SelPrivBtn').removeClass('hide');
                    //  $('#DeSelPrivBtn').removeClass('hide');
                }

                this.setState({
                    Tab2SiteList: SiteListDD, SelectTab2Site: SiteValue, Tab2RoleList: RoleListDD, SelectROleList: RoleValue, Tab2BindTree: TreeValueList,
                    checked: checkvalues, expanded: checkvalues, DisablePrivRole: Disrole, PrivTree: ProgramTree, PrivTreeDisable: PrivTreeDisableL, Tab2SiteTitle: Tab2SiteTitleL,
                    flagOptions: flagOptions, flagValues: flagValues
                })
                break;
            }

            case "APP": {
                let Session_ThirdParty_CompanyID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID");
                if (Session_ThirdParty_CompanyID != null && Session_ThirdParty_CompanyID != undefined) {
                    Session_ThirdParty_CompanyID = Session_ThirdParty_CompanyID
                }

                else {
                    Session_ThirdParty_CompanyID = ""
                }
                if ((this.state.LoginUserRole.toUpperCase() == "SUPER" || this.state.LoginUserRole.toUpperCase() == "ADMIN") && (Session_ThirdParty_CompanyID.trim != "" && Session_ThirdParty_CompanyID <= 99)) {




                    //document.getElementById("ApprLabel").innerText = (t("Budgetary Approval by"))
                    let ApproverList = Tabdetails.BudApproverDD;
                    let ExistApprover = [];
                    ExistApprover = Tabdetails.ExistBudApprover
                    let ApproveValue = []
                    let ExistApp = []
                    let LimitValue = ""

                    let ExistBudApprL = "";
                    $('#budApproval').removeClass('hide');
                    let n = ['BudReq', 'AltReq', 'AltBud'];
                    let len = 2
                    while (len != -1) {
                        let accElement = document.getElementById(`arrow-${n[len]}`);
                        let classTest = accElement.classList.contains("accordion-arrow-change");
                        if (classTest) {
                            $(`#arrow-${n[len]}`).toggleClass('accordion-arrow-change');
                            $(`#contentrow-${n[len]}`).addClass('d-none');
                        }
                        len--;
                    }
                    let BudReqElement = document.getElementById("arrow-BudReq");
                    let classTest = BudReqElement.classList.contains("accordion-arrow-change");
                    if (!classTest) {
                        $('#arrow-BudReq').toggleClass('accordion-arrow-change');
                    }
                    $('#contentrow-BudReq').removeClass('d-none');
                    //approvalAccordian = 1;
                    if (ApproverList != null && ApproverList != undefined) {
                        ApproverList.map((val, index) => {
                            if (index == 0) {
                                let localArray1 = {
                                    value: 0,
                                    label: t("--------Select Approver-------")
                                }
                                ApproveValue.push(localArray1)
                                if (ExistApprover.length == 0 || ApproverList.indexOf(ExistApprover[0].ISA_IOL_APR_EMP_ID) == -1) {
                                    ExistApp = localArray1
                                    $('#removeApprover').addClass('hide');
                                }
                            }
                            let localArray = {
                                value: val.ISA_EMPLOYEE_ID,
                                label: val.EMP_TEXT
                            }
                            if (ExistApprover.length > 0) {
                                if (val.ISA_EMPLOYEE_ID == ExistApprover[0].ISA_IOL_APR_EMP_ID) {
                                    ExistApp = localArray
                                    LimitValue = ExistApprover[0].ISA_IOL_APR_LIMIT
                                    ExistBudApprL = ExistApprover[0].ISA_IOL_APR_EMP_ID
                                    $('#BUdLimitData').val(LimitValue)
                                    //[8/10/22, Bug - 2349, PS_UP_03, Dhevanesam R]
                                    $('#removeApprover').removeClass('hide');
                                }
                            }
                            ApproveValue.push(localArray)
                        });
                    }

                    //PC_1044_153 WW-1044 Approval  [07/05/2024] Pavithra R
                    let user = "";
                    let userLimit = "";
                    let approver = "";
                    let approverLimit = "";
                    let popupFlag = true;
                    if (Tabdetails.ApproverData != null && Tabdetails.ApproverData.length > 0) {
                        user = Tabdetails.ApproverData[0].CURRENTUSER;
                        if (Tabdetails.ApproverData[0].NEXTAPPROVER != null) {
                            approver = Tabdetails.ApproverData[0].NEXTAPPROVER;
                        }
                        else {
                            approver = "-"
                        }
                        userLimit = Tabdetails.ApproverData[0].CURRENTUSERLIMIT;
                        approverLimit = Tabdetails.ApproverData[0].NEXTAPPROVERLIMIT;
                    }
                    else {
                        popupFlag = false;
                    }
                    //document.getElementById('ReqBtn').innerText = (t("Set Requestor Approval"))
                    if (Tabdetails.BudApproverData != null && Tabdetails.BudApproverData.length > 0) {
                        $('#altBudApproval').removeClass('hide');
                    }
                    else {
                        $('#altBudApproval').addClass('hide');
                    }

                    this.setState({
                        ApproverList: ApproveValue, ExistApproveValue: ExistApp, ExistAppLimit: LimitValue, initialBudAppLimit: LimitValue, ExistBudAppr: ExistBudApprL, ApprovLabelVal: "Budgetary Approval by", ApprovBtnTxt: "Set Requestor Approval",
                        CurrentUserName: user, CurrentUserLimit: userLimit, NextApprover: approver, NextApproverLimit: approverLimit, ApproverPopupFlag: popupFlag

                    })
                }
                else {
                    //$('#BudLimitDiv').addClass('hide');
                    //$('#BudBtn').addClass('hide');
                    //document.getElementById("ApprLabel").innerText = (t("Alternate Requestor Approval by"))
                    let ApproverList = Tabdetails.ReqApproverDD;
                    let ExistApprover = [];
                    let ExistReqApprL = "";
                    ExistApprover = Tabdetails.ExistReqApprover
                    let ApproveValue = []
                    let ExistApp = []
                    //PC_1044_153 WW-1044 Approval  [07/05/2024] Pavithra R
                    $('#budApproval').addClass('hide');
                    let n = ['BudReq', 'AltReq', 'AltBud'];
                    let len = 2
                    while (len != -1) {
                        let accElement = document.getElementById(`arrow-${n[len]}`);
                        let classTest = accElement.classList.contains("accordion-arrow-change");
                        if (classTest) {
                            $(`#arrow-${n[len]}`).toggleClass('accordion-arrow-change');
                            $(`#contentrow-${n[len]}`).addClass('d-none');
                        }
                        len--;
                    }
                    let AltReqElement = document.getElementById("arrow-AltReq");
                    let classTest = AltReqElement.classList.contains("accordion-arrow-change");
                    if (!classTest) {
                        $('#arrow-AltReq').toggleClass('accordion-arrow-change');
                    }
                    $('#contentrow-AltReq').removeClass('d-none');
                    //approvalAccordian = 2;
                    if (ApproverList != null && ApproverList != undefined) {
                        ApproverList.map((val, index) => {
                            if (index == 0) {
                                let localArray1 = {
                                    value: 0,
                                    label: t("--------Select Approver-------")
                                }
                                ApproveValue.push(localArray1)
                                if (ExistApprover.length == 0 || ApproverList.indexOf(ExistApprover[0].ISA_REQ_APR_ALT) == -1) {
                                    ExistApp = localArray1
                                    $('#removeApprover').addClass('hide');
                                }
                            }
                            let localArray = {
                                value: val.ISA_EMPLOYEE_ID,
                                label: val.EMP_TEXT
                            }
                            if (ExistApprover.length > 0) {
                                if (val.ISA_EMPLOYEE_ID == ExistApprover[0].ISA_REQ_APR_ALT) {
                                    ExistApp = localArray
                                    ExistReqApprL = ExistApprover[0].ISA_REQ_APR_ALT
                                    //[8/10/22, Bug - 2349, PS_UP_03, Dhevanesam R]
                                    $('#removeApprover').removeClass('hide');
                                }
                            }
                            ApproveValue.push(localArray)
                        });
                    }

                    //PC_1044_153 WW-1044 Approval  [07/05/2024] Pavithra R
                    let user = "";
                    let userLimit = "";
                    let approver = "";
                    let approverLimit = "";
                    let popupFlag = true;
                    if ((Tabdetails.ApproverData != null && Tabdetails.ApproverData.length > 0) && (Session_ThirdParty_CompanyID.trim != "" && Session_ThirdParty_CompanyID <= 99)) {
                        user = Tabdetails.ApproverData[0].CURRENTUSER;
                        if (Tabdetails.ApproverData[0].NEXTAPPROVER != null) {
                            approver = Tabdetails.ApproverData[0].NEXTAPPROVER;
                        }
                        else {
                            approver = "-"
                        }

                        userLimit = Tabdetails.ApproverData[0].CURRENTUSERLIMIT;
                        approverLimit = Tabdetails.ApproverData[0].NEXTAPPROVERLIMIT;
                    }
                    else {
                        popupFlag = false;
                    }

                    if (Tabdetails.BudApproverData != null && Tabdetails.BudApproverData.length > 0) {
                        $('#altBudApproval').removeClass('hide');
                    } else {
                        $('#altBudApproval').addClass('hide');
                    }
                    this.setState({
                        ApproverList: ApproveValue, ExistApproveValue: ExistApp, ExistReqAppr: ExistReqApprL, ApprovLabelVal: "Alternate Requestor Approval by",
                        CurrentUserName: user, CurrentUserLimit: userLimit, NextApprover: approver, NextApproverLimit: approverLimit, ApproverPopupFlag: popupFlag
                    })
                }

                //document.getElementById("approvals-link").classList.remove("d-none");
                break;
            }

                //**************************[7/12/2022] - Bug ID 2340 - Start of commenting budgetary approver DD binding code- Dhamotharan P****************************

                //let ExistApprover = [];
                //ExistApprover = Tabdetails.ExistBudApprover
                //let ApproveValue = []
                //let ExistApp = []
                //let LimitValue = ""

                //let ExistBudApprL = "";
                //if (ApproverList != null && ApproverList != undefined) {
                //    ApproverList.map((val, index) => {
                //        if (index == 0) {
                //            let localArray1 = {
                //                value: 0,
                //                label: "--------Select Approver-------"
                //            }
                //            ApproveValue.push(localArray1)
                //            if (ExistApprover.length == 0) {
                //                ExistApp = localArray1
                //            }
                //        }
                //        let localArray = {
                //            value: val.ISA_EMPLOYEE_ID,
                //            label: val.EMP_TEXT
                //        }
                //        if (ExistApprover.length > 0) {
                //            if (val.ISA_EMPLOYEE_ID == ExistApprover[0].ISA_IOL_APR_EMP_ID) {
                //                ExistApp = localArray
                //                LimitValue = ExistApprover[0].ISA_IOL_APR_LIMIT
                //                ExistBudApprL = ExistApprover[0].ISA_IOL_APR_EMP_ID
                //                $('#BUdLimitData').val(LimitValue)
                //            }
                //        }
                //        ApproveValue.push(localArray)
                //    });
                //}

                //document.getElementById('ReqBtn').innerText = "Set Requestor Approval"
                //$('#BudLimitDiv').removeClass('hide');
                //$('#BudBtn').removeClass('hide');
                //let Buttype = document.getElementById('ReqBtn').innerText
                //if (Buttype == "Set Requestor Approval") {
                //    document.getElementById('ReqBtn').innerText = "Set Budgetary Approval"
                //    $('#BudLimitDiv').addClass('hide');
                //}
                //else {
                //    document.getElementById('ReqBtn').innerText = "Set Requestor Approval"
                //    $('#BudLimitDiv').removeClass('hide');
                //}
                //    this.setState({
                //        ApproverList: ApproveValue, ExistApproveValue: ExistApp, ExistAppLimit: LimitValue, ExistBudAppr: ExistBudApprL
                //    })
                //}
                //else {

                //}

                //**************************[7/12/2022] - Bug ID 2340 - End of commenting budgetary approver DD binding code- Dhamotharan P****************************

                break;

            case "OSE": {
                document.getElementById("chbCRE").checked = false;
                document.getElementById("chbAPR").checked = false;
                document.getElementById("chbDLF").checked = false;
                document.getElementById("chbCNC").checked = false;
                document.getElementById("chbRCP").checked = false;
                document.getElementById("chbRCF").checked = false;
                document.getElementById("chbRFC").checked = false;
                document.getElementById("chbRFR").checked = false;
                document.getElementById("chbRFA").checked = false;
                document.getElementById("chbQTR").checked = false;
                document.getElementById("chbQTA").checked = false;
                document.getElementById("chbVND").checked = false;
                document.getElementById("chbCST").checked = false;
                document.getElementById("chbQTS").checked = false;
                document.getElementById("chbQTC").checked = false;
                document.getElementById("chbQTW").checked = false;
                let HasTable = Tabdetails.Hashtable
                let RoleExist = Tabdetails.ROleExist
                //**********NEW(5/1/2021)REMOVED*****************
                //if (RoleExist[0].ROleExist == "FALSE") {
                //**********END*****************
                //**********NEW(5/1/2021)ADDED*****************
                if (HasTable != null && HasTable != undefined) {
                    //**********END*****************
                    HasTable.map((val, index) => {
                        switch (val.Key) {
                            case "EMAILCRE01": {
                                document.getElementById("chbCRE").checked = true;
                                break;
                            }
                            case "EMAILQTW02": {
                                document.getElementById("chbQTW").checked = true;
                                break;
                            }
                            case "EMAILQTC03": {
                                document.getElementById("chbQTC").checked = true;
                                break;
                            }
                            case "EMAILQTS04": {
                                document.getElementById("chbQTS").checked = true;
                                break;
                            }
                            case "EMAILCST05": {
                                document.getElementById("chbCST").checked = true;
                                break;
                            }
                            case "EMAILVND06": {
                                document.getElementById("chbVND").checked = true;
                                break;
                            }
                            case "EMAILAPR07": {
                                document.getElementById("chbAPR").checked = true;
                                break;
                            }
                            case "EMAILQTA08": {
                                document.getElementById("chbQTA").checked = true;
                                break;
                            }
                            case "EMAILQTR09": {
                                document.getElementById("chbQTR").checked = true;
                                break;
                            }
                            case "EMAILRFA10": {
                                document.getElementById("chbRFA").checked = true;
                                break;
                            }
                            case "EMAILRFR11": {
                                document.getElementById("chbRFR").checked = true;
                                break;
                            }
                            case "EMAILRFC12": {
                                document.getElementById("chbRFC").checked = true;
                                break;
                            }
                            case "EMAILRCF13": {
                                document.getElementById("chbRCF").checked = true;
                                break;
                            }
                            case "EMAILRCP14": {
                                document.getElementById("chbRCP").checked = true;
                                break;
                            }
                            case "EMAILCNC15": {
                                document.getElementById("chbCNC").checked = true;
                                break;
                            }
                            case "EMAILDLF16": {
                                document.getElementById("chbDLF").checked = true;
                                break;
                            }
                        }
                    });
                    //$("#OSESubmitBtn").attr("disabled", "false");
                    //**********NEW(5/1/2021)REMOVED*****************
                    // }

                    //else {
                    //    //$("#OSESubmitBtn").attr("disabled", "true");
                    //    //$('#OSESubmitBtn').add()

                    //    this.setState({ RoleExist: RoleExist[0].ROleExist })
                    //}
                    //************END***********************
                    //**********NEW(5/1/2021)ADDED*****************
                }
                if (RoleExist[0].ROleExist != "FALSE") {
                    //$("#OSESubmitBtn").attr("disabled", "true");
                    //$('#OSESubmitBtn').add()

                    this.setState({ RoleExist: RoleExist[0].ROleExist })
                }
                //************END**********************
                break;
            }
            case "PREF": {
                /*[05/24/22,WW-272_PC-01], Priyanka D */
                let HomeStore = ""
                let ShiptoList = Tabdetails.ShipToTable
                let defaultShip = []
                defaultShip = Tabdetails.Default_ShipTo
                let DepartList = []
                let PrefTable = []
                let DepartDefault = []
                let DepartListvalue = []
                PrefTable = Tabdetails.PreferenceTable
                $('#DepartPrefDiv').removeClass('hide');
                if (this.state.UserType.toUpperCase() == "S") {
                    DepartList = Tabdetails.DepartList
                    if (DepartList != null && DepartList != undefined) {
                        if (DepartList.length > 0) {
                            DepartList.map((val, index) => {
                                if (index == 0) {
                                    let localArray1 = {
                                        value: "",
                                        label: "-----Select Department-----"
                                    }
                                    DepartListvalue.push(localArray1)
                                    if (val.DEPT_ID != PrefTable[0].ISA_DEPT) {
                                        DepartDefault = localArray1
                                    }
                                }
                                let localArray = {
                                    value: val.DEPT_ID,
                                    label: val.DEPT_NAME
                                }
                                if (val.DEPT_ID == PrefTable[0].ISA_DEPT) {
                                    DepartDefault = localArray
                                }
                                DepartListvalue.push(localArray)
                            });
                        }
                    }
                }
                else {
                    $('#DepartPrefDiv').addClass('hide');
                }
                let PerferedHomeStore = {
                    value: "0",
                    label: "-----Select Home Store-----"
                }
                let HomeStoreLocal = []
                let defaultShipto = [];
                let shiptolistValue = [];
                let Manager = [];
                let RegManager = [];
                let Director = [];
                let Senior_Direcor = [];
                if (ShiptoList) {
                    ShiptoList.map((val, index) => {
                        if (index == 0) {
                            let localArray1 = {
                                value: "",
                                label: "-----Select Ship To-----"
                            }
                            shiptolistValue.push(localArray1)
                            if (val.CUSTID != PrefTable[0].SHIPTO_DEFAULT) {
                                defaultShipto = localArray1
                            }
                        }
                        let localArray = {
                            value: val.CUSTID,
                            label: val.LOCNAME
                        }
                        if (val.CUSTID == PrefTable[0].SHIPTO_DEFAULT) {
                            defaultShipto = localArray
                        }
                        shiptolistValue.push(localArray)
                    });

                    //this.state.EmplyeeNameDD.map((val, index) => {
                    //    let localArray = {
                    //        value: val.value,
                    //        label: val.label
                    //    }
                    //    if (val.value == this.state.ManagerList[0].MANAGER_NAME) {
                    //        Manager = localArray
                    //    }
                    //    if (val.value == this.state.ManagerList[0].REGIONAL_MANAGER) {
                    //        RegManager = localArray
                    //    }
                    //    if (val.value == this.state.ManagerList[0].DIRECTOR) {
                    //        Director = localArray
                    //    }
                    //    if (val.value == this.state.ManagerList[0].SR_DIRECTOR) {
                    //        Senior_Direcor = localArray
                    //    }


                    //});
                    let DefaultHomeStore = shiptolistValue.filter((x) => x.value == CookieService.getLocalStorageValues("HOME_STORE"))//WW-536
                    if (DefaultHomeStore != undefined && DefaultHomeStore != null) {
                        if (DefaultHomeStore[0] != undefined && DefaultHomeStore[0] != null) {
                            /*[05/26/22,WW-404],Every user should see the default shipto field Priyanka D */
                            if (DefaultHomeStore[0].value != '') {
                                HomeStore = DefaultHomeStore[0].label
                            } else {
                                HomeStore = ""
                            }
                        } else {
                            HomeStore = ""
                        }
                    }
                    else {
                        HomeStore = ""
                    }


                    ShiptoList.map((val, index) => {
                        if (index == 0) {
                            let localArray1 = {
                                value: "",
                                label: "-----Select Home Store-----"
                            }
                            HomeStoreLocal.push(localArray1)
                        }

                        let localArray = {
                            value: val.CUSTID,
                            label: val.LOCNAME
                        }
                        if (DefaultHomeStore[0] != undefined && DefaultHomeStore[0] != null) {
                            if (val.LOCNAME == DefaultHomeStore[0].label) {
                                PerferedHomeStore = localArray
                            }
                        }

                        HomeStoreLocal.push(localArray)
                    });

                    /*[05/24/22,WW-272_PC-02], Priyanka D */
                    //HomeStore = shiptolistValue.filter((x) => x.value == CookieService.getLocalStorageValues("HOME_STORE"))//WW-536
                    //if (HomeStore != undefined && HomeStore != null) {
                    //    if (HomeStore[0] != undefined && HomeStore[0] != null) {
                    //        /*[05/26/22,WW-404],Every user should see the default shipto field Priyanka D */
                    //        if (HomeStore[0].value != '') {
                    //            HomeStore = HomeStore[0].label
                    //        } else {
                    //            HomeStore = ""
                    //        }
                    //    } else {
                    //        HomeStore = ""
                    //    }
                    //}
                    ///*[05/26/22,WW-404],Every user should see the default shipto field Priyanka D */
                    //else {
                    //    HomeStore = ""
                    //}
                }
                let divisionList = Tabdetails.DivisionTable
                let prefferedDivision = []
                let SelectedDivision = ""
                if (divisionList != null && divisionList != undefined) {
                    divisionList.forEach((val, index) => {
                        if (index == 0) {
                            let localArray1 = {
                                value: "",
                                label: "-----Select Division-----"
                            }
                            prefferedDivision.push(localArray1)

                        }
                        let localArray = {
                            value: val.DIVISION,
                            label: val.DIVISION
                        }
                        prefferedDivision.push(localArray)
                        if (CookieService.getLocalStorageValues("Division") != null && CookieService.getLocalStorageValues("Division") != undefined) {
                            if (val.DIVISION == CookieService.getLocalStorageValues("Division")) {
                                SelectedDivision = localArray

                            }
                        }

                    })
                }
                if (SelectedDivision == "" || SelectedDivision == null || SelectedDivision == undefined) {
                    SelectedDivision = prefferedDivision[0]
                }
                /*[05/24/22,WW-272_PC-03], Priyanka D */
                this.setState({
                    DepartmentPref: DepartDefault, DepartPref: DepartListvalue, ShiptoList: shiptolistValue,
                    Shipto: defaultShipto, HomeStore: HomeStore, HomeStoreDD: HomeStoreLocal, HomeStoreValue: PerferedHomeStore, Senior_Direcor: Senior_Direcor, Manager: Manager, RegManager: RegManager, Director: Director,
                    DivisionDD: prefferedDivision, DivisionValue: SelectedDivision
                })
                if (PrefTable[0].ISA_PROD_DISPLAY != null) {
                    if (PrefTable[0].ISA_PROD_DISPLAY == "P") {
                        document.getElementById("ClientDesp").checked = true;
                        document.getElementById("CataDesp").checked = false;
                    }
                    else {
                        document.getElementById("CataDesp").checked = true;
                        document.getElementById("ClientDesp").checked = false;
                    }
                }
                else {
                    document.getElementById("CataDesp").checked = true;
                    document.getElementById("ClientDesp").checked = false;
                }
                if (PrefTable[0].ISA_PRICE_BLOCK != null && PrefTable[0].ISA_PRICE_BLOCK != "" && PrefTable[0].ISA_PRICE_BLOCK != " " && PrefTable[0].ISA_PRICE_BLOCK != "(null)") {
                    document.getElementById("PriceDisplay").checked = true;
                }

                document.getElementById("PriceDisplay").disabled = false
                if (this.state.LoginUserRole.toUpperCase() != "SUPER") {
                    document.getElementById("PriceDisplay").disabled = true
                }
                break;
            }
            case "MOB": {
                let CribListdata = Tabdetails.GribTable
                let ExistCrib = Tabdetails.GribAlreadyExist
                let DefaultCrib = []
                let CribListValue = []
                document.getElementById('CribValidate').innerText = ""
                CribListdata.map((val, index) => {

                    let localArray = {
                        value: val.BUUNIT,
                        label: val.BUUNIT
                    }
                    if (val.BUUNIT == ExistCrib[0].GribAlreadyExist) {
                        DefaultCrib = localArray
                    }
                    CribListValue.push(localArray)
                });
                this.setState({
                    CribValue: DefaultCrib,
                    CribList: CribListValue
                })
                break;
            }
            case "ZEUS": {
                let ZeusStatus = Tabdetails.ZeusTable
                let ZeusLabel = ZeusStatus[0].Zeus_Disabled != null ? ZeusStatus[0].Zeus_Disabled : ZeusStatus[0].Zeus_Enabled
                this.setState({ ZeusTitle: ZeusLabel })
                break;
            }
            case "TST": {
                let TSTValue = Tabdetails.ADDUserFormTable
                let TSTValueUser = Tabdetails.SDITrackDetails
                let EmployeeList = Tabdetails.EmployeeList
                let EmployeeValue = []
                let EmployeeListData = []
                EmployeeList.map((val, index) => {
                    let localArray = {
                        value: val.ISA_EMPLOYEE_ID,
                        label: val.USERANDBU
                    }
                    if (val.ISA_EMPLOYEE_ID == TSTValue[0].OtherUserID) {
                        EmployeeValue.push(localArray)
                    }
                    EmployeeListData.push(localArray)
                });
                this.setState({
                    TSTEmployeeValue: EmployeeListData,
                    TSTDefaultValue: EmployeeValue
                })
                let TSTUserIDValue = TSTValueUser[0].SDITrack_UserID
                let ErrorMessage = ""
                if (TSTValue[0].OtherUserBUMessage != null || TSTValue[0].OtherUserNoBU != null) {
                    ErrorMessage = TSTValue[0].OtherUserBUMessage != null ? TSTValue[0].OtherUserBUMessage : TSTValue[0].OtherUserNoBU
                    document.getElementById("TSTError").innerText = ErrorMessage;
                    $('#AddTSTUserDiv').addClass('hide');
                    $('#AddUserDiv').addClass('hide');
                }
                document.getElementById("TSTUserName").innerText = TSTValue[0].OtherUserID;
                document.getElementById("TSTUSERID1").innerText = TSTUserIDValue;
                document.getElementById("TSTuserBu").innerText = TSTValue[0].BusinessUnit;
                document.getElementById("TSTCurentUser").innerText = TSTValueUser[0].Current_User;
                document.getElementById("LoginUserId").innerText = TSTValueUser[0].SDITrack_UserID;
                document.getElementById("LoginUserADDOn").innerText = TSTValueUser[0].AddedUserDate;
                document.getElementById("LoginUserGuid").innerText = TSTValueUser[0].AddedUserGUID;
                $('#ADDEDUSERDiv').addClass('hide')
                this.setState({
                    TSTUserID: TSTUserIDValue
                })
                break;
            }
        }
        if (this.props.location.state != null && this.props.location.state != undefined) {
            if (this.props.location.state.origin == 'Inventory') {
                this.props.location.state.origin = ""
            }
            else {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
        }
        else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }

    }
    //WW-1229 Home tiles -Nandhini L
    BindHomeTiles = () => {
        let { UserHomeTilesList } = this.state;

        if (Array.isArray(UserHomeTilesList)) {
            UserHomeTilesList = UserHomeTilesList.sort((a, b) => a.SEQ_ORDER - b.SEQ_ORDER);
        }
        const tileLength = this.state.UserHomeTilesList.length;
        let leftColumnTiles = [];
        let rightColumnTiles = [];
        if (tileLength <= 10) {
            // All tiles on the left if 10 or fewer
            leftColumnTiles = UserHomeTilesList;
            rightColumnTiles = [];
        } else if (tileLength <= 20) {
            // 10 on left, rest on right if between 11 and 20
            leftColumnTiles = UserHomeTilesList.slice(0, 10);
            rightColumnTiles = UserHomeTilesList.slice(10);
        } else {
            // Split evenly if more than 20
            const midPoint = Math.ceil(tileLength / 2);
            leftColumnTiles = UserHomeTilesList.slice(0, midPoint);
            rightColumnTiles = UserHomeTilesList.slice(midPoint);
        }
        return (
            <>
                <div className="col-md-6 px-1">
                    <div className="custom-program-list">
                        {leftColumnTiles.map((tile, index) => (
                            <div key={index} className={`form-check custom-list-item custom-checkbox ${(this.state.UserHomeTilesList.filter(tile => tile.tilePrivCheck == true)).length == 12 && !tile.tilePrivCheck ? 'disabled' : ''}`}>
                                <input
                                    className="custom-control-input"
                                    type="checkbox"
                                    id={tile.ISA_IDENTIFIER_NAME}
                                    checked={tile.tilePrivCheck}
                                    onChange={(e) => this.onClickHomeTiles(e, index)}
                                    disabled={(this.state.UserHomeTilesList.filter(tile => tile.tilePrivCheck == true)).length == 12 && !tile.tilePrivCheck}
                                />
                                <label className="custom-control-label" htmlFor={tile.ISA_IDENTIFIER_NAME}>
                                    {tile.ISA_IDENTIFIER_NAME}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
                {rightColumnTiles.length > 0 ? <>
                    <div className="col-md-6 px-1">
                        <div className="custom-program-list custom-mob-mt">
                            {rightColumnTiles.map((tile, index) => (<>
                                <div key={index + 10} className={`form-check custom-list-item  custom-checkbox ${(this.state.UserHomeTilesList.filter(tile => tile.tilePrivCheck == true)).length == 12 && !tile.tilePrivCheck ? 'disabled' : ''}`}>
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id={tile.ISA_IDENTIFIER_NAME}
                                        checked={tile.tilePrivCheck}
                                        onChange={(e) => this.onClickHomeTiles(e, index + 10)}
                                        disabled={(this.state.UserHomeTilesList.filter(tile => tile.tilePrivCheck == true)).length == 12 && !tile.tilePrivCheck}
                                    />
                                    <label className="custom-control-label" htmlFor={tile.ISA_IDENTIFIER_NAME}>
                                        {tile.ISA_IDENTIFIER_NAME}
                                    </label>
                                </div>
                            </>))}
                        </div>
                    </div>
                </> : null}
            </>
        );
    }
    //WW-1229 Home tiles -Nandhini L
    onClickHomeTiles = (event, index) => {
        let { UserHomeTilesList } = this.state;
        UserHomeTilesList[index].tilePrivCheck = event.target.checked;
        this.setState({ UserHomeTilesList })
    };


    /*
    * Ref no:UP_PC_41
    * 
    * This method is called when the search user drop down selected value is changed
    * */
    handleChange = (values) => {
        document.getElementById('StatusMsg').innerText = "";
        this.setState(
            { selectedOption: values })
        console.log('Option selected:', this.state.selectedOption);
        let UserROle = this.state.LoginUserRole
        if (this.state.LoginUserRole.toUpperCase() == "CORP ADMIN") {
            UserROle = "CORPADMIN"
        }
        let SearchBO = {
            Selected_UserID: values.value,
            Session_USERID: this.state.Login_UserId,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_UserRole: UserROle,
            Selected_UserType: this.state.LoginUserType,
            Session_ThirdParty_CompanyID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
            Query_IsMexicoVendor: false,
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Query_IsVendor: false,
            Session_APPRTYPE: CookieService.getLocalStorageValues("Session_APPRTYPE")
        }
        ProfileAction.GetSearchUsers(SearchBO);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //this.BuildSearch(values);
    };
    /*
    * Ref no:UP_PC_52
    * 
    * Bind the user details in the user profile form.
    * */
    BuildUserProfileDetails = () => {
        let SelectUserDetails = JSON.parse(ProfileStore.SelectUserBO);
        console.log("SelectUserDetails", SelectUserDetails)
        let FirstNameL = "";
        let lastNameL = "";
        let PhoneL = "";
        let DepartL = "";
        let userTypeL = "";
        let userRoleL = "";
        let HideuseridL = "";
        let EmailAddL = "";
        let Site = "";
        let SelectedUserIdL = "";
        let ActiveStatus = "";
        let MultiSiteEnableL = "";
        let GroupTable = [];
        let SiteList = [];
        let MultiSiteList = [];
        let MultiSiteChecked = [];
        let searchUserL = [];
        let DepartmentL = [];
        let UserDetails = [];
        let ThirdPartyListL = [];
        let VendorIdL = "";
        let VendorGroupL = "";
        let selectedOptionL = [];
        let SiteValue = "";
        let Departvalue = "";
        let SiteTitle = "";
        let btnActivateAccount = "";
        let btnInactivateAccount = "";
        let btnEmplInactivateAccount = "";
        let ShowActiveLabel = false;
        let ShowEmplyActiveLabel = false;
        let btnEmplActivateAccount = "";
        let ShowEmplLabel = "";
        let ShowAcctLabel = "";
        let SelectedThirdPartyL = "";
        let GroupIdL = "";
        UserDetails = SelectUserDetails.UserProfileDeatils;
        let EmployeeActiveStatus = "";
        let ErrorTable = SelectUserDetails.Error_Table;


        if (ErrorTable != null && ErrorTable != undefined && ErrorTable.length > 0) {
            if (ErrorTable.length > 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: ErrorTable[0].UserExist
                });
                // alert(ErrorTable[0].UserExist)
            }
        }
        else {
            if (UserDetails.length > 0) {
                if (UserDetails.length > 0) {
                    SelectedUserIdL = UserDetails[0].Employee_ID;
                    SelectedThirdPartyL = UserDetails[0].ThirdParty_Id;
                    userTypeL = UserDetails[0].UserType;
                    userRoleL = UserDetails[0].UserRole;
                    FirstNameL = UserDetails[0].First_Name;
                    lastNameL = UserDetails[0].Last_Name;
                    PhoneL = UserDetails[0].Phone_No;
                    EmailAddL = UserDetails[0].Email_Address;
                    DepartL = UserDetails[0].Departement;
                    HideuseridL = UserDetails[0].Hide_User_ID;
                    ActiveStatus = UserDetails[0].active_status;
                    EmployeeActiveStatus = UserDetails[0].Employee_active_status;
                    Site = UserDetails[0].Businees_Unit;
                    MultiSiteEnableL = UserDetails[0].Enable_MultiSite;
                    VendorIdL = UserDetails[0].MainvndrID;
                    btnActivateAccount = UserDetails[0].btnActivateAccount;
                    btnInactivateAccount = UserDetails[0].btnInactivateAccount;
                    btnEmplInactivateAccount = UserDetails[0].btnEmplInactivateAccount;
                    btnEmplActivateAccount = UserDetails[0].btnEmplActivateAccount;
                    ShowEmplLabel = UserDetails[0].lblEmplAccountDisabled;
                    ShowAcctLabel = UserDetails[0].lblAccountDisabled;
                    VendorGroupL = UserDetails[0]['Vendor Name'];
                    ThirdPartyListL = SelectUserDetails.ThirdPartytable;
                    SiteList = SelectUserDetails.SisterSiteTable;
                    MultiSiteList = SelectUserDetails.Multisite;
                    MultiSiteChecked = SelectUserDetails.MultiSite_Checked;
                    DepartmentL = SelectUserDetails.DepartmentTable;
                    GroupTable = SelectUserDetails.GroupTable;
                    ShowActiveLabel = UserDetails[0].lblAccountVisible;
                    ShowEmplyActiveLabel = UserDetails[0].lblEmplAccountVisible;
                    //if (GroupTable.length > 0) {
                    SiteTitle = UserDetails[0].txtGroup;
                    GroupIdL = UserDetails[0].txtGroupID;
                    CookieService.updateLocalStorageValues("HOME_STORE", UserDetails[0].HOME_STORE);
                    CookieService.updateLocalStorageValues("Division", UserDetails[0].DIVISION);

                    //}
                }
                /******NEW*(User Profile Settings Adjustable)wal-158****/
                PhoneL = PhoneL.replaceAll("-", "");
                console.log("phone no field", PhoneL)
                /************END********/
                if (userTypeL != "S") {

                    $('#DepartDiv').addClass('hide');

                }
                else {
                    $('#DepartDiv').removeClass('hide');
                }
                if (VendorIdL == null) {
                    VendorIdL = ""
                }
                else {
                    $('#VendorGroupValue').removeClass('errorcolour');
                    $('#VendorGroupValue').addClass('GreenColour');
                }
                let conditionvalue = "false"
                if (GroupTable != null && GroupTable != undefined) {
                    if (GroupTable.length > 0) {
                        GroupIdL = GroupTable[0].txtGroupID
                    }
                }
                if (Site == "I0W01" || userTypeL == "V") {
                    $('#MultiDiv').addClass('hide');
                } else {
                    $('#MultiDiv').removeClass('hide');
                }
                //$('#EmpyAcctBtn').removeClass('hide');
                //$('#AcctBtn').removeClass('hide');
                //$('#AcctLabel').removeClass('hide');
                //$('#EmpLabel').removeClass('hide');

                //if (btnEmplActivateAccount.toUpperCase() == conditionvalue.toUpperCase() && btnEmplInactivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
                //    $('#EmpyAcctBtn').addClass('hide');
                //}
                //else {
                if (EmployeeActiveStatus === "N") {
                    $('#EmpyAcctBtn').addClass('hide');
                    $('#EmpLabel').addClass('hide');
                }
                else {
                        if (btnEmplActivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
                            document.getElementById("EmpyAcctBtn").innerText = "In-Activate Employee Account"
                        }
                        else {
                            document.getElementById("EmpyAcctBtn").innerText = "Activate Employee Account"
                        }
                        $('#EmpyAcctBtn').removeClass('hide');
                }
                
                //}
                //if (btnActivateAccount.toUpperCase() == conditionvalue.toUpperCase() && btnInactivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
                //    $('#AcctBtn').addClass('hide');
                //}
                //else {
                if (btnActivateAccount.toUpperCase() == conditionvalue.toUpperCase()) {
                    document.getElementById("AcctBtn").innerText = "In-Activate Account"
                }
                else {
                    document.getElementById("AcctBtn").innerText = "Activate Account"
                }
                //}
                //if (ShowAcctLabel.toUpperCase() == conditionvalue.toUpperCase()) {
                //    $('#AcctLabel').addClass('hide');
                //}
                //if (ShowAcctLabel != null && ShowAcctLabel != undefined && ShowAcctLabel != "") {
                //    document.getElementById("AcctLabel").innerText = ShowAcctLabel;
                //    $('#AcctLabel').removeClass('hide')
                //}
                //if (ShowEmplLabel.toUpperCase() == conditionvalue.toUpperCase()) {
                //    $('#EmpLabel').addClass('hide');
                //}
                //if (ShowEmplLabel != null && ShowEmplLabel != undefined && ShowEmplLabel != "") {
                //    document.getElementById("EmpLabel").innerText = ShowEmplLabel;
                //    $('#EmpLabel').removeClass('hide')
                //}
                //if (ShowEmpyAcct.toUpperCase() == conditionvalue.toUpperCase()) {
                //    $('#EmpyAcctBtn').addClass('hide');
                //}
                //if (ShowAcct.toUpperCase() == conditionvalue.toUpperCase()) {
                //    $('#AcctBtn').addClass('hide');
                //}
                if (ShowActiveLabel.toUpperCase() == conditionvalue.toUpperCase()) {
                    $('#AcctLabel').addClass('hide');
                }
                else {
                    document.getElementById("AcctLabel").innerText = ShowAcctLabel;
                    $('#AcctLabel').removeClass('hide')
                }
                if (ShowEmplyActiveLabel.toUpperCase() == conditionvalue.toUpperCase()) {
                    $('#EmpLabel').addClass('hide');
                }
                else {
                    document.getElementById("EmpLabel").innerText = ShowEmplLabel;
                    $('#EmpLabel').removeClass('hide')
                }
                let Usertypes = []
                if (userRoleL == "CORPADMIN") {
                    userRoleL = "CORP ADMIN"
                }
                if (userRoleL.toUpperCase() == "SUPER" || userRoleL.toUpperCase() == "CORP ADMIN") {
                    Usertypes = [{ Role: "Super" }, { Role: "Corp Admin" }, { Role: "Admin" }, { Role: "User" }]
                }
                else {
                    Usertypes = [{ Role: "Admin" }, { Role: "User" }]
                }
                if (this.state.LoginUserRole.toUpperCase() == "SUPER") {
                    Usertypes = [{ Role: "Super" }, { Role: "Corp Admin" }, { Role: "Admin" }, { Role: "User" }]
                }
                if (this.state.ChangePasswordEnable == "Y") {
                    $('#PassDiv').addClass('hide');
                    $('#ConfPassDiv').addClass('hide');
                    $('#ChangePasBtn').removeClass('hide');
                }
                let UserROleLocal = []
                let UserRoleSelect = {}

                console.log("SelectedThirdPartyL", SelectedThirdPartyL)
                let loginThirdpartyid = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                if (loginThirdpartyid == "0" || loginThirdpartyid == null) {
                    if (ThirdPartyListL.length > 0 && userTypeL == "C" && (loginThirdpartyid == "0" || loginThirdpartyid == null)) {

                        ThirdPartyListL.map((ThirdParty, index1) => {
                            if (index1 == 0) {
                                Usertypes.map((val, index2) => {
                                    let localArray = {
                                        value: val.Role + index2,
                                        label: val.Role,
                                        key: Site,
                                        Role: val.Role,
                                        Third: "0",
                                    }
                                    if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin") {
                                        UserROleLocal.push(localArray)
                                    }
                                    if (this.state.SelectUsertype == "C" && val.Role != "Super") {
                                        UserROleLocal.push(localArray)
                                    }
                                    if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                                        UserROleLocal.push(localArray)
                                    }
                                    //debugger;
                                    if (val.Role.toUpperCase() == userRoleL) {
                                        UserRoleSelect = localArray
                                    }
                                });
                            }
                            Usertypes.map((val, index3) => {
                                let localArray = {
                                    value: ThirdParty.COMPANY_NAME + val.Role + index3,
                                    label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                                    key: Site,
                                    Role: val.Role,
                                    Third: ThirdParty.THIRDPARTY_COMP_ID,
                                }
                                if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin" && val.Role != "Super") {
                                    UserROleLocal.push(localArray)
                                }
                                if (this.state.SelectUsertype == "C" && val.Role != "Super" && val.Role != "Corp Admin") {
                                    UserROleLocal.push(localArray)
                                }
                                if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                                    UserROleLocal.push(localArray)
                                }
                                if (val.Role.toUpperCase() == userRoleL && SelectedThirdPartyL == ThirdParty.THIRDPARTY_COMP_ID) {
                                    UserRoleSelect = localArray
                                }
                            });
                        });
                    }
                    else {

                        Usertypes.map((val, index2) => {
                            let localArray = {
                                value: val.Role + index2,
                                label: val.Role,
                                key: Site,
                                Role: val.Role,
                                Third: "0",
                            }
                            if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "C" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (val.Role.toUpperCase() == userRoleL) {
                                UserRoleSelect = localArray
                            }
                        });
                    }
                }
                else {

                    let childItems = ThirdPartyListL.filter((item, index) => item.THIRDPARTY_COMP_ID == SelectedThirdPartyL);
                    childItems.map((ThirdParty, index1) => {
                        Usertypes.map((val, index2) => {
                            let localArray = {
                                value: ThirdParty.COMPANY_NAME + index2,
                                label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                                key: Site,
                                Role: val.Role,
                                Third: ThirdParty.THIRDPARTY_COMP_ID,
                            }
                            if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "C" && val.Role != "Corp Admin" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (val.Role.toUpperCase() == userRoleL) {
                                UserRoleSelect = localArray
                            }
                        });
                    });
                }
                let MultiSlectList = []
                let MultiSelectValue = []
                MultiSiteCHeckB = false
                //MultiSiteCHeckB = MultiSiteEnableL.toUpperCase() == "Y" || MultiSiteEnableL.toLowerCase() == "y" ? true : false
                if (MultiSiteEnableL.toUpperCase() == "Y" || MultiSiteEnableL.toLowerCase() == "y") {
                    //document.getElementById("customCheck7").checked = true;
                    MultiSiteCHeckB = true
                    MultiSiteList.map((val, index) => {
                        if (val.BUSINESS_UNIT == Site) {
                            let localArray = {
                                value: val.BUSINESS_UNIT,
                                label: val.DESCRIPTION,
                                disabled: true
                            }
                            SiteTitle = val.DESCRIPTION;
                            MultiSlectList.push(localArray)
                        }
                        else {
                            let localArray = {
                                value: val.BUSINESS_UNIT,
                                label: val.DESCRIPTION
                            }
                            MultiSlectList.push(localArray)
                        }
                    });

                    MultiSiteChecked.map((val, index) => {
                        let ChildSiteValue = MultiSiteList.filter((item, index) => item.BUSINESS_UNIT == val.BUSINESS_UNIT);

                        let localArray = {
                            value: ChildSiteValue[0].BUSINESS_UNIT,
                            label: ChildSiteValue[0].DESCRIPTION
                        }
                        MultiSelectValue.push(localArray)

                    });
                    $('#MultiSelectDD').removeClass('hide');
                }
                else {
                    $('#MultiSelectDD').addClass('hide');
                    //document.getElementById("customCheck7").checked = false;
                    MultiSiteEnableL = "N"
                }
                let SiteListDD = []
                console.log("Site", Site)
                if (this.state.SelectUsertype != "V") {
                    SiteList.map((val, index) => {

                        let localArray = {
                            value: val.GROUPID,
                            label: val.GROUPNAME
                        }
                        if (val.GROUPID == Site) {
                            SiteValue = localArray
                        }
                        if (val.GROUPID != undefined && val.GROUPNAME != undefined) {
                            SiteListDD.push(localArray)
                        }
                    });
                    if (SiteListDD.length == 0) {
                        SiteList.map((val, index) => {

                            let localArray = {
                                value: val.BUSINESS_UNIT,
                                label: val.DESCRIPTION
                            }
                            if (val.BUSINESS_UNIT == Site) {
                                SiteValue = localArray
                            }
                            SiteListDD.push(localArray)
                        });
                    }
                }
                else {
                    let localArray = {
                        value: UserDetails[0].Businees_Unit,
                        label: UserDetails[0].Businees_Unit
                    }
                    SiteValue = localArray
                    SiteListDD = this.state.SiteList
                }


                let DepartmentLocal = []
                if (DepartmentL.length > 0) {
                    DepartmentL.map((val, index) => {
                        if (index == 0) {
                            let localArray1 = {
                                value: "",
                                label: "-----Select Department-----"
                            }
                            DepartmentLocal.push(localArray1)
                            if (val.DEPT_ID != DepartL) {
                                Departvalue = localArray1
                            }
                        }
                        let localArray = {
                            value: val.DEPT_ID,
                            label: val.DEPT_NAME
                        }
                        if (val.DEPT_ID == DepartL) {
                            Departvalue = localArray
                        }
                        DepartmentLocal.push(localArray)
                    });
                }
                if (SiteTitle == null) {
                    SiteTitle = ""
                }
                /******NEW*(User Profile Settings Adjustable)wal-158****/
                PhoneL = PhoneL.replaceAll("-", "");
                console.log("phone no field", PhoneL)
                /************END********/
                console.log("UserROleLocal", UserROleLocal)
                this.setState({
                    SelectedUserId: SelectedUserIdL, FirstName: FirstNameL, LastName: lastNameL, PhoneNum: PhoneL, EmailAddres: EmailAddL, MultiSiteEnable: MultiSiteEnableL, MultiSiteExist: MultiSiteEnableL,
                    VendorGroup: VendorGroupL, VendorId: VendorIdL, UserType: userTypeL, UserRole: userRoleL, DepartMent: Departvalue, HideuserId: HideuseridL,
                    UserActiveStatus: ActiveStatus, EmployeeAccountActiveStatus: EmployeeActiveStatus, MultiSite: MultiSlectList, MultiSiteSelected: MultiSelectValue, Depart: DepartmentLocal, SiteList: SiteListDD,
                    ThirdPartyList: ThirdPartyListL, SelectUserRole: UserRoleSelect, UserRoleDD: UserROleLocal, SiteTitleValue: SiteTitle, selectSiteID: Site, SelectSite: SiteValue,
                    SelectedThirdParty: SelectedThirdPartyL, MultiSiteChecked: MultiSiteCHeckB, GroupID: GroupIdL
                })
            }

        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
    * Ref no:UP_PC_204
    * This method is invoked when the Site value is changed
    * 
    * */
    handleChangeSite = SelectSite => {
        this.setState(
            { SelectSite },
            () => console.log(`Option Site:`, this.state.SelectSite)
        );
        document.getElementById('ErrorMagSite').innerText = ""
        let ThirdPartyBo = {
            SiteValue: SelectSite.value,
            Session_ThirdParty_CompanyID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
            SelectedUserId: this.state.SelectedUserId,
            Page_Action: this.state.PageAction,
        }
        ProfileAction.GetThirdParty(ThirdPartyBo)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (SelectSite.value.toUpperCase() == "SELECT" || SelectSite.value == "I0W01") {
            $('#MultiDiv').addClass('hide');
        } else { 
            $('#MultiDiv').removeClass('hide');
        }

    };
    /*
    * Ref no:UP_PC_204
    * 
    * Bind the third party roles
    * */
    ShowThirdParty = () => {

        let ThirdParty = JSON.parse(ProfileStore.LoadThirdParty);
        let DisableTypeDDL = false
        console.log("ThirdParty", ThirdParty)
        let MultiSiteList = []
        MultiSiteList = ThirdParty.Multisite
        let MultiSiteChecked = []
        MultiSiteChecked = ThirdParty.MultiSite_Checked
        let MultiSlectList = []
        //let SelectSiteValue = [];
        //SelectSiteValue = this.state.SelectSite;
        let Site = this.state.selectSiteID
        if (this.state.SiteList.length > 0) {
            Site = this.state.SelectSite.value
        }
        else {
            Site = this.state.GroupID
        }
        //if (SelectSiteValue.length == 0) {
        //    Site = this.state.selectSiteID
        //}
        //else {
        //    Site = SelectSiteValue.value
        //}
        let ThirdPartyListL = []
        ThirdPartyListL = ThirdParty.ThirdPartytable
        let Usertypes = []
        let UserROleLocal = []
        let UserRoleSelect = {}
        let MultiSelectValue = []
        let SelectedThirdPartyL = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
        if ((this.state.UserRole.toUpperCase() == "SUPER" || this.state.UserRole.toUpperCase() == "CORP ADMIN") && this.state.PageAction != "ADD") {
            Usertypes = [{ Role: "Super" }, { Role: "Corp Admin" }, { Role: "Admin" }, { Role: "User" }]
        }
        else {
            Usertypes = [{ Role: "Admin" }, { Role: "User" }]
        }
        if (this.state.LoginUserRole.toUpperCase() == "SUPER" || (this.state.LoginUserType == "S" && this.state.LoginUserRole.toUpperCase() == "ADMIN")) {
            Usertypes = [{ Role: "Super" }, { Role: "Corp Admin" }, { Role: "Admin" }, { Role: "User" }]
        }
        $('#MultiSelectDD').removeClass('hide');
        let UserRoleL = this.state.SelectUserRole
        if (SelectedThirdPartyL == "0" || SelectedThirdPartyL == null) {
            if (ThirdPartyListL.length > 0 && this.state.Customer == true && (SelectedThirdPartyL == "0" || SelectedThirdPartyL == null)) {

                ThirdPartyListL.map((ThirdParty, index1) => {
                    if (index1 == 0) {
                        Usertypes.map((val, index2) => {
                            let localArray = {
                                value: val.Role + index2,
                                label: val.Role,
                                key: Site,
                                Role: val.Role,
                                Third: "0",
                            }
                            if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "C" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            //if (val.Role.toUpperCase() == this.state.UserRole) {
                            //    UserRoleSelect = localArray
                            //}
                            if (UserRoleL.Role.toUpperCase() == val.Role.toUpperCase()) {
                                UserRoleSelect = localArray
                            }
                            if ((UserRoleL.Role == "Super") && this.state.SelectUsertype == "C" && val.Role == "Corp Admin") {
                                UserRoleSelect = localArray
                            }
                            if ((UserRoleL.Role == "Corp Admin") && this.state.SelectUsertype == "S" && val.Role == "Super") {
                                UserRoleSelect = localArray
                            }
                            if ((UserRoleL.Role == "Corp Admin" || UserRoleL.Role == "Super") && this.state.SelectUsertype == "V" && val.Role == "Admin") {
                                UserRoleSelect = localArray
                            }
                        });
                    }
                    Usertypes.map((val, index3) => {
                        let localArray = {
                            value: ThirdParty.COMPANY_NAME + val.Role + index3,
                            label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                            key: Site,
                            Role: val.Role,
                            Third: ThirdParty.THIRDPARTY_COMP_ID,
                        }
                        if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin" && val.Role != "Super") {
                            UserROleLocal.push(localArray)
                        }
                        if (this.state.SelectUsertype == "C" && val.Role != "Super" && val.Role != "Corp Admin") {
                            UserROleLocal.push(localArray)
                        }
                        if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                            UserROleLocal.push(localArray)
                        }
                        //if (val.Role.toUpperCase() == this.state.UserRole) {
                        //    UserRoleSelect = localArray
                        //}
                    });
                });
            }
            else {

                Usertypes.map((val, index2) => {
                    let localArray = {
                        value: val.Role + index2,
                        label: val.Role,
                        key: Site,
                        Role: val.Role,
                        Third: "0",
                    }
                    if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "C" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    //if (val.Role.toUpperCase() == this.state.UserRole) {
                    //    UserRoleSelect = localArray
                    //}
                    //if (this.state.Customer == true && this.state.UserRole == "SUPER") {

                    //}
                    if (UserRoleL.Role.toUpperCase() == val.Role.toUpperCase()) {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.Role == "Super") && this.state.SelectUsertype == "C" && val.Role == "Corp Admin") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.Role == "Corp Admin") && this.state.SelectUsertype == "S" && val.Role == "Super") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.Role == "Corp Admin" || UserRoleL.Role == "Super") && this.state.SelectUsertype == "V" && val.Role == "Admin") {
                        UserRoleSelect = localArray
                    }
                });
            }
        }
        else {

            let childItems = ThirdPartyListL.filter((item, index) => item.THIRDPARTY_COMP_ID == SelectedThirdPartyL);
            childItems.map((ThirdParty, index1) => {
                Usertypes.map((val, index2) => {
                    let localArray = {
                        value: ThirdParty.COMPANY_NAME + index2,
                        label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                        key: Site,
                        Role: val.Role,
                        Third: ThirdParty.THIRDPARTY_COMP_ID,
                    }
                    if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "C" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    //if (val.Role.toUpperCase() == this.state.UserRole) {
                    //    UserRoleSelect = localArray
                    //}
                    if (UserRoleL.Role.toUpperCase() == val.Role.toUpperCase()) {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.Role == "Super") && this.state.SelectUsertype == "C" && val.Role == "Corp Admin") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.Role == "Corp Admin") && this.state.SelectUsertype == "S" && val.Role == "Super") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.Role == "Corp Admin" || UserRoleL.Role == "Super") && this.state.SelectUsertype == "V" && val.Role == "Admin") {
                        UserRoleSelect = localArray
                    }
                });
            });
        }
        console.log("UserRoleSelect", UserRoleSelect)
        console.log("UserROleLocal", UserROleLocal)
        let MultisSIteCheckedvalue = false
        if (MultiSiteList.length > 0 && MultiSiteChecked.length > 0) {
            MultiSiteList.map((val, index) => {
                if (val.BUSINESS_UNIT == Site) {
                    let localArray = {
                        value: val.BUSINESS_UNIT,
                        label: val.DESCRIPTION,
                        disabled: true
                    }
                    MultiSlectList.push(localArray)
                }
                else {
                    let localArray = {
                        value: val.BUSINESS_UNIT,
                        label: val.DESCRIPTION
                    }
                    MultiSlectList.push(localArray)
                }
            });
            MultisSIteCheckedvalue = true
            // document.getElementById("customCheck7").checked = true;
            if (MultiSiteChecked.length > 0) {
                MultiSiteChecked.map((val, index) => {
                    let ChildSiteValue = MultiSiteList.filter((item, index) => item.BUSINESS_UNIT == val.BUSINESS_UNIT);

                    let localArray = {
                        value: ChildSiteValue[0].BUSINESS_UNIT,
                        label: ChildSiteValue[0].DESCRIPTION
                    }
                    MultiSelectValue.push(localArray)

                });
            }

        }
        else {

            //document.getElementById("customCheck7").checked = false;
            $('#MultiSelectDD').addClass('hide');
        }
        let UserROleLocalArray = UserROleLocal
        if (this.state.PageAction == "ADD") {
            UserRoleSelect = {
                value: "Select",
                label: "Select Type",
                key: "",
                Role: "",
                Third: "",
            }
            UserROleLocalArray = []
            UserROleLocal.map((val, index2) => {
                //debugger
                if (index2 == 0) {
                    UserROleLocalArray.push(UserRoleSelect)
                }
                UserROleLocalArray.push(val)
            })
        }
        this.setState({
            MultiSite: MultiSlectList, MultiSiteSelected: MultiSelectValue, MultiSiteChecked: MultisSIteCheckedvalue,
            ThirdPartyList: ThirdPartyListL, SelectUserRole: UserRoleSelect, UserRoleDD: UserROleLocalArray, adduser: false, DisableTypeDD: DisableTypeDDL
        })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
    * This method is invoke when the Site is selected in the Privileges tab.
    * */
    handleChangeTab2Site = SelectTab2Site => {
        this.setState(
            { SelectTab2Site },
            () => console.log(`Option SiteTab2:`, this.state.SelectTab2Site)
        );
    };
    /*
    * This method is invoke when the Role is slected in the Privileges tab.
    * */
    handleChangeTab2Role = SelectROleList => {
        this.setState(
            { SelectROleList },
            () => console.log(`Option Role:`, this.state.SelectROleList)
        );
        let selectrole = SelectROleList.value
        let GetPrivilegeRoleBO = {
            UserRoleSelected: selectrole
        }
        ProfileAction.GetPrivilegeRole(GetPrivilegeRoleBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    };
    /*
    * This method is invoke when the Department is slected in the User profile tab.
    * */
    handleChangeDepart = DepartMent => {
        this.setState(
            { DepartMent },
            () => console.log(`Option Site:`, this.state.DepartMent)
        );
    };
    /*
    * This method is invoke when the Role is slected in the User profile tab.
    * */
    handleChangeUserROle = SelectUserRole => {
        this.setState(
            { SelectUserRole },
            () => {
                console.log(`Option role:`, this.state.SelectUserRole);
                if (this.state.SelectUserRole !== "Select") {
                    document.getElementById("ErrorMegSite").innerHTML = "";
                }
            }
        );
    };
    /*
    * This method is invoke when the MultiSite is slected in the user Profile tab.
    * */
    handleMultiSiteDD = (values) => {
        let selectedMulti = [];
        values.forEach((selected) => {
            selectedMulti.push({ BUSINESS_UNIT: selected.value });
        })
        this.setState({ MultiSiteSelected: values, selectedMultiSites: selectedMulti });
        console.log("Multisite", selectedMulti)
        console.log("MultisiteValue", values)
    }
    /*
    * This method is invoke when the Privilege is checked in the privileges tree in the privileges tab.
    * */
    //WW-1229 Home tiles -Nandhini L
    OnCheckTree = (checked, targetNode) => {
        let tempHomeTiles = [];
        let UserHomeTilesList = this.state.UserHomeTilesList;
        if (Array.isArray(targetNode.children)) {
            targetNode.children.forEach(item => {
                if (Array.isArray(item.children)) {
                    item.children.forEach(child => {
                        if (!targetNode.checked || !UserHomeTilesList.some(tile => tile.SECURITYALIAS.slice(3) == child.value)) {
                            tempHomeTiles.push(child.value);
                        }
                    });
                } else {
                    if (!targetNode.checked || !UserHomeTilesList.some(tile => tile.SECURITYALIAS.slice(3) == item.value)) {
                        tempHomeTiles.push(item.value);
                    }
                }
            });
        } else {
            if (!targetNode.checked || !UserHomeTilesList.some(tile => tile.SECURITYALIAS.slice(3) == targetNode.value)) {
                tempHomeTiles.push(targetNode.value);
            }
        }
        if (targetNode.checked) {
            this.state.TilesList.forEach(tile => {
                if (tile.DEFAULT_TILE != 'Y' && tempHomeTiles.includes(tile.SECURITYALIAS.slice(3))) {
                    UserHomeTilesList.push({ ...tile, tilePrivCheck: false });
                }
            });
        } else {
            UserHomeTilesList = UserHomeTilesList.filter(tile => tile.DEFAULT_TILE == 'Y' || !tempHomeTiles.includes(tile.SECURITYALIAS.slice(3)));
        }

        this.setState({ checked, UserHomeTilesList: UserHomeTilesList });

    }
    /*
     * This method is invoke when the Approver is changed in the Approvals tab.
     * */
    ////2377 - User Profile_ After selecting Remove checkbox alternate requestor approval dropdown value should be in disable mode.-Dhamotharan P
    //handleChangeAppro = ExistApproveValue => {
    //    //debugger
    //    let a = this.state.ExistReqAppr;
    //    let b = this.state.ExistApproveValue;

    //    if (ExistApproveValue.value == this.state.ExistReqAppr ) {
    //        $('#removeApprover').removeClass('hide');
    //    }
    //    else {
    //        $('#removeApprover').addClass('hide');
    //    }
    //    this.setState(
    //        { ExistApproveValue },
    //        () => console.log(`Option Approver:`, this.state.ExistApproveValue)
    //    );
    //};


    //PC_1044_153 WW-1044 Approval  [07/05/2024] Pavithra R
    handleChangeAppro = ExistApproveValue => {
        //debugger
        const { t } = this.props
        //[8/10/22, Bug - 2349, PS_UP_04, Dhevanesam R]
        if (ExistApproveValue.value == 0) {
            this.setState({ ExistAppLimit: "", ExistApproveValue });
            $('#removeApprover').addClass('hide');
        }
        else {
            if (approvalAccordian == 2) {
                if (ExistApproveValue.value == this.state.ExistReqAppr) {
                    $('#removeApprover').removeClass('hide');
                    this.setState({ ExistAppLimit: this.state.initialBudAppLimit, ExistApproveValue });
                }
                else {
                    this.setState({ ExistAppLimit: "", ExistApproveValue });

                    $('#removeApprover').addClass('hide');
                }
            }
            else if (approvalAccordian == 3) {     //PC_1044_153 WW-1044 Approval  [07/05/2024] Pavithra R
                let updateAltBudgetary = [];
                if (ExistApproveValue.length < 11) {
                    if (ExistApproveValue.length > 0) {
                        updateAltBudgetary = ExistApproveValue;
                    }
                    this.setState({ selectedApprvValue: ExistApproveValue, updateAltBudgetary });
                }
                else {
                    try {
                        $.toast({
                            text: 'You already selected the maximum number of approvers',
                            position: {
                                top: 150,
                                bottom: 90,
                                left: 650
                            },
                            stack: false,
                            loader: false
                        });
                    } catch (ex) {
                        console.log(ex)
                    }
                }
            }
            else {
                this.setState({ ExistApproveValue });
            }
            //else {
            //    if (ExistApproveValue.value == this.state.ExistBudAppr) {
            //        $('#removeApprover').removeClass('hide');
            //        this.setState({ ExistAppLimit: this.state.initialBudAppLimit });
            //    }
            //    else {
            //        this.setState({ ExistAppLimit: "" });

            //        $('#removeApprover').addClass('hide');
            //    }
            //}
        }
    };

    /*
     * This method is invoke when the Ship to is changed in the Preference tab.
     * */
    handleChangeShipto = Shipto => {
        this.setState(
            { Shipto },
            () => console.log(`Option Approver:`, this.state.Shipto)
        );
    };
    /*[07/19/22, PC_WW-448_07], Priyanka D */
    handleChangeHomeStore = HomeStoreValue => {
        this.setState({ HomeStoreValue })
    }

    handleChangeDivision = DivisionValue => {
        this.setState({ DivisionValue })
    }
    /*
     * This method is invoke when the Department is changed in the Preference tab.
     * */
    handleChangeDepartPref = DepartmentPref => {
        this.setState(
            { DepartmentPref },
            () => console.log(`Option Approver:`, this.state.DepartmentPref)
        );
    };
    /*
    * This method is invoke when the Crib is changed.
    * */
    handleChangeCrib = CribValue => {
        this.setState(
            { CribValue },
            () => console.log(`Option Approver:`, this.state.CribValue)
        );
    };
    /*
    * This method is invoke when the User is changed in the SDI Track.
    * */
    handleChangeEmplyee = TSTDefaultValue => {
        this.setState(
            { TSTDefaultValue },
            () => console.log(`Option Approver:`, this.state.TSTDefaultValue)
        );
        let SelectedUserId = TSTDefaultValue.value
        if (SelectedUserId != "" && SelectedUserId != null) {
            let TSTSelectedBO = {
                SelectedUser: SelectedUserId
            }
            ProfileAction.GetSearchUserTrack(TSTSelectedBO)
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
    };
    /*
    * Ref no: UP_PC_40
    * 
    * This is event method invoke when user type radio is select changed
    * */
    UserTypeRadio = (UserType) => {
        document.getElementById('StatusMsg').innerText = "";
        //debugger;
        //this.setState({ DisableTypeDD: true });
        if (UserType != "V") {
            $('#VendorDiv').addClass('hide');
            $('#MultiDiv').addClass('hide');
            if (this.state.selectSiteID != "I0W01") {
                $('#MultiDiv').removeClass('hide');
            }
        }
        if (UserType == "S") {
            $('#DepartDiv').removeClass('hide');
        }
        let SDIEMp = false
        let CustomerL = false
        let vendor = false
        if (UserType == "S") {
            SDIEMp = true
            CustomerL = false
            vendor = false
            document.getElementById("UtypeSDI").checked = true;
            document.getElementById("UtypeCustomer").checked = false;
            document.getElementById("UtypeVendor").checked = false;
        }
        else if (UserType == "C") {
            SDIEMp = false
            CustomerL = true
            vendor = false
            document.getElementById("UtypeSDI").checked = false;
            document.getElementById("UtypeCustomer").checked = true;
            document.getElementById("UtypeVendor").checked = false;
        }
        else {
            SDIEMp = false
            vendor = true
            CustomerL = false
            document.getElementById("UtypeSDI").checked = false;
            document.getElementById("UtypeCustomer").checked = false;
            document.getElementById("UtypeVendor").checked = true;
        }
        if (this.state.PageAction == "ADD") {
            document.getElementById("VendorGroupValue").innerText = "";
            document.getElementById("ErrorMagFirstName").innerText = "";
            document.getElementById("ErrorMagLastName").innerText = "";
            document.getElementById("ErrorMagEMailAdd").innerText = "";
            document.getElementById("ErrorMagPhone").innerText = "";
            document.getElementById("ErrorMagPass").innerText = "";
            document.getElementById("ErrorMagConfPass").innerText = "";
            document.getElementById("ErrorMagSite").innerText = "";
            document.getElementById("ErrorMegSite").innerText = "";
            document.getElementById("EmpLabel").innerText = "";
            document.getElementById("AcctLabel").innerText = "";
            document.getElementById("StatusMsg").innerText = "";
            document.getElementById("MultiSelectUP").checked = false; //{/*NEW***changed**(id)customCheck7-->MultiSelectUP*/}
            let DisableTypeDDL = this.state.SiteList.length > 0 ? true : false
            //if (this.state.SelectUsertype == "V") {
            //    SiteList = [{ GROUPID: "ISA00", GROUPNAME: "ISA00" }, { GROUPID: "SDM00", GROUPNAME: "SDM00" }, { GROUPID: "WAL00", GROUPNAME: "WAL00" }]
            //    $('#VendorDiv').removeClass('hide');
            //    $('#MultiDiv').addClass('hide');
            //    $('#DepartDiv').addClass('hide');
            //}
            //SiteList.map((val, index) => {

            //    let localArray = {
            //        value: val.GROUPID,
            //        label: val.GROUPNAME
            //    }
            //    if (index == 0 && this.state.SelectUsertype == "V") {
            //        let localArray1 = {
            //            value: "1",
            //            label: "Select Site"
            //        }
            //        SiteValue = localArray1
            //    }
            //    if (val.GROUPID == this.state.selectSiteID) {
            //        SiteValue = localArray
            //    }
            //    SiteListDD.push(localArray)
            //});
            //if (this.state.SelectUsertype == "C") {
            //    $('#DepartDiv').addClass('hide');
            //}
            let UserTypeChange = {
                Session_USERID: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_ThirdParty_CompanyID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserRole: this.state.LoginUserType,
                Page_Action: this.state.PageAction,
                Query_IsVendor: false,
                Selected_UserType: UserType
            }

            ProfileAction.GetSearchUserOnUTypeChange(UserTypeChange)
            let Departmentdefault = {
                value: "",
                label: "-----Select Department-----"

            }
            let siteclear = {
                value: "Select",
                label: "Select Site"
            }
            let Selectvalue = {
                value: "Select",
                label: "Select Type",
                key: "",
                Role: "",
                Third: "",
            }
            $('#MultiSelectDD').addClass('hide');
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            this.setState({
                SelectedUserId: "", FirstName: "", LastName: "",
                EmailAddres: "", PhoneNum: "", PassNTB: "", ConPasNTB: "", PageAction: "ADD", ChangePasswordEnable: "Y", adduser: true,
                VendorId: "", DisableTypeDD: DisableTypeDDL, SelectUsertype: UserType, SDIEMp: SDIEMp, vendor: vendor, Customer: CustomerL, DepartMent: Departmentdefault,
                MultiSiteChecked: false, MultiSiteSelected: [], SelectSite: siteclear, SelectUserRole: Selectvalue,
            })
        }
        else {
            let UserTypeChange = {
                Session_USERID: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_ThirdParty_CompanyID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserRole: this.state.LoginUserType,
                Page_Action: this.state.PageAction,
                Query_IsVendor: false,
                Selected_UserType: UserType
            }
            let MultiSiteCheckedL = this.state.MultiSiteChecked
            if (this.state.MultiSiteExist.toUpperCase() != "Y") {
                $('#MultiSelectDD').addClass('hide');
                MultiSiteCheckedL = false
            }
            ProfileAction.GetSearchUserOnUTypeChange(UserTypeChange)
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            this.setState({
                SelectUsertype: UserType, SDIEMp: SDIEMp, vendor: vendor, Customer: CustomerL, MultiSiteChecked: MultiSiteCheckedL
            })
        }
    }
    /*
    * Ref no: UP_PC_56
    * 
    * In this method search user drop down is binded
    * */
    BuildSearchOnUserTypeChg = () => {
        //debugger
        let RadioType = JSON.parse(ProfileStore.RadioUserTypeBO);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("RadioType", RadioType)
        let SearchDDlist = [];
        let selectedOptionL = [];
        let searchUserL = [];
        searchUserL = RadioType.SearchDropDownTable
        searchUserL.map((val, index) => {
            let localArray = {
                value: val.ISA_EMPLOYEE_ID,
                label: val.USERANDBU
            }
            if (index == 1) {
                let localArray1 = {
                    value: "1",
                    label: "<< Select User >>"
                }
                selectedOptionL = localArray1
            }
            if (val.ISA_EMPLOYEE_ID == this.state.SelectedUserId) {
                selectedOptionL = localArray
            }
            SearchDDlist.push(localArray)
        });
        let SiteListDD = []
        let SiteList = []
        let SiteValue = []
        SiteList = RadioType.SisterSiteTable
        if (this.state.ChangePasswordEnable == "Y") {
            $('#PassDiv').addClass('hide');
            $('#ConfPassDiv').addClass('hide');
            $('#ChangePasBtn').removeClass('hide');
        }
        if (this.state.PageAction == "ADD") {
            $('#PassDiv').removeClass('hide');
            $('#ConfPassDiv').removeClass('hide');
            $('#ChangePasBtn').addClass('hide');
        }
        if (this.state.SelectUsertype == "V") {
            SiteList = [{ GROUPID: "ISA00", GROUPNAME: "ISA00" }, { GROUPID: "SDM00", GROUPNAME: "SDM00" }, { GROUPID: "WAL00", GROUPNAME: "WAL00" }]
            $('#VendorDiv').removeClass('hide');
            $('#MultiDiv').addClass('hide');
            $('#DepartDiv').addClass('hide');
        }
        if (this.state.SelectUsertype == "C") {
            $('#DepartDiv').addClass('hide');
        }
        SiteList.map((val, index) => {

            let localArray = {
                value: val.GROUPID,
                label: val.GROUPNAME
            }
            if (index == 0 && this.state.SelectUsertype == "V") {
                let localArray1 = {
                    value: "1",
                    label: "Select Site"
                }
                SiteValue = localArray1
            }
            if (val.GROUPID == this.state.selectSiteID) {
                SiteValue = localArray
            }
            SiteListDD.push(localArray)
        });
        let UserROleLocal = [];
        let UserRoleSelect = {};
        let ThirdPartyListL = this.state.ThirdPartyList
        console.log("ThirdPartyListL", ThirdPartyListL)
        let Usertypes = []
        if (this.state.LoginUserRole.toUpperCase() == "SUPER" || this.state.LoginUserRole.toUpperCase() == "CORP ADMIN") {
            Usertypes = [{ Role: "Super" }, { Role: "Corp Admin" }, { Role: "Admin" }, { Role: "User" }]
        }
        else {
            Usertypes = [{ Role: "Admin" }, { Role: "User" }]
        }
        let UserRoleL = this.state.UserRole
        //******NEW*****(1/27/2021)***removed**for the vendor radio change on addnewuser
        //if (this.state.PageAction == "ADD") {
        //    UserRoleL = {
        //        value: "Select",
        //        label: "Select Type",
        //        key: "",
        //        Role: "",
        //        Third: "",
        //    }
        //}
        //*** END **********
        let SelectedThirdPartyL = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
        if (SelectedThirdPartyL == "0" || SelectedThirdPartyL == null) {
            if (ThirdPartyListL.length > 0 && this.state.Customer == true && (SelectedThirdPartyL == "0" || SelectedThirdPartyL == null)) {
                ThirdPartyListL.map((ThirdParty, index1) => {
                    if (index1 == 0) {
                        //debugger
                        Usertypes.map((val, index2) => {
                            let localArray = {
                                value: val.Role + index2,
                                label: val.Role,
                                key: this.state.selectSiteID,
                                Role: val.Role,
                                Third: "0",
                            }
                            if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "C" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                                UserROleLocal.push(localArray)
                            }
                            if (UserRoleL.toUpperCase() == val.Role.toUpperCase()) {
                                UserRoleSelect = localArray
                            }
                            if ((UserRoleL.toUpperCase() == "SUPER" || UserRoleL.toUpperCase() == "ADMIN") && this.state.SelectUsertype == "C" && val.Role == "Corp Admin") {
                                UserRoleSelect = localArray
                            }
                            if ((UserRoleL.toUpperCase() == "CORP ADMIN" || UserRoleL.toUpperCase() == "ADMIN") && this.state.SelectUsertype == "S" && val.Role == "Super") {
                                UserRoleSelect = localArray
                            }
                            if ((UserRoleL.toUpperCase() == "CORP ADMIN" || UserRoleL.toUpperCase() == "SUPER") && this.state.SelectUsertype == "V" && val.Role == "Admin") {
                                UserRoleSelect = localArray
                            }
                            if (UserRoleL.toUpperCase() == "SUPER" && this.state.SelectUsertype == "C" && val.Role == "Admin") {
                                UserRoleSelect = localArray
                            }
                        });
                    }
                    Usertypes.map((val, index3) => {
                        let localArray = {
                            value: ThirdParty.COMPANY_NAME + index1 + index3,
                            label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                            key: this.state.selectSiteID,
                            Role: val.Role,
                            Third: ThirdParty.THIRDPARTY_COMP_ID,
                        }
                        if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin" && val.Role != "Super") {
                            UserROleLocal.push(localArray)
                        }
                        if (this.state.SelectUsertype == "C" && val.Role != "Super" && val.Role != "Corp Admin") {
                            UserROleLocal.push(localArray)
                        }
                        if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                            UserROleLocal.push(localArray)
                        }
                        //if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin" && val.Role != "Super") {
                        //    UserRoleSelect = localArray
                        //}
                        //if (this.state.SelectUsertype == "C" && val.Role != "Super" && val.Role != "Corp Admin") {
                        //    UserRoleSelect = localArray
                        //}
                        //if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                        //    UserRoleSelect = localArray
                        //}

                    });
                });
                console.log("UserROleLocal", UserROleLocal)
            }
            else {
                Usertypes.map((val, index2) => {
                    let localArray = {
                        value: val.Role + index2,
                        label: val.Role,
                        key: this.state.selectSiteID,
                        Role: val.Role,
                        Third: "0",
                    }
                    if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin" && val.Role != "Corp Admin") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "C" && val.Role != "Super" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (UserRoleL.toUpperCase() == val.Role.toUpperCase()) {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.toUpperCase() == "SUPER" || UserRoleL.toUpperCase() == "ADMIN") && this.state.SelectUsertype == "C" && val.Role == "Corp Admin") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.toUpperCase() == "CORP ADMIN" || UserRoleL.toUpperCase() == "Admin") && this.state.SelectUsertype == "S" && val.Role == "Super") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL.toUpperCase() == "CORP ADMIN" || UserRoleL.toUpperCase() == "SUPER") && this.state.SelectUsertype == "V" && val.Role == "Admin") {
                        UserRoleSelect = localArray
                    }
                });
            }
        }
        else {
            let childItems = ThirdPartyListL.filter((item, index) => item.THIRDPARTY_COMP_ID == CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"));
            childItems.map((ThirdParty, index1) => {
                Usertypes.map((val, index2) => {
                    let localArray = {
                        value: ThirdParty.COMPANY_NAME + index2,
                        label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                        key: this.state.selectSiteID,
                        Role: val.Role,
                        Third: ThirdParty.THIRDPARTY_COMP_ID,
                    }
                    if (this.state.SelectUsertype == "S" && val.Role != "Corp Admin") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "C" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (this.state.SelectUsertype == "V" && val.Role != "Corp Admin" && val.Role != "Super") {
                        UserROleLocal.push(localArray)
                    }
                    if (UserRoleL.toUpperCase() == val.Role.toUpperCase()) {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL == "Super" || UserRoleL == "Admin") && this.state.SelectUsertype == "C" && val.Role == "Corp Admin") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL == "Corp Admin" || UserRoleL == "Admin") && this.state.SelectUsertype == "S" && val.Role == "Super") {
                        UserRoleSelect = localArray
                    }
                    if ((UserRoleL == "Corp Admin" || UserRoleL == "Super") && this.state.SelectUsertype == "V" && val.Role == "Admin") {
                        UserRoleSelect = localArray
                    }
                });
            });
        }
        if (this.state.PageAction == "ADD") {
            SiteValue = {
                value: "Select",
                label: "Select Site"
            }
            UserRoleSelect = {
                value: "Select",
                label: "Select Type",
                key: "",
                Role: "",
                Third: "",
            }
        }

        this.setState({
            SearchUser: SearchDDlist, selectedOption: selectedOptionL, SiteList: SiteListDD, SelectSite: SiteValue, SelectUserRole: UserRoleSelect, UserRoleDD: UserROleLocal,
        })

    }
    /*
    * Ref no:UP_PC_92
    * 
    * Show the Change password fields
    * */
    ChgPwd = () => {
        this.setState({ ChangePasswordEnable: "Y" });
        $('#PassDiv').removeClass('hide');
        $('#ConfPassDiv').removeClass('hide');
        $('#ChangePasBtn').addClass('hide');
        document.getElementById('EmpLabel').innerText = ""
        document.getElementById('AcctLabel').innerText = ""
        $('#EmpyAcctBtn').addClass('hide');
        $('#AcctBtn').addClass('hide');
        document.getElementById("ErrorMagPass").innerHTML = ""
        document.getElementById("ErrorMagConfPass").innerHTML = ""
        document.getElementById('EmpLabel').innerText = ""
        document.getElementById('AcctLabel').innerText = ""
        this.setState({ PassNTB: "", ConPasNTB: "", DisableFields: true })
    }
    /*
    * Ref no: UP_PC_43
    * 
    * Multisite checkbox change event call
    * */
    MultiSiteCheckBtn = () => {
        let UserRoleSelected = this.state.SelectUserRole
        let SelectSiteValue = this.state.SelectSite
        let SiteValue = ""
        SiteValue = this.state.selectSiteID
        if (this.state.SiteList.length > 0) {
            SiteValue = this.state.SelectSite.value
        }
        else {
            SiteValue = this.state.GroupID
        }
        console.log(SiteValue)
        let EnableMulti = "N"
        console.log("SelectSiteValue", SiteValue)
        let OLPriorityOrder = $('#MultiSelectUP').is(":checked") ? true : false //{/*NEW***changed**(id)customCheck7-->MultiSelectUP*/}
        if (SiteValue != "Select") {
            document.getElementById('ErrorMagSite').innerText = ""
            if (OLPriorityOrder == true) {
                let MultiSiteCheckedBo = {
                    Selected_UserType: this.state.SelectUsertype,
                    Session_UserRole: UserRoleSelected.Role,
                    MultiSiteChecked: true,
                    Query_Mexico: "NO",
                    SelectedUserBu: SiteValue
                }
                ProfileAction.GetMultiSite(MultiSiteCheckedBo)
                EnableMulti = "N"
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            }
            else {
                $('#MultiSelectDD').addClass('hide');
            }
        }
        else {
            OLPriorityOrder = false
            document.getElementById('ErrorMagSite').innerText = "Please select site"
        }
        this.setState({ MultiSiteChecked: OLPriorityOrder, MultiSiteEnable: EnableMulti })
    }
    /*
    * Ref no:UP_PC_58
    * 
    * MultiSite dropdown is binded 
    * */
    BindMultiSiteDD = () => {
        let MultiSite = JSON.parse(ProfileStore.MultiSiteBO);
        let SelectSiteValue = this.state.SelectSite;
        let Site = ""
        //if (SelectSiteValue.length == 0) {
        //Site = this.state.selectSiteID
        //}
        //else {
        //    Site = SelectSiteValue[0].value
        //}
        if (this.state.SiteList.length > 0) {
            Site = this.state.SelectSite.value
        }
        else {
            Site = this.state.GroupID
        }
        console.log("MultiSite", MultiSite)
        let MultiSiteListdata = MultiSite.Table
        let MultiSlectList = []
        let MultiSelectValue = []
        MultiSiteListdata.map((val, index) => {
            if (val.BUSINESS_UNIT == Site) {
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCRIPTION,
                    disabled: true
                }
                //SiteTitle = val.DESCRIPTION;
                MultiSlectList.push(localArray)
                MultiSelectValue.push(localArray)
            }
            else {
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCRIPTION
                }
                MultiSlectList.push(localArray)
            }
        });
        if (this.state.MultiSiteEnable == "N" || this.state.PageAction == "ADD") {
            $('#MultiSelectDD').removeClass('hide');
        }
        this.setState({
            MultiSite: MultiSlectList, MultiSiteSelected: MultiSelectValue
        })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
    * Ref no:UP_PC_59
    * This method is invoked when the save button is clicked in the user profile tab
    * validation is clicked
    * */
    btnSave_Click = () => {
        //debugger
        let FirstNameVal = $('#FirstNTB').val();
        let lastNameVal = $('#LastNTB').val();
        let PhoneNum = $('#PhoneNumNTB').val();
        let EmailIdValue = $('#EmailNTB').val();
        let PasswordValue = $('#PassNTB').val();
        let COnfirmPasValue = $('#ConPasNTB').val();
        let VendorIDVALUE = $('#VendorID').val();
        //11/8/22, PS_WW-538_02 - Emptying the user ID, Dhevanesam R]
        $('#ManuallyUserIdTb').val('');
        document.getElementById("ErrorMagUserId").innerText = "";

        let SelectUserRoleAdd = this.state.SelectUserRole
        let UserTypeSelected = this.state.SelectUsertype;
        let role = SelectUserRoleAdd.value
        document.getElementById('EmpLabel').innerText = ""
        document.getElementById('AcctLabel').innerText = ""

        if (role == null || role == "" || role == undefined) {
            role = "SELECT";

        }
        let ErrorValidation = 0
        if ((!VendorIDVALUE || this.state.VendorIdValidate != 0) && UserTypeSelected == "V") {
            ErrorValidation = 1
            if (!VendorIDVALUE) {
                document.getElementById("VendorGroupValue").innerHTML = "Please enter vendor id";
                $('#VendorGroupValue').addClass('errorcolour');
                $('#VendorGroupValue').removeClass('GreenColour');
            }
            else {
                document.getElementById("VendorGroupValue").innerHTML = "Entered Vendor ID is Invalid";
                $('#VendorGroupValue').addClass('errorcolour');
                $('#VendorGroupValue').removeClass('GreenColour');
            }
        }
        else {
            document.getElementById("VendorGroupValue").innerHTML = "";
            $('#VendorGroupValue').addClass('GreenColour');
        }
        if (!FirstNameVal) {
            ErrorValidation = 1
            document.getElementById("ErrorMagFirstName").innerHTML = "Please enter first name";
        }
        else {
            document.getElementById("ErrorMagFirstName").innerHTML = "";
        }
        if (role.toUpperCase() == "SELECT" && this.state.DisableTypeDD == false ) {
            ErrorValidation = 1
            document.getElementById("ErrorMegSite").innerHTML = "Please select user type";
        }
        else {
            document.getElementById("ErrorMegSite").innerHTML = "";
        }
        if (!lastNameVal) {
            ErrorValidation = 1
            document.getElementById("ErrorMagLastName").innerHTML = "Please enter last name";
        }
        else {
            document.getElementById("ErrorMagLastName").innerHTML = "";
        }
        if (!EmailIdValue) {
            ErrorValidation = 1
            document.getElementById("ErrorMagEMailAdd").innerHTML = "Please enter email address";
        }
        else {
            document.getElementById("ErrorMagEMailAdd").innerHTML = "";
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(EmailIdValue)) {
                ErrorValidation = 1
                document.getElementById("ErrorMagEMailAdd").innerHTML = "Please enter valid email address";

            }
        }
        ///****NEW******phone num issue (errror msg)_--> !phoneNum-->!=
        const NumRegex = SDIConstants.quantityRegEX;

        if (PhoneNum.length == 0 || !NumRegex.test(PhoneNum)) {
            console.log("On phone change:", PhoneNum);
            ErrorValidation = 1
            document.getElementById("ErrorMagPhone").innerHTML = "Please enter phone number";
        }
        else {
            document.getElementById("ErrorMagPhone").innerHTML = "";
            if (PhoneNum.length < 10 && NumRegex.test(PhoneNum)) {
                ErrorValidation = 1
                document.getElementById("ErrorMagPhone").innerHTML = "Please enter valid phone Number";
            }

        }
        if (!PasswordValue && this.state.ChangePasswordEnable == "Y") {
            ErrorValidation = 1
            document.getElementById("ErrorMagPass").innerHTML = "Please enter password";
        }
        else {
            document.getElementById("ErrorMagPass").innerHTML = "";
            //let firstletter2 = PasswordValue.slice(0, 1)
            if ((this.state.ChangePasswordEnable == "Y" || this.state.PageAction == "ADD")) {

                //*************************Commented below password strength validation & added new Regex validation************************************
                //if (PasswordValue.length < 6) {
                //    ErrorValidation = 1
                //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!"
                //}
                //else if ((/[a-zA-Z]/).test(firstletter2) == false || PasswordValue.match(/[0-9]/g) == null || PasswordValue.match(/[0-9]/g) == undefined || PasswordValue.match(/[0-9]/g) == "") {
                //    ErrorValidation = 1
                //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least 1 number and 1 letter - must start with a letter!"
                //}

                //****************************End of commenting password validation*********************************************************

                //Added below Regex password strength validation

                if (passwrdRegex.test(PasswordValue) == false) {
                    ErrorValidation = 1
                    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters."
                }
                else if (PasswordValue.length > 128) {
                    ErrorValidation = 1
                    document.getElementById("ErrorMagPass").innerHTML = "Password must be within 128 characters!"
                }
                else {
                    document.getElementById("ErrorMagPass").innerHTML = "";
                }
            }
        }
        if (!PasswordValue && (this.state.ChangePasswordEnable == "Y" || this.state.PageAction == "ADD")) {
            ErrorValidation = 1
            document.getElementById("ErrorMagPass").innerHTML = "Please enter password";
        }
        else {
            document.getElementById("ErrorMagPass").innerHTML = "";
            let firstletter = PasswordValue.slice(0, 1)
            if ((this.state.ChangePasswordEnable == "Y" || this.state.PageAction == "ADD")) {

                //*************************Commented below password strength validation & added new Regex validation************************************
                //if (PasswordValue.length < 6) {
                //    ErrorValidation = 1
                //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!"
                //}
                //else if ((/[a-zA-Z]/).test(firstletter) == false || PasswordValue.match(/[0-9]/g) == null || PasswordValue.match(/[0-9]/g) == undefined || PasswordValue.match(/[0-9]/g) == "") {
                //    ErrorValidation = 1
                //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least 1 number and 1 letter - must start with a letter!"
                //}

                //****************************End of commenting password validation*********************************************************

                //Added below Regex password strength validation

                if (passwrdRegex.test(PasswordValue) == false) {
                    ErrorValidation = 1
                    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters."
                }
                else if (PasswordValue.length > 128) {
                    ErrorValidation = 1
                    document.getElementById("ErrorMagPass").innerHTML = "Password must be within 128 characters!"
                }
                else {
                    document.getElementById("ErrorMagPass").innerHTML = "";
                }
            }
        }
        if (!COnfirmPasValue && (this.state.ChangePasswordEnable == "Y" || this.state.PageAction == "ADD")) {
            ErrorValidation = 1
            document.getElementById("ErrorMagConfPass").innerHTML = "Please enter confirm password";
        }
        else if (PasswordValue != COnfirmPasValue && (this.state.ChangePasswordEnable == "Y" || this.state.PageAction == "ADD")) {
            ErrorValidation = 1
            document.getElementById("ErrorMagConfPass").innerHTML = "Password doesn't match";
        }
        else {
            document.getElementById("ErrorMagConfPass").innerHTML = "";
            let firstletter1 = COnfirmPasValue.slice(0, 1)
            if ((this.state.ChangePasswordEnable == "Y" || this.state.PageAction == "ADD")) {

                //*************************Commented below password strength validation & added new Regex validation************************************
                //if (COnfirmPasValue.length < 6) {
                //    ErrorValidation = 1
                //    document.getElementById("ErrorMagConfPass").innerHTML = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!"
                //}
                //else if ((/[a-zA-Z]/).test(firstletter1) == false || COnfirmPasValue.match(/[0-9]/g) == null || COnfirmPasValue.match(/[0-9]/g) == undefined || COnfirmPasValue.match(/[0-9]/g) == "") {
                //    ErrorValidation = 1
                //    document.getElementById("ErrorMagConfPass").innerHTML = "Password must contain at least 1 number and 1 letter - must start with a letter!"
                //}

                //****************************End of commenting password validation*********************************************************

                //Added below Regex password strength validation

                if (passwrdRegex.test(COnfirmPasValue) == false) {
                    ErrorValidation = 1
                    document.getElementById("ErrorMagConfPass").innerHTML = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters."
                }
                else if (COnfirmPasValue.length > 128) {
                    ErrorValidation = 1
                    document.getElementById("ErrorMagConfPass").innerHTML = "Password must be within 128 characters!"
                }
                else {
                    document.getElementById("ErrorMagConfPass").innerHTML = "";
                }
            }
        }
        let SelectSiteValue = this.state.SelectSite;
        let SiteSelected = ""
        //SiteSelected = SelectSiteValue.value
        //if (this.state.SiteList.length > 1) {
        //    SiteSelected = SelectSiteValue.value
        //}
        //else if (this.state.PageAction != "ADD"){
        //    SiteSelected = this.state.GroupID
        //}
        //debugger
        if (this.state.SiteList.length > 0) {
            SiteSelected = SelectSiteValue.value
        }
        else {
            SiteSelected = this.state.GroupID
        }
        console.log("SiteSelected", SiteSelected)
        if ((SiteSelected == "" || SiteSelected.toUpperCase() == "SELECT" || SiteSelected == "1") && this.state.SiteList.length > 0) {
            ErrorValidation = 1
            document.getElementById("ErrorMagSite").innerHTML = "Please select site";
        }
        else {
            document.getElementById("ErrorMagSite").innerHTML = "";
        }
        //let UserTypeSelected = this.state.SelectUsertype;
        if (this.state.SelectUsertype != "V" && this.state.ManuallyAddUserId != "V" && this.state.ManuallyAddUserId != "A" && ErrorValidation == 0 && this.state.ManuallyAddUserId != "" && this.state.PageAction == "ADD") {
            $('#UserIdModal').modal('show');
        }
        else if (ErrorValidation == 0) {
            this.UpdateUserProfile()
        }
    }
    /*
    * Ref no:UP_PC_60
    * 
    * In this method the UpdateUserDetails action method is invoked to update or add user.
    * */
    UpdateUserProfile = () => {
        //debugger;
        window.scrollTo(0, 0)
        let UserIdTb = $('#TBUserid').val();
        let FirstNameVal = $('#FirstNTB').val();
        let lastNameVal = $('#LastNTB').val();
        let PhoneNum = $('#PhoneNumNTB').val();
        let EmailIdValue = $('#EmailNTB').val();
        let PasswordValue = $('#PassNTB').val();
        let ManuallyUserId = $('#ManuallyUserIdTb').val();
        let VendorId = $('#VendorID').val();
        let UserTypeSelected = this.state.SelectUsertype;
        let MultiSiteEnable = $('#MultiSelectUP').is(":checked") ? "TRUE" : "FALSE"; {/*NEW***(1/25/2021)changed**(id)customCheck7-->MultiSelectUP*/ }
        let MultiSitelist = []
        if (MultiSiteEnable == "TRUE") {

            if (this.state.selectedMultiSites.length > 0) {
                this.state.selectedMultiSites.map((val, index) => {
                    MultiSitelist.push(val.BUSINESS_UNIT)
                });
            }
        }
        //if (MultiSitelist != null && MultiSitelist != undefined) {
        //    if (MultiSitelist.length < 1) {
        //        $('#MultiSelectDD').addClass('hi');

        //    }
        //}
        let ValidationMsg = true
        if (this.state.PageAction == "ADD" && UserTypeSelected != "V") {
            //11/8/22, PS_WW-538_02 - Adding trim to check User ID, Dhevanesam R]
            if (ManuallyUserId.trim() == "" || ManuallyUserId == null || ManuallyUserId == undefined) {
                document.getElementById("ErrorMagUserId").innerHTML = "Please enter user id";
                ValidationMsg = false
            }
        }
        //WW-319 Order Status Alerts to Default to All Checked - Deepthi
        this.setState({ UserIDAdded: ManuallyUserId, UserRoleAdded: this.state.SelectUserRole, UserEmailAdded: EmailIdValue });
        let DepartmentAdd = []
        DepartmentAdd = this.state.DepartMent
        let Depart = "";
        if (UserTypeSelected == "S") {
            Depart = DepartmentAdd.value;
        }
        if (this.state.PageAction == "ADD") {
            if (this.state.LoginUserRole == "CORP ADMIN" || this.state.LoginUserRole == "ADMIN") {
                UserTypeSelected = "C"
            }
        }
        let SelectUserRoleAdd = this.state.SelectUserRole
        let ThirdpartyId = SelectUserRoleAdd.Third;
        let SelectSiteValue = this.state.SelectSite;
        let SiteSelected = ""
        SiteSelected = SelectSiteValue.value
        if (this.state.SiteList.length > 1) {
            SiteSelected = SelectSiteValue.value
        }
        else {
            SiteSelected = this.state.GroupID
        }
        console.log("SiteSelected", SiteSelected)
        //debugger;
        let UserROleSelected = SelectUserRoleAdd.Role;
        console.log("UserROleSelected", UserROleSelected);
        if (UserROleSelected != undefined) {
            if (UserROleSelected.toUpperCase() == "CORP ADMIN") {
                UserROleSelected = "CORPADMIN"
            }
        }
        let LoginRole = this.state.LoginUserRole
        if (this.state.LoginUserRole == "CORP ADMIN") {
            LoginRole = "CORPADMIN"
        }
        if (ValidationMsg == true) {
            if (this.state.PageAction == "ADD") {
                $('#UserIdModal').modal('hide');
            }
            let updateprofileBo = {
                Session_UserID: this.state.Login_UserId,
                lblUserIDHide: this.state.LoginHideuserId,
                UserID: UserIdTb,
                ManuallyEntered_UserId: ManuallyUserId.toUpperCase(),
                ThirdParty_CompanyID: ThirdpartyId,
                VendorID: VendorId,
                SiteValue: SiteSelected,
                UserType: UserTypeSelected,
                Session_UserType: this.state.LoginUserType,
                UserRole: UserROleSelected,
                Session_Role: LoginRole,
                FirstName: FirstNameVal,
                LastName: lastNameVal,
                UserEmailID: EmailIdValue,
                UserPhoneNum: PhoneNum,
                UserDepart: Depart,
                Page_Action: this.state.PageAction,
                Query_IsVendor: "False",
                Query_IsMexico: "False",
                Query_IsMexicoVendor: "False",
                MultiSiteChecked: MultiSiteEnable,
                MultiSite: MultiSitelist,
                PassWord: PasswordValue,
                Flag_AddUser: this.state.ManuallyAddUserId,

            }
            console.log("updateprofileBo", updateprofileBo)
            ProfileAction.UpdateUserDetails(updateprofileBo)
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
    }
    /*
    * Ref no: UP_PC_62
    * 
    * this method is invoke when add user button is clicked.
    * */
    AddUser = () => {

        $('#VendorDiv').addClass('hide');
        $('#SearchDIv').addClass('hide');
        $('#MultiSelectDD').addClass('hide');
        $('#EmpyAcctBtn').addClass('hide');
        $('#AcctBtn').addClass('hide');
        $('#EmpLabel').addClass('hide');
        $('#AcctLabel').addClass('hide');
        $('#EditMode').removeClass('hide');
        $('#AddUserBtn').addClass('hide');
        $('#approvalsTab').addClass('hide');
        $('#privilegesTab').addClass('hide');
        $('#orderSETab').addClass('hide');
        $('#preferencesTab').addClass('hide');
        $('#mobilityTab').addClass('hide');
        $('#zeusTab').addClass('hide');
        $('#sditrackTab').addClass('hide');
        $('#PassDiv').val('');
        $('#ConfPassDiv').val('');
        $('#ManuallyUserIdTb').val('');
        document.getElementById("VendorGroupValue").innerText = "";
        document.getElementById("ErrorMagFirstName").innerText = "";
        document.getElementById("ErrorMagLastName").innerText = "";
        document.getElementById("ErrorMagEMailAdd").innerText = "";
        document.getElementById("ErrorMagPhone").innerText = "";
        document.getElementById("ErrorMagPass").innerText = "";
        document.getElementById("ErrorMagConfPass").innerText = "";
        document.getElementById("ErrorMagSite").innerText = "";
        document.getElementById("ErrorMegSite").innerText = "";
        document.getElementById("EmpLabel").innerText = "";
        document.getElementById("AcctLabel").innerText = "";
        document.getElementById("StatusMsg").innerText = "";
        //11/8/22, PS_WW-538_02 - Emptying the user ID, Dhevanesam R]
        document.getElementById("ErrorMagUserId").innerText = "";
        document.getElementById("MultiSelectUP").checked = false; //{/*NEW***(1/25/2021)changed**(id)customCheck7-->MultiSelectUP*/ }
        let SelectTypeL = this.state.SelectUsertype
        let SiteListDD = this.state.SiteList
        if (this.state.LoginUserRole.toUpperCase() == "SUPER" && this.state.LoginUserType.toUpperCase() == "S") {
            SelectTypeL = "S"
            SiteListDD = []
            let SiteListvalue = this.state.PageLoadSiteList
            SiteListvalue.map((val, index) => {
                if (index == 0) {
                    let siteLocal = {
                        value: "Select",
                        label: "Select Site"
                    }
                    SiteListDD.push(siteLocal)
                }
                let localArray = {
                    value: val.GROUPID,
                    label: val.GROUPNAME
                }
                if (val.GROUPID != undefined && val.GROUPNAME != undefined) {
                    SiteListDD.push(localArray)
                }
            });
            if (SiteListDD.length == 0) {
                SiteListvalue.map((val, index) => {
                    if (index == 0) {
                        let siteLocal = {
                            value: "Select",
                            label: "Select Site"
                        }
                        SiteListDD.push(siteLocal)
                    }
                    let localArray = {
                        value: val.BUSINESS_UNIT,
                        label: val.DESCRIPTION
                    }
                    SiteListDD.push(localArray)
                });
            }
        }
        if (this.state.ChangePasswordEnable == "N") {
            $('#PassDiv').removeClass('hide');
            $('#ConfPassDiv').removeClass('hide');
            $('#ChangePasBtn').addClass('hide');
        }
        let Rolelist = this.state.UserRoleDD
        let Userroleddl = []
        if (this.state.LoginUserType == "S") {
            if (this.state.LoginUserRole == "CORP ADMIN" || this.state.LoginUserRole == "ADMIN") {
                $('#DepartDiv').addClass('hide');
            }
        }
        if (SelectTypeL == "V") {
            $('#VendorDiv').removeClass('hide');
            $('#MultiDiv').addClass('hide');
            $('#DepartDiv').addClass('hide');
        }
        // let Selectvalue = []
        Rolelist.map((val, index) => {
            //debugger
            if (index == 0 && this.state.LoginUserRole == "ADMIN" && this.state.LoginUserType == "S") {
                let localArray = {
                    value: "Corp Admin",
                    label: "Corp Admin",
                    key: this.state.SiteTitleValue,
                    Role: "Corp Admin",
                    Third: "0",
                }
                Userroleddl.push(localArray)

            }
            if (this.state.LoginUserRole == "CORP ADMIN" && val.value != "Corp Admin") {
                Userroleddl.push(val)
            }
            if (this.state.LoginUserRole == "SUPER" && val.value == "Super") {
                Userroleddl.push(val)
            }

            if (val.value != "Corp Admin" && val.value != "Super") {
                Userroleddl.push(val)
            }
        });
        console.log("LoginUserRole", this.state.LoginUserRole)
        console.log("Userroleddl", Userroleddl)
        let DisableTypeDDL = this.state.SiteList.length > 0 ? true : false
        //let SiteListDD = this.state.SiteList
        //if (SiteListDD.length > 0) {
        //    SiteListDD.map((val, index) => {
        //        if (index == 0) {
        //            let localArray = {
        //                value: "Select",
        //                label: "Select "
        //            }
        //            Userroleddl.push(localArray)
        //            Selectvalue = localArray
        //        }
        //            let localArray = {
        //                value: val.BUSINESS_UNIT,
        //                label: val.DESCRIPTION
        //            }
        //            if (val.BUSINESS_UNIT == Site) {
        //                SiteValue = localArray
        //            }
        //            SiteListDD.push(localArray)
        //        });

        //}

        let ThirdPartyListL = this.state.ThirdPartyList

        let Usertypes = [{ Role: "Admin" }, { Role: "User" }]
        let UserROleLocal = [];
        let UserRoleSelect = {};
        if (this.state.LoginUserType == "S" && this.state.LoginUserRole.toUpperCase() == "ADMIN") {
            if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") == "0") {
                //debugger
                if (ThirdPartyListL.length > 0) {

                    ThirdPartyListL.map((ThirdParty, index1) => {

                        if (index1 == 0) {
                            Usertypes.map((val, index2) => {
                                if (index2 == 0) {
                                    let localArray1 = {
                                        value: "Corp Admin",
                                        label: "Corp Admin",
                                        key: this.state.SiteTitleValue,
                                        Role: "Corp Admin",
                                        Third: "0",
                                    }
                                    UserROleLocal.push(localArray1)
                                }
                                let localArray = {
                                    value: val.Role,
                                    label: val.Role,
                                    key: this.state.selectSiteID,
                                    Role: val.Role,
                                    Third: "0",
                                }
                                UserROleLocal.push(localArray)

                            });
                        }
                        Usertypes.map((val, index3) => {

                            let localArray = {
                                value: ThirdParty.COMPANY_NAME + "  " + val.Role,
                                label: ThirdParty.COMPANY_NAME + "  " + val.Role,
                                key: this.state.selectSiteID,
                                Role: val.Role,
                                Third: ThirdParty.THIRDPARTY_COMP_ID,
                            }
                            UserROleLocal.push(localArray)

                        });
                    });
                }
                else {
                    Usertypes.map((val, index2) => {

                        let localArray = {
                            value: val.Role,
                            label: val.Role,
                            key: this.state.selectSiteID,
                            Role: val.Role,
                            Third: "0",
                        }
                        UserROleLocal.push(localArray)

                    });
                }
            }

        }
        else {
            UserROleLocal = Userroleddl
        }
        let site = {
            value: "Select",
            label: "Select Site"
        }

        let Selectvalue = {
            value: "Select",
            label: "Select Type",
            key: "",
            Role: "",
            Third: "",
        }
        let Departmentdefault = {
            value: "",
            label: "-----Select Department-----"
        }

        let SDIEMp = this.state.SDIEMp
        let CustomerL = this.state.Customer
        let vendor = this.state.vendor

        if (this.state.LoginUserType == "S") {
            SDIEMp = true
            CustomerL = false
            vendor = false
            document.getElementById("UtypeSDI").checked = true;
            document.getElementById("UtypeCustomer").checked = false;
            document.getElementById("UtypeVendor").checked = false;

        }

        this.setState({
            SelectedUserId: "", FirstName: "", LastName: "", SelectUsertype: SelectTypeL, SiteList: SiteListDD,
            EmailAddres: "", PhoneNum: "", PassNTB: "", ConPasNTB: "", PageAction: "ADD", ChangePasswordEnable: "Y", adduser: true, UserRoleDD: UserROleLocal, SelectUserRole: Selectvalue,
            SelectSite: site, VendorId: "", DepartMent: Departmentdefault, DisableTypeDD: DisableTypeDDL, MultiSiteChecked: false, SDIEMp: SDIEMp, Customer: CustomerL, vendor: vendor
        })
    }
    /*
     * Ref no: UP_PC_63
    * To reload the page
    * 
    * */
    EditUser = () => {
        window.location.reload(false);
    }
    /*
    * Ref no: UP_PC_61
    * 
    * This method is invoked when the action response for update user details is return.
    * The update status is shown as message to the user
    * */
    ShowEditMessage = () => {
        //debugger
        const { t } = this.props;
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let edituser = JSON.parse(ProfileStore.AddUserBO);
        console.log("edituser", edituser)
        window.scrollTo(0, 0)
        document.getElementById('StatusMsg').innerText = ""
        if (edituser.Table1.length > 0) {
            let ErrorTable = edituser.Table1;
            if (ErrorTable[0].PasswordExist == "Error - password has already been used") {
                $('#PassDiv').val('');
                $('#ConfPassDiv').val('');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    //5340 - Bug Nandhini L - 09/24/24
                    text: t("Error - This password has already been used. Please choose a different one")
                    //text: t("Error - password has already been used")
                });
                // alert(t("Error - password has already been used"))
            }
            else if (ErrorTable[0].UserIdExist == "User ID already exists") {
                $('#ManuallyUserIdTb').val('');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("User ID already exists")
                });
                //   alert(t("User ID already exists"))
            }
            else if (ErrorTable[0].UserIdFormatError != null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: ErrorTable[0].UserIdFormatError
                });
                //  alert(ErrorTable[0].UserIdFormatError)
            }
            else if (ErrorTable[0].InvalidUserId == "Invalid User ID") {
                $('#ManuallyUserIdTb').val('');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Invalid User ID")
                });
                // alert(t("Invalid User ID"))
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Technical issue")
                });
                // alert(t("Technical issue"))
            }
        }
        else {
            let UpdateSuccess = edituser.Table2
            if (UpdateSuccess.length > 0) {
                if (UpdateSuccess[0].AddUserMessage != null) {
                    //WW-319 Order Status Alerts to Default to All Checked - Deepthi
                    this.DefaultOSECheck(UpdateSuccess[0].AddUserMessage);
                    document.getElementById('StatusMsg').innerText = UpdateSuccess[0].AddUserMessage
                    let Rolelist = this.state.UserRoleDD
                    let Userroleddl = []
                    Rolelist.map((val, index) => {
                        Userroleddl.push(val)
                    });
                    let DisableTypeDDL = this.state.SiteList.length > 0 ? true : false
                    let site = {
                        value: "Select",
                        label: "Select Site"
                    }
                    let Selectvalue = {
                        value: "Select",
                        label: "Select Type",
                        key: "",
                        Role: "",
                        Third: "",
                    }
                    let Departmentdefault = {
                        value: "",
                        label: "-----Select Department-----"
                    }

                    $('#PassDiv').val('');
                    $('#ConfPassDiv').val('');
                    $('#ManuallyUserIdTb').val('');
                    //11/8/22, PS_WW-538_02 - Emptying the user ID, Dhevanesam R]
                    document.getElementById("ErrorMagUserId").innerText = "";
                    this.setState({
                        SelectedUserId: "", FirstName: "", LastName: "",
                        EmailAddres: "", PhoneNum: "", PassNTB: "", ConPasNTB: "", PageAction: "ADD", ChangePasswordEnable: "Y", adduser: true, UserRoleDD: Userroleddl, SelectUserRole: Selectvalue,
                        SelectSite: site, VendorId: "", DisableTypeDD: DisableTypeDDL, DepartMent: Departmentdefault
                    })
                    //if (this.state.PageAction == "ADD") {
                    //    window.location.reload(false);
                    //}
                }
                else {
                    //WW-889 Home page does not open after changing password - Nandhini L
                    if (UpdateSuccess[0].PasswordValidation == 'true') {
                        console.log(this.state.SelectedUserId)
                        if (this.state.Login_UserId == this.state.SelectedUserId) {
                            $('#changePassword_Popup').modal('show')
                        }
                        else {
                            document.getElementById('StatusMsg').innerText = UpdateSuccess[0].EditUserMessage
                        }
                    }
                    else {
                        document.getElementById('StatusMsg').innerText = UpdateSuccess[0].EditUserMessage
                    }
                    CookieService.updateLocalStorageValues("newlanguage", this.state.language);
                    let Filecheck = CookieService.getLocalStorageValues("resultMessage");
                    if (Filecheck) {
                        const localStorageLanguageCode = this.state.language
                        let result = JSON.parse(Filecheck[0].result)
                        const langResult = result[0].messages;
                        const displayDateTimeStart = ConvertToEst(result[0].displayDateTimeStart);
                        const outageDateTimeStart = ConvertToEst(result[0].outageDateTimeStart);
                        const outageDateTimeEnd = ConvertToEst(result[0].outageDateTimeEnd);
                        const filteredLangResult = langResult.find(msg => msg.languageCode === localStorageLanguageCode.value);
                        let externalMessage = filteredLangResult && filteredLangResult.externalMessage;
                        externalMessage = externalMessage
                            .replace('outageDateTimeStart', outageDateTimeStart)
                            .replace('outageDateTimeEnd', outageDateTimeEnd);

                        CookieService.updateLocalStorageValues("displayText", externalMessage);
                    }

                    i18n.changeLanguage(this.state.language.value);
                    //WW-319 Order Status Alerts to Default to All Checked - Deepthi
                    this.setState({ IsNewUserCreated: false });
                }
            }
        }

    }

    logout = () => {
        $('#changePassword_Popup').modal('hide');
        let newlang = CookieService.getLocalStorageValues("newlanguage");
        let lastversion = CookieService.getLocalStorageValues("lastVersion");
        CookieService.setCookieValues(SDIConstants.access_token, "", -1);
        localStorage.clear();
        CookieService.updateLocalStorageValues("lastVersion", lastversion);
        let lv = CookieService.getLocalStorageValues("lastVersion");
        CookieService.updateLocalStorageValues("newlanguage", newlang);
        CookieService.updateLocalStorageValues("isSSOClick", false);
        CookieService.updateLocalStorageValues("isLogout", true);
        this.props.history.push({
            pathname: '/',
        });
    }

    /*
    * Ref no:UP_PC_42
    * 
    * This method is invoke when the value is entered into the vendor id text box.
    * */
   //WW-1312 Vendor ID Removal -Nandhini L
    //VendorIdChaneg = () => {
    //    let VendorId = $('#VendorID').val();
    //    if (VendorId == "" || VendorId == null) {
    //        document.getElementById('VendorGroupValue').innerText = "Enter the vendor ID"
    //    }
    //    else {
    //        let VendorIDBo = {
    //            Entered_VendorId: VendorId
    //        }
    //        ProfileAction.GetVendorGroup(VendorIDBo);
    //        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    //    }
    //}
    /*
    * Ref no:UP_PC_57
    * 
    * In this method the vendor id check response is binded to the Vendorgroupvalue label.
    * */
    //WW-1312 Vendor ID Removal -Nandhini L
    //BindVendorSite = () => {
    //    let VendorGroupData = JSON.parse(ProfileStore.VendorIdCheckBO);
    //    $(`#${SDIConstants.SDILoader}`).addClass('hide');
    //    let VendorExist = []
    //    VendorExist = VendorGroupData.dsVendorExist
    //    if (VendorExist.length > 0) {
    //        document.getElementById('VendorGroupValue').innerText = VendorExist[0].Vendor_CompanyName
    //        $('#VendorGroupValue').removeClass('errorcolour');
    //        $('#VendorGroupValue').addClass('GreenColour');

    //        this.setState({ VendorIdValidate: 0 })
    //    }
    //    else {
    //        let errortable = VendorGroupData.Error_Table
    //        document.getElementById('VendorGroupValue').innerText = errortable[0].VendorId_NotExist
    //        $('#VendorGroupValue').addClass('errorcolour');
    //        $('#VendorGroupValue').removeClass('GreenColour');
    //        this.setState({ VendorIdValidate: 1 })
    //    }
    //}
    /*
    * Ref no:UP_PC_46
    * This method is invoked when the Privilege type is changed.
    * The action method GetPrivilegesType is invoked to get the data using api method.
    * */
    OnchangePrivType = (Type) => {
        document.getElementById('StatusMsg').innerText = ""
        if (Type != "1") {
            SelectAll = true
            //   $('#SelPrivBtn').removeClass('hide');
            //  $('#DeSelPrivBtn').removeClass('hide');
            let SiteSelected = this.state.SelectTab2Site.value
            let UserTypeSelected = this.state.SelectUsertype;
            let UserROleSelected = this.state.SelectUserRole.Role;
            let PrivilegeTypeBO = {
                PriviTypeIndex: Type,
                UserRoleSelected: "",
                UserId: this.state.SelectedUserId,
                Page_Action: this.state.PageAction,
                Query_IsMexicoVendor: "False",
                Query_IsVendor: "False",
                SiteValue: SiteSelected,
                UserType: UserTypeSelected,
                UserRole: UserROleSelected,
            }
            ProfileAction.GetPrivilegesType(PrivilegeTypeBO)
            this.setState({ DisablePrivRole: true, isExpandAll: true, selectDisplay: false, SelectROleList: [] })
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        else {
            SelectAll = false
            //   $('#SelPrivBtn').addClass('hide');
            //   $('#DeSelPrivBtn').addClass('hide');
            //WW-1229 Home tiles -Nandhini L
            let checkedvalue = []
            let UserHomeTilesList = [];

            if (this.state.TilesList && this.state.TilesList.length > 0) {
                let userHomeTilesMap = new Map(this.state.UserHomeTilesList.map(tile => [tile.SECURITYALIAS, tile]));
                this.state.TilesList.forEach(tile => {
                    if (tile.DEFAULT_TILE === 'Y') {
                        const temp = this.state.TilesList.find(Temptile => Temptile.SECURITYALIAS === tile.SECURITYALIAS);
                        let updatedTile = { ...temp, tilePrivCheck: false };
                        UserHomeTilesList.push(updatedTile);
                        userHomeTilesMap.set(tile.SECURITYALIAS, tile);
                    }
                });
            }

            this.setState({
                DisablePrivRole: false, PrivTreeDisable: true, checked: checkedvalue, UserHomeTilesList: UserHomeTilesList, selectDisplay: true, SelectROleList: [], isSelectAll: true
            }, () => {
                this.BindHomeTiles()
            });
        }
    }
    /*
    * This method is invoked when the privileges type action response is emitted
    * If Alacart is the type then the privileges tree is checked with the alacrt privileges
    * 
    * */
    BindPrivilegeOnType = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PrivilegeTypeBO = JSON.parse(ProfileStore.PrivilegeTypeBO);
        console.log("PrivilegeTypeBO", PrivilegeTypeBO)
        let checkvalues = []
        //WW-1229 Home tiles -Nandhini L
        let homeTilesChecked = [];
        let AlacartProgramTableValue = PrivilegeTypeBO.AlacartProgramTable
        let UserTiles = PrivilegeTypeBO.UserTilesList
        let TilesList = PrivilegeTypeBO.TilesList
        let UserHomeTilesList = PrivilegeTypeBO.UserHomeTilesList
        let flagValues = PrivilegeTypeBO.flagValues && PrivilegeTypeBO.flagValues.length > 0 ? PrivilegeTypeBO.flagValues : [];
        flagValues = this.state.flagOptions.filter(opt => flagValues.map(val => val.FLAG_ALIAS).includes(opt.value))
        let userHomeTilesMap = []
        AlacartProgramTableValue.map((val, index) => {
            checkvalues.push(val.SECURITYALIAS)
        });

        if (UserTiles && UserTiles.length > 0) {
            UserTiles.forEach(item => {
                homeTilesChecked.push(item.SECURITYALIAS);
            });
        }
        userHomeTilesMap = new Map(UserHomeTilesList.map(tile => [tile.SECURITYALIAS, tile]));

        TilesList.forEach(tile => {
            if (tile.DEFAULT_TILE === 'Y' && !userHomeTilesMap.has(tile.SECURITYALIAS)) {
                UserHomeTilesList.push(tile);
                userHomeTilesMap.set(tile.SECURITYALIAS, tile);
            }
        });

        UserHomeTilesList.forEach(tile => {
            tile.tilePrivCheck = homeTilesChecked.includes(tile.SECURITYALIAS);
        });
        this.setState({
            checked: checkvalues, expanded: checkvalues, PrivTreeDisable: false, UserHomeTilesList: UserHomeTilesList, TilesList: TilesList, flagValues: flagValues
        }, () => {
            this.BindHomeTiles()
        });
    }
    /*
    * Ref no:UP_PC_68
    * 
    * This method is invoked when the store emit the data for Role privileges
    * Privileges tree is checked with role based privileges
    * */
    BindPrivilegeOnRole = () => {
        let PrivilegeTypeBO = JSON.parse(ProfileStore.PrivilegeRoleBO);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        document.getElementById('StatusMsg').innerText = ""
        console.log("PrivilegeTypeBO", PrivilegeTypeBO)
        let checkvalues = []
        //WW-1229 Home tiles -Nandhini L
        let HomeTilescheckvalues = [];
        let HomeTiles = [];
        let RoleDataProgramTableValue = PrivilegeTypeBO.RoleDataProgramTable
        this.state.TilesList.forEach(tile => {
            if (tile.DEFAULT_TILE === 'Y') {
                HomeTiles.push(tile);
            }
        });
        RoleDataProgramTableValue.map((val, index) => {
            if (val.ALIAS_NAME.includes('HT-')) {
                HomeTilescheckvalues.push(val.ALIAS_NAME);
            } else {
                checkvalues.push(val.ALIAS_NAME);
            }
            this.state.TilesList.forEach(tile => {
                if (tile.SECURITYALIAS.slice(3) == val.ALIAS_NAME) {
                    HomeTiles.push(tile);
                }
            });
        });

        let TilesListUpdated = HomeTiles.map(tile => {
            tile.tilePrivCheck = HomeTilescheckvalues.includes(tile.SECURITYALIAS);
            return tile;
        });

        this.setState({
            checked: checkvalues,
            expanded: checkvalues,
            PrivTreeDisable: true,
            UserHomeTilesList: TilesListUpdated, isExpandAll: true
        }, () => {
            this.BindHomeTiles()
        });
    }
    /*
    * Ref no:UP_PC_67
    * 
    * This method is invoked when the submit button is clicked in the privileges tab.
    * */
    updatePrivilege = () => {
        let PriviIndex = "0"
        let selectrole = ""
        let RoleChecked = $('#Role').is(":checked") ? "True" : "False"
        let checkedlist = []
        let privilegelist = []
        let SelectSiteValue = this.state.SelectSite;
        let Sitedata = ""
        Sitedata = SelectSiteValue.value
        window.scrollTo(0, 0)
        if (this.state.SiteList.length > 0) {
            Sitedata = SelectSiteValue.value
        }
        else {
            Sitedata = this.state.GroupID
        }
        let PrivilegeTree = this.state.Tab2BindTree
        let PrivTreeL = this.state.PrivTree
        checkedlist = this.state.checked
        let FinalPriv = []
        //WW-703 Menu Revamping-Deepthi N H
        checkedlist.map((val, index) => {
            let PriviTree = {
                NOdeVaue: val
            }
            privilegelist.push(PriviTree)
        })
        //WW-1229 Home tiles -Nandhini L
        const UserTiles = this.state.UserHomeTilesList.filter(tile => tile.tilePrivCheck === true).map(userTile => ({ ...userTile, NOdeVaue: userTile.SECURITYALIAS }));
        if (RoleChecked == "True") {
            PriviIndex = "1"
            selectrole = this.state.SelectROleList.value
        }
        if (privilegelist.length > 1) {
            let UpdatePriviBo = {
                UserId: this.state.SelectedUserId,
                Session_UserId: this.state.Login_UserId,
                PriviTypeIndex: PriviIndex,
                UserRoleSelected: selectrole,
                PrivilegeTree: privilegelist,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                SiteValue: Sitedata,
                Session_USERTYPE: this.state.LoginUserType,
                UserTiles: UserTiles, //WW-1229 Home tiles -Nandhini L
                roleFlags: this.state.flagValues,
                onlyHomeTiles: this.state.tabrole.toUpperCase() == "USER" || this.state.LoginUserRole.toUpperCase() == "CORP ADMIN" ? true : false
            }
            ProfileAction.UpdatePrivilege(UpdatePriviBo);

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        else {
            if (RoleChecked == "True") {
                document.getElementById('StatusMsg').innerText = "Please select a role."
            }
            else {
                if (this.state.tabrole.toUpperCase() == "USER" || this.state.LoginUserRole.toUpperCase() == "CORP ADMIN") {
                    let UpdatePriviBo = {
                        UserId: this.state.SelectedUserId,
                        Session_UserId: this.state.Login_UserId,
                        PriviTypeIndex: PriviIndex,
                        UserRoleSelected: selectrole,
                        PrivilegeTree: privilegelist,
                        Session_BUSUNIT: this.state.Login_UserBU,
                        Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                        SiteValue: Sitedata,
                        Session_USERTYPE: this.state.LoginUserType,
                        UserTiles: UserTiles, //WW-1229 Home tiles -Nandhini L
                        roleFlags: this.state.flagValues,
                        onlyHomeTiles: this.state.tabrole.toUpperCase() == "USER" || this.state.LoginUserRole.toUpperCase() == "CORP ADMIN" ? true : false
                    }
                    ProfileAction.UpdatePrivilege(UpdatePriviBo);

                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                }
                else {
                    document.getElementById('StatusMsg').innerText = "Please select atleast two programs."
                }
            }
        }
    }

    /*
    * Ref no:UP_PC_69
    * In this method Privileges update status is showmn.
    * 
    * */
    ShowUpdateMesPri = () => {

        let UpdatePrivile = JSON.parse(ProfileStore.UpdatePrivilegeBO);
        let RedirectPage = []
        RedirectPage = UpdatePrivile.Redirect_Page
        let SuccessTable = []
        SuccessTable = UpdatePrivile.SuceessMessage
        if (RedirectPage.length > 0) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Update Failed"
            });
            //alert("Update Failed");
        }
        else {
            //localStorage.setItem("SDIMenu", "")
            //this.refreshMenu();
            //WW-703 Menu Revamping-Deepthi N H
            let menuBO = {
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_MenuUpdated: "False",
                Session_SDIMenu: "",
                Session_BARCODE: CookieService.getLocalStorageValues("Session_BARCODE") ? CookieService.getLocalStorageValues("Session_BARCODE") : "",
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
                Session_DEFAULTPAGE: CookieService.getLocalStorageValues("Session_DEFAULTPAGE"),
                Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
                Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
                Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERNAME: CookieService.getLocalStorageValues("Session_AGENTUSERNAME") ? CookieService.getLocalStorageValues("Session_AGENTUSERNAME") : "",
                Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
                Source: 'Web',
                Version_No: CookieService.getLocalStorageValues("currentversion") != null && CookieService.getLocalStorageValues("currentversion") != undefined ? CookieService.getLocalStorageValues("currentversion") : ""
            }
            MenuAction.getMenuItems(menuBO);
            //WW-1229 Home tiles -Nandhini L
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            if (SuccessTable[0].UpdateSuccess) {
                this.props.toastSuccessMessage(SuccessTable[0].UpdateSuccess)
                let updateSession = UpdatePrivile.SessionTable;
                if (updateSession && updateSession.length > 0) {
                    if (this.state.Login_UserId == this.state.SelectedUserId) {
                        CookieService.updateLocalStorageValues("HideMobility", updateSession[0].HideMobility);
                        if (updateSession[0].HideMobility.toUpperCase() == "TRUE") {
                            $('#mobilityTab').addClass('hide');
                        } else {
                            $('#mobilityTab').removeClass('hide');
                        }
                    }
                }
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Update Failed"
                });
            }
            //document.getElementById('StatusMsg').innerText = SuccessTable[0].UpdateSuccess
        }
        document.getElementById('StatusMsg').innerText = ""
    }
    //PC_1044_153 WW-1044 Approval  [07/05/2024] Pavithra R
    UpdateApprovals = (selectedApprovers) => {
        const { t } = this.props

        let StatusMsgError = ""

        let validation = true
        let SiteSelected = ""
        window.scrollTo(0, 0)
        if (this.state.SiteList.length > 0) {
            SiteSelected = this.state.SelectSite.value
        }
        else {
            SiteSelected = this.state.GroupID
        }
        console.log("ApprSiteSelected", SiteSelected)
        let DeleteAppr = $('#customCheckk').is(":checked") ? "TRUE" : "FALSE";
        let BudLimitset = $('#BUdLimitData').val()
        let Selectedaprover = approvalAccordian == 3 ? selectedApprovers : this.state.ExistApproveValue.value
        console.log("Selectedaprover", Selectedaprover)
        //[4/27/22, Bug - 2071, Dhevanesam R
        if (Selectedaprover == "0" || Selectedaprover == undefined) {
            //5719 - Update  a validation based on approval panel [4/22/2025] Nachiappan
            if (approvalAccordian == 1) {
                StatusMsgError = "Budgetary approval name must be selected";
            }
            else if (approvalAccordian == 2) {
                StatusMsgError = "Requestor approval name must be selected";
            }
            validation = false
            document.getElementById('StatusMsg').innerText = StatusMsgError;
            // $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        //[4/13/22, Bug - 2071, Dhevanesam R]
        if (validation) {
            //[4/13/22, Bug - 2071, Dhevanesam R
            //if (Buttype == "Définir l’approbation du demandeur" || Buttype == "Establecer la aprobación del solicitante") {
            //    Buttype = "Set Requestor Approval"
            //}
            //else if (Buttype == "Définir l’approbation budgétaire" || Buttype == "Establecer aprobación presupuestaria") {
            //Buttype = "Set Budgetary Approval"
            //}
            if (approvalAccordian == 1) {
                let UpdBudAppBo = {
                    UserId: this.state.SelectedUserId,
                    Session_UserId: this.state.Login_UserId,
                    Session_UserRole: this.state.LoginUserRole.toUpperCase(),
                    SiteValue: SiteSelected,
                    BudApp_Selected: Selectedaprover,
                    BudLimit: BudLimitset,
                    Delete_Checked: DeleteAppr,
                    Session_WEBSITED: CookieService.getLocalStorageValues("Session_WEBSITED"),
                    AppExist: this.state.ExistBudAppr,
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ProfileAction.UpdateBudgetApp(UpdBudAppBo)
                // let DeleteAppr = $('#customCheckk').is(":checked") ? "TRUE" : "FALSE";
                //[3/11/22, PC_UP_02, CAS - 31, Dhevanesam R
                if (DeleteAppr == "TRUE") {
                    let localArray1 = {
                        value: 0,
                        label: t("--------Select Approver-------"),
                    }
                    //document.getElementById("customCheckk").checked = false;
                    //[8/10/22, Bug - 2349, PS_UP_05, Dhevanesam R]
                    this.setState({ ExistApproveValue: localArray1, ExistAppLimit: "", initialApprover: Selectedaprover, initialBudAppLimit: "" })
                    if (document.getElementById("customCheckk")) {
                        document.getElementById("customCheckk").checked = false;
                    }
                }
            }
            else if (approvalAccordian == 2) {
                let UpdReqAppBo = {
                    UserId: this.state.SelectedUserId,
                    Session_UserId: this.state.Login_UserId,
                    Session_UserRole: this.state.LoginUserRole.toUpperCase(),
                    SiteValue: SiteSelected,
                    ReqApp_Selected: Selectedaprover,
                    Delete_Checked: DeleteAppr,
                    Session_WEBSITED: CookieService.getLocalStorageValues("Session_WEBSITED"),
                    AppExist: this.state.ExistApprover,
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ProfileAction.UpdateReqApp(UpdReqAppBo)
                // let DeleteAppr = $('#customCheckk').is(":checked") ? "TRUE" : "FALSE";
                //[3/11/22, PC_UP_02, CAS - 31, Dhevanesam R
                if (DeleteAppr == "TRUE") {
                    let localArray1 = {
                        value: 0,
                        label: t("--------Select Approver-------"),
                    }
                    //document.getElementById("customCheckk").checked = false;
                    //[8/10/22, Bug - 2349, PS_UP_05, Dhevanesam R]
                    this.setState({ ExistApproveValue: localArray1, ExistAppLimit: "", initialApprover: Selectedaprover, initialBudAppLimit: "" })
                    if (document.getElementById("customCheckk")) {
                        document.getElementById("customCheckk").checked = false;
                    }
                }
                //PC_1044_153 WW-1044 Approval Trigger on the click of submit, delete from alternate budgetary  [07/05/2024] Pavithra R
            } else if (approvalAccordian == 3) {
                let tempArray = [];
                let existApp = [];
                checkboxCount = 0;
                Selectedaprover.forEach((object, index) => {
                    if (object.value != " ") {
                        tempArray.push(object.value);
                        existApp.push(object);
                    }
                    $(`#AltBudgCheckbox${index + 1}`).prop('checked', false);
                    $(`#AltBudgDelIcon${index + 1}`).removeClass('del-icon-disable');

                })
                $('#AltBudgMultiselect').prop('checked', false);
                let selectedAltBudg = Array(10).fill(' ')
                for (let i = 0; i < tempArray.length; i++) {
                    selectedAltBudg[i] = tempArray[i];
                }
                /*let combinedArray = [...existApp, ...this.state.ApproverList];
                let uniqueSet = new Set(combinedArray);
                let approverList = Array.from(uniqueSet);*/
                let UpdReqAppBo = {
                    UserId: this.state.SelectedUserId,
                    Session_UserId: this.state.Login_UserId,
                    Session_UserRole: this.state.LoginUserRole.toUpperCase(),
                    SiteValue: SiteSelected,
                    ReqApp_Selected: selectedAltBudg,
                    Delete_Checked: selectedApprovers == this.state.updateAltBudgetary ? "FALSE" : "TRUE",
                    Session_WEBSITED: CookieService.getLocalStorageValues("Session_WEBSITED"),
                    AppExist: this.state.ExistApprover,
                    isMultiSelectChecked: this.state.isMultiSelectChecked
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ProfileAction.UpdateAltBudApp(UpdReqAppBo)

                this.setState({
                    ExistApproveValue: existApp, selectedApprvValue: existApp, updateAltBudgetary: existApp,
                    delAltBudCheck: existApp, delAltBudIcon: existApp, isMultiSelectChecked: false
                })
            }

        }
    }

    /*
    * Ref no:UP_PC_72
    * 
    * In this method requestor approval update status is showmn.
    * */
    ShowApprovalStatus = () => {


        let UpdateStatusL = JSON.parse(ProfileStore.UpdateReqApprovalsBO);
        let UpdateStatus = UpdateStatusL.Table1
        console.log("UpdateStatus", UpdateStatus)
        if (UpdateStatus[0].DeleteSuccess != null) {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].DeleteSuccess
            $(`#removeApprover`).addClass('hide');
        }
        else if (UpdateStatus[0].DeleteFailed != null) {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].DeleteFailed
        }

        //2377 - User Profile_ After selecting Remove checkbox alternate requestor approval dropdown value should be in disable mode.-Dhamotharan P
        else if (UpdateStatus[0].UpdateSuccess != null) {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].UpdateSuccess
            $(`#removeApprover`).removeClass('hide');
            this.setState({ ExistReqAppr: this.state.ExistApproveValue.value });
        }
        else {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].InsertFailed;
            $(`#removeApprover`).removeClass('hide');
        }
        let DeleteAppr = $('#customCheckk').is(":checked") ? "TRUE" : "FALSE";
        if (DeleteAppr == "TRUE") {
            let localArray1 = {
                value: 0,
                label: "--------Select Approver-------",
            }
            //document.getElementById("customCheckk").checked = false;
            $(`#removeApprover`).addClass('hide');
            this.setState({ ExistApproveValue: localArray1, ExistAppLimit: "" })
            document.getElementById("customCheckk").checked = false;
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R


    ShowBudApprovalStatus = () => {
        const { t } = this.props
        let UpdateStatusL = JSON.parse(ProfileStore.UpdateApprovalsBO);
        let UpdateStatus = UpdateStatusL.Table1
        console.log("UpdateStatus", UpdateStatus)
        //[4/27/22, Bug - 2071, Dhevanesam R
        let StatusMsgError = "";
        if (UpdateStatus[0].DeleteSuccess != null) {
            StatusMsgError = UpdateStatus[0].DeleteSuccess;
            $(`#removeApprover`).addClass('hide');
        }
        else if (UpdateStatus[0].DeleteFailed != null) {
            StatusMsgError = UpdateStatus[0].DeleteFailed
        }
        else if (UpdateStatus[0].UpdateSuccess != null) {
            StatusMsgError = UpdateStatus[0].UpdateSuccess;
            //[8/10/22, Bug - 2349, PS_UP_07, Dhevanesam R]
            $(`#removeApprover`).removeClass('hide');
            //this.setState({ ExistReqAppr: this.state.ExistApproveValue.value });
            this.setState({ ExistBudAppr: this.state.ExistApproveValue.value });
        }
        else {
            StatusMsgError = UpdateStatus[0].InsertFailed;
            $(`#removeApprover`).removeClass('hide');
            //this.setState({ ExistReqAppr: this.state.ExistApproveValue.value });
            this.setState({ ExistBudAppr: this.state.ExistApproveValue.value });
        }

        //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R- Fetch Approvers popup data
        let user = "";
        let userLimit = "";
        let approver = "";
        let approverLimit = "";
        let popupFlag = true;
        if (UpdateStatusL.ApproverData != null && UpdateStatusL.ApproverData.length > 0) {
            user = UpdateStatusL.ApproverData[0].CURRENTUSER;
            approver = UpdateStatusL.ApproverData[0].NEXTAPPROVER;
            userLimit = UpdateStatusL.ApproverData[0].CURRENTUSERLIMIT;
            approverLimit = UpdateStatusL.ApproverData[0].NEXTAPPROVERLIMIT;
        }
        else {
            popupFlag = false;
        }

        let DeleteAppr = $('#customCheckk').is(":checked") ? "TRUE" : "FALSE";
        //[3/11/22, PC_UP_02, CAS - 31, Dhevanesam R
        if (DeleteAppr == "TRUE") {
            let localArray1 = {
                value: 0,
                label: t("--------Select Approver-------"),
            }

            this.setState({ ExistApproveValue: localArray1, ExistAppLimit: "", initialBudAppLimit: "" })
            if (document.getElementById("customCheckk")) {
                document.getElementById("customCheckk").checked = false;
            }
        }
        document.getElementById('StatusMsg').innerText = StatusMsgError
        this.setState({
            StatusMsgErrorVal: StatusMsgError,
            CurrentUserName: user, CurrentUserLimit: userLimit, NextApprover: approver, NextApproverLimit: approverLimit, ApproverPopupFlag: popupFlag
        })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
    * Ref no:UP_PC_80
    * 
    * This method is called when Submit in Order status email tab is click to update the Order status email in the database.
    * */
    UpdateOSE = () => {
        document.getElementById('StatusMsg').innerText = ""
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let SiteSelected = ""
        if (this.state.SiteList.length > 0) {
            SiteSelected = this.state.SelectSite.value
        }
        else {
            SiteSelected = this.state.GroupID
        }
        window.scrollTo(0, 0)
        let Validate = true
        if (this.state.RoleExist == "" || Validate) {
            let UpdOSEBO = {
                UserId: this.state.SelectedUserId,
                Session_UserId: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                Session_UserRole: this.state.LoginUserRole,
                SiteValue: SiteSelected,
                chbCRE: $('#chbCRE').is(":checked") ? "TRUE" : "FALSE",
                chbQTW: $('#chbQTW').is(":checked") ? "TRUE" : "FALSE",
                chbQTC: $('#chbQTC').is(":checked") ? "TRUE" : "FALSE",
                chbQTS: $('#chbQTS').is(":checked") ? "TRUE" : "FALSE",
                chbCST: $('#chbCST').is(":checked") ? "TRUE" : "FALSE",
                chbVND: $('#chbVND').is(":checked") ? "TRUE" : "FALSE",
                chbAPR: $('#chbAPR').is(":checked") ? "TRUE" : "FALSE",
                chbQTA: $('#chbQTA').is(":checked") ? "TRUE" : "FALSE",
                chbQTR: $('#chbQTR').is(":checked") ? "TRUE" : "FALSE",
                chbRFA: $('#chbRFA').is(":checked") ? "TRUE" : "FALSE",
                chbRFR: $('#chbRFR').is(":checked") ? "TRUE" : "FALSE",
                chbRFC: $('#chbRFC').is(":checked") ? "TRUE" : "FALSE",
                chbRCF: $('#chbRCF').is(":checked") ? "TRUE" : "FALSE",
                chbRCP: $('#chbRCP').is(":checked") ? "TRUE" : "FALSE",
                chbCNC: $('#chbCNC').is(":checked") ? "TRUE" : "FALSE",
                chbDLF: $('#chbDLF').is(":checked") ? "TRUE" : "FALSE",
            }
            ProfileAction.UpdateOSE(UpdOSEBO);
        }
        else {
            document.getElementById('StatusMsg').innerText = "Role is assigned so order status email cannot be updated"
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    }
    /*
     *
     WW-319 Default check box values of Order Status Email for Newly created user - Deepthi
     **/
    DefaultOSECheck = (SuccessMsg) => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let userId = this.state.UserIDAdded;
        let Session_UserId = this.state.UserIDAdded;
        let Session_BUSUNIT = this.state.Login_UserBU;
        let Session_EMAIL = this.state.UserEmailAdded;
        let Session_UserRole = this.state.UserRoleAdded.Role;
        let SiteSelected = this.state.SelectSite.value
        this.setState({ IsNewUserCreated: true, NewUserOSEDefMsg: SuccessMsg });
        let UpdOSEBO = {
            UserId: this.state.UserIDAdded,
            Session_UserId: this.state.UserIDAdded,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_EMAIL: this.state.UserEmailAdded,
            Session_UserRole: this.state.UserRoleAdded.Role,
            SiteValue: this.state.Login_UserBU,
            chbCRE: "TRUE",
            chbQTW: "TRUE",
            chbQTC: "TRUE",
            chbQTS: "TRUE",
            chbCST: "TRUE",
            chbVND: "TRUE",
            chbAPR: "TRUE",
            chbQTA: "TRUE",
            chbQTR: "TRUE",
            chbRFA: "TRUE",
            chbRFR: "TRUE",
            chbRFC: "TRUE",
            chbRCF: "TRUE",
            chbRCP: "TRUE",
            chbCNC: "TRUE",
            chbDLF: "TRUE",
        }
        ProfileAction.UpdateOSE(UpdOSEBO);
    }
    /*
    * Ref no: UP_PC_81
    * In this method Order Status Email update status is showmn.
    * 
    * */
    ShowOSEMessage = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateStatusL = JSON.parse(ProfileStore.UpdateOSEBO);
        console.log(UpdateStatusL)
        let UpdateStatus = UpdateStatusL.Table1
        if (UpdateStatus[0].UpdateSuccess != null) {
            if (this.state.IsNewUserCreated) {
                document.getElementById('StatusMsg').innerText = this.state.NewUserOSEDefMsg;
            }
            else {
                document.getElementById('StatusMsg').innerText = UpdateStatus[0].UpdateSuccess;
            }
        }
        else {
            document.getElementById('StatusMsg').innerText = "Techincal Issue"
        }
    }
    /*
    * Ref no:UP_PC_83
    * 
    * This method is called when Submit in Preference tab is click to update the Preference in the database.
    * */

    /*[07/19/22, PC_WW-448_08], Priyanka D */
    UpdatePref = () => {
        //debugger
        document.getElementById('StatusMsg').innerText = ""
        window.scrollTo(0, 0)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let DescripTypeValue = $('#ClientDesp').is(":checked") ? "Client" : "C";
        let BlockPrice = $('#PriceDisplay').is(":checked") ? "True" : "False";
        let Departmentvalue = ""
        let ShiptoValue = ""
        let Child1Value = ""
        let Child2Value = ""
        if (this.state.DepartmentPref != []) {
            Departmentvalue = this.state.DepartmentPref.value
        }
        if (this.state.Shipto != []) {
            ShiptoValue = this.state.Shipto.value
        }
        //9/21/22, Bug - 2665, To make home store as a mandatory select value, Dhevanesam R] */}
        const { t } = this.props;
        //WW-985 - User SAMSAPP1 can't approve orders & unable to assign home store to user - Deepthi N H
        if (this.state.HomeStoreValue != undefined && this.state.HomeStoreValue != null && this.state.DivisionValue != undefined && this.state.DivisionValue != null) {
            if (CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" && this.state.HomeStoreValue.value == "0" || this.state.HomeStoreValue.value == "" || this.state.HomeStoreValue.value == " " && this.state.HomeStoreValue.value == null && this.state.HomeStoreValue.value == undefined) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Please select any home store")
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
            else if ((CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" || CookieService.getLocalStorageValues("Session_USERTYPE") == "CORPADMIN") && (this.state.DivisionValue.value == "0" || this.state.DivisionValue.value == "" || this.state.DivisionValue.value == " " || this.state.DivisionValue.value == null || this.state.DivisionValue.value == undefined)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Please select any division")
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
            else {
                //WW-981 Source Non Catalog Changes - Deepthi N H
                CookieService.updateLocalStorageValues("Session_User_Division", this.state.DivisionValue.label)
                let UpdPrefBO = {
                    UserId: this.state.SelectedUserId,
                    DescripType: DescripTypeValue,
                    Dept: Departmentvalue,
                    ShipTo: ShiptoValue,
                    BlockPrice: BlockPrice,
                    HomeStore: this.state.HomeStoreValue.value,
                    Division: this.state.DivisionValue.value
                }
                ProfileAction.UpdatePreferences(UpdPrefBO)
            }
        }
        else {
            if (this.state.HomeStoreValue == undefined || this.state.HomeStoreValue == null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Please select any home store")
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
            else if (this.state.DivisionValue == undefined && this.state.DivisionValue == null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Please select any division")
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }

        }
    }

    /*
    * Ref no:UP_PC_84
    * In this method Perference update status is showmn.
    * 
    * */

    /*[07/19/22, PC_WW-448_10], Priyanka D */
    ShowPrefMessage = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateStatus = JSON.parse(ProfileStore.UpdatePrefBO);
        let SuceessMessageTable = []
        SuceessMessageTable = UpdateStatus.SuceessMessage
        let updateSessionL = []
        updateSessionL = UpdateStatus.UpdateSession
        if (SuceessMessageTable.length > 0) {
            let menuBO = {
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_MenuUpdated: "False",
                Session_SDIMenu: "",
                Session_BARCODE: CookieService.getLocalStorageValues("Session_BARCODE") ? CookieService.getLocalStorageValues("Session_BARCODE") : "",
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
                Session_DEFAULTPAGE: CookieService.getLocalStorageValues("Session_DEFAULTPAGE"),
                Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
                Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
                Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERNAME: CookieService.getLocalStorageValues("Session_AGENTUSERNAME") ? CookieService.getLocalStorageValues("Session_AGENTUSERNAME") : "",
                Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
                Source: 'Web',
                Version_No: CookieService.getLocalStorageValues("currentversion") != null && CookieService.getLocalStorageValues("currentversion") != undefined ? CookieService.getLocalStorageValues("currentversion") : ""
            }
            MenuAction.getMenuItems(menuBO);
            document.getElementById('StatusMsg').innerText = SuceessMessageTable[0].UpdateSuccess
            if (updateSessionL != null && updateSessionL != undefined) {
                if (updateSessionL.length > 0) {
                    CookieService.updateLocalStorageValues("Session_ISAShipToID", updateSessionL[0].ISAShipToID);
                    CookieService.updateLocalStorageValues("HOME_STORE", updateSessionL[0].HOME_STORE);
                    CookieService.updateLocalStorageValues("Division", updateSessionL[0].DIVISION);
                    CookieService.updateLocalStorageValues("Session_STATE", updateSessionL[0].Session_STATE);
                    CookieService.updateLocalStorageValues("City", updateSessionL[0].City);
                    CookieService.updateLocalStorageValues("Address1", updateSessionL[0].Address1);
                    CookieService.updateLocalStorageValues("Address2", updateSessionL[0].Address2);
                    CookieService.updateLocalStorageValues("Postal_Code", updateSessionL[0].Postal_Code);
                    CookieService.updateLocalStorageValues("Country", updateSessionL[0].Country);

                    let DescripTypeValue = $('#ClientDesp').is(":checked") ? "P" : "C";
                    CookieService.updateLocalStorageValues("Session_PROD_DESCPREFERENCE", DescripTypeValue);
                    let BlockPrice = $('#PriceDisplay').is(":checked") ? "Y" : "N";
                    CookieService.updateLocalStorageValues("Session_ISAPriceBlock", BlockPrice);
                }
            }
        }
        else {
            document.getElementById('StatusMsg').innerText = "Technical issue"
        }
    }
    /*
    * Ref no:UP_PC_86
    * This method is called when Submit in Mobility tab is click to update the Mobility in the database.
    * 
    * */
    UpdateCrib = () => {
        document.getElementById('StatusMsg').innerText = ""
        document.getElementById('CribValidate').innerText = ""
        window.scrollTo(0, 0)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        let validate = true
        let CribValueL = this.state.CribValue.value
        if (CribValueL == "" || CribValueL == null || CribValueL == undefined) {
            document.getElementById('CribValidate').innerText = "Please select a crib";
            validate = false
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        if (validate) {
            let UpdCribBO = {
                UserId: this.state.SelectedUserId,
                Session_UserId: this.state.Login_UserId,
                Crib_Value: CribValueL
            }
            ProfileAction.UpdateCrib(UpdCribBO)
        }
    }
    /*
    * Ref no:UP_PC_87
    * In this method Crib update status is showmn.
    * 
    * */
    ShowMobMessage = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateStatusL = JSON.parse(ProfileStore.UpdateCribBO);
        console.log("UpdateStatusL", UpdateStatusL)
        let UpdateStatus = UpdateStatusL.SuceessMessage
        if (UpdateStatus[0].UpdateSuccess != null) {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].UpdateSuccess
            CookieService.updateLocalStorageValues("Session_ISA_CRIB_IDENT", this.state.CribValue.value)
            //PC_CPW_267_17 Assign empty string the value when change crib for container printing-Nandhini L
            CookieService.updateLocalStorageValues("printer", "");
            //CPW-341 Assign empty string the value when change crib for Fedex shipping -Nandhini L
            CookieService.updateLocalStorageValues("BOLPrinterValue", "");
            CookieService.updateLocalStorageValues("PrinterValue", "");
        }
        else {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].UpdateFailed
        }
    }
    /*
    * Ref no:UP_PC_96
    * This method is called when Submit in Zeus tab is click to update the zeus status in the database.
    * 
    * */
    UpdateZeus = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        window.scrollTo(0, 0)
        document.getElementById('StatusMsg').innerText = ""
        let ZeusStatus = document.getElementById("ZeusLabel").innerText
        let ZeusCheckBox = $('#Disable-Zeus').is(":checked") ? "True" : "False";
        if (ZeusCheckBox == "True") {
            let UpdZeusBo = {
                UserId: this.state.SelectedUserId,
                Session_UserId: this.state.Login_UserId,
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                ZeusLabelText: ZeusStatus
            }
            ProfileAction.UpdateZeus(UpdZeusBo)
        }
        else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            document.getElementById('StatusMsg').innerText = "Please Select the Option"
        }
    }
    /*
    * Ref no:UP_PC_97
    * In this method Zeus update status is showmn.
    * 
    * */
    ShowZeusMessage = () => {
        const { t } = this.props;
        let UpdateStatusL = JSON.parse(ProfileStore.UpdateZeusBO);
        console.log("UpdateStatusL", UpdateStatusL)
        let ZeusStatus = document.getElementById("ZeusLabel").innerHTML
        let UpdateStatus = UpdateStatusL.SuceessMessage
        let ZeusTitleL = ""
        if (UpdateStatus[0].UpdateSuccess != null) {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].UpdateSuccess
        }
        else {
            document.getElementById('StatusMsg').innerText = UpdateStatus[0].UpdateFailed
        }
        document.getElementById("Disable-Zeus").checked = false;
        if (ZeusStatus == "Enable Zeus") {
            ZeusTitleL = "Disable Zeus"
        }
        else {
            ZeusTitleL = "Enable Zeus"
        }
        this.setState({ ZeusTitle: ZeusTitleL })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /*
     * Ref No: UP_PC_75 && UP_PC_77
    * This method is invoked when the Set Budgetary or Set Requestor button is clicked. 
    * Action call is made to get the approvals details from the database using the api.
    * */

    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
    LoadApprover = () => {
        //[3/11/22, PC_UP_02, CAS - 31, Dhevanesam R
        const { t } = this.props
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //[4/27/22, Bug - 2071, Dhevanesam R
        //document.getElementById('StatusMsg').innerText = "";

        let StatusMsgError = "";
        document.getElementById('StatusMsg').innerText = StatusMsgError
        //let Buttype = document.getElementById('ReqBtn').innerText
        let JD = $('#customCheckk').is(":checked") ? "TRUE" : "FALSE";
        console.log("JD", JD);
        if (document.getElementById("customCheckk")) {
            document.getElementById("customCheckk").checked = false;
        }
        let SiteSelected = ""
        if (this.state.SiteList.length > 0) {
            SiteSelected = this.state.SelectSite.value
        }
        else {
            SiteSelected = this.state.GroupID
        }
        let SetReqAppBo = {
            Session_ThirdParty_CompanyID: this.state.SelectedThirdParty,
            UserId: this.state.SelectedUserId,
            Session_UserRole: this.state.LoginUserRole,
            SiteValue: SiteSelected
        }
        //[4/13/22, Bug - 2047 & 2048, Dhevanesam R
        //if (Buttype == "Définir l’approbation du demandeur" || Buttype == "Establecer la aprobación del solicitante") {
        //    Buttype = "Set Requestor Approval"
        //}
        //else if (Buttype == "Définir l’approbation budgétaire" || Buttype == "Establecer aprobación presupuestaria") {
        //    Buttype = "Set Budgetary Approval"
        //}
        if (approvalAccordian == 1) {
            ProfileAction.GetBudApprovals(SetReqAppBo)
            //document.getElementById('ReqBtn').innerText = (t("Set Budgetary Approval"))
            //$('#BudLimitDiv').addClass('hide');
            this.setState({
                ApprovBtnTxt: "Set Budgetary Approval", StatusMsgErrorVal: StatusMsgError
            })

        }
        else if (approvalAccordian == 2) {
            ProfileAction.GetReqApprovals(SetReqAppBo)
            //document.getElementById('ReqBtn').innerText = (t("Set Requestor Approval"))
            //$('#BudLimitDiv').removeClass('hide');
            this.setState({
                ApprovBtnTxt: "Set Requestor Approval", StatusMsgErrorVal: StatusMsgError
            })
        } else if (approvalAccordian == 3) {
            ProfileAction.GetAltBudApprovals(SetReqAppBo)
            this.setState({
                ApprovBtnTxt: "Set Requestor Approval", StatusMsgErrorVal: StatusMsgError
            })
        }
    }

    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
    BuildAltBudApprovalForm = () => {
        const { t } = this.props;
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateStatus = JSON.parse(ProfileStore.LoadAltBudApprovalsBO);
        let AltBudApprover = [];
        let ExistApprover = [];
        AltBudApprover = UpdateStatus.AltBudApproverDD
        ExistApprover = UpdateStatus.ExistAltBudApprover
        if (ExistApprover.length > 0) {
            ExistApprover = Object.values(ExistApprover[0])
        }
        let ApproveValue = []
        let ExistApp = []
        AltBudApprover.map((val, index) => {
            let localArray = {
                value: val.ISA_EMPLOYEE_ID,
                label: val.EMP_TEXT
            }
            ApproveValue.push(localArray)
            if (ExistApprover.length > 0) {
                if (ExistApprover.includes(val.ISA_EMPLOYEE_ID)) {
                    ExistApp.push(localArray)
                }
            }
        });
        this.setState({
            ApproverList: ApproveValue, ExistApproveValue: ExistApp, updateAltBudgetary: ExistApp,
            delAltBudCheck: ExistApp, delAltBudIcon: ExistApp, selectedApprvValue: ExistApp
        })
    }

    ShowAltBudApprovalStatus = () => {
        const { t } = this.props
        let UpdateStatusL = JSON.parse(ProfileStore.UpdateAltBudApprovalsBO);
        let UpdateStatus = UpdateStatusL.Table1
        let StatusMsgError = "";
        if (UpdateStatus[0].DeleteSuccess != null) {
            StatusMsgError = UpdateStatus[0].DeleteSuccess;
            $(`#removeApprover`).addClass('hide');
        }
        else if (UpdateStatus[0].DeleteFailed != null) {
            StatusMsgError = UpdateStatus[0].DeleteFailed
        }
        else if (UpdateStatus[0].UpdateSuccess != null) {
            StatusMsgError = UpdateStatus[0].UpdateSuccess;
            $(`#removeApprover`).removeClass('hide');
            this.setState({ ExistReqAppr: this.state.ExistApproveValue.value });
        }
        else {
            StatusMsgError = UpdateStatus[0].InsertFailed;
            $(`#removeApprover`).removeClass('hide');
            this.setState({ ExistReqAppr: this.state.ExistApproveValue.value });
        }
        let DeleteAppr = $('#customCheckk').is(":checked") ? "TRUE" : "FALSE";
        if (DeleteAppr == "TRUE") {
            let localArray1 = {
                value: 0,
                label: t("--------Select Approver-------"),
            }
            this.setState({ ExistApproveValue: localArray1, ExistAppLimit: "", initialBudAppLimit: "" })
            if (document.getElementById("customCheckk")) {
                document.getElementById("customCheckk").checked = false;
            }
        }
        this.setState({
            StatusMsgErrorVal: StatusMsgError
        })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
    onAccordianClick = (event, index, currentAccordion) => {
        let n = ['BudReq', 'AltReq', 'AltBud'];
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        if (approvalAccordian == currentAccordion) {
            $(`#contentrow-${index}`).toggleClass('d-none');
            return;
        }
        if (approvalAccordian != 0) {
            let newElement = document.getElementById(`arrow-${n[approvalAccordian - 1]}`);
            let classTest = newElement.classList.contains("accordion-arrow-change");
            if (classTest) {
                $(`#arrow-${n[approvalAccordian - 1]}`).toggleClass('accordion-arrow-change');
            }
        }
        if (index == "BudReq") {
            $('#contentrow-BudReq').removeClass('d-none');
            $('#contentrow-AltReq').addClass('d-none');
            $('#contentrow-AltBud').addClass('d-none');
        }
        else if (index == "AltReq") {
            $('#contentrow-BudReq').addClass('d-none');
            $('#contentrow-AltReq').removeClass('d-none');
            $('#contentrow-AltBud').addClass('d-none');
        }
        else if (index == "AltBud") {
            $('#contentrow-BudReq').addClass('d-none');
            $('#contentrow-AltReq').addClass('d-none');
            $('#contentrow-AltBud').removeClass('d-none');
        }
        approvalAccordian = currentAccordion;
        this.LoadApprover();
    };

    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R

    bindAlternateGrid = () => {
        if (this.state.ExistApproveValue.length > 0) {
            return this.state.ExistApproveValue.map((value, index) => {
                return (
                    <tr>
                        <td className="text-nowrap text-center">
                            <input type="checkbox" className="custom-control-del" id={`AltBudgCheckbox${index + 1}`} style={{ "opacity": "5", "height": '1.25rem', "width": '1rem' }} onChange={(e) => this.handleDelCheckOnchange(e, value, index)} />

                        </td>
                        <td className="text-nowrap">
                            <label id={`AltBudg${index + 1}`}>{value.label}</label>
                        </td>
                        <td className="text-nowrap text-center">
                            <img src="Images/trash.svg" id={`AltBudgDelIcon${index + 1}`} className="del-icon" style={{ "width": '20px', "margin-left": '2px' }} onClick={() => this.handleDelIconAndPopup("Delete", value, index)} ></img>
                        </td>
                    </tr>
                )
            })
        }
    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R- To trigger on the click of delete checkbox
    handleDelCheckOnchange = (event, value, index) => {
        let tempArray = JSON.parse(JSON.stringify(this.state.delAltBudCheck));
        if (event.target.checked) {
            tempArray[index] = { value: " ", label: " " };
            $(`#AltBudgDelIcon${index + 1}`).addClass('del-icon-disable');
            checkboxCount++
        }
        else {
            tempArray[index] = value;
            $(`#AltBudgDelIcon${index + 1}`).removeClass('del-icon-disable');
            checkboxCount--
        }
        if (checkboxCount == this.state.ExistApproveValue.length) {
            $('#AltBudgMultiselect').prop('checked', true);
            this.setState({ isMultiSelectChecked: true });
        }
        else {
            $('#AltBudgMultiselect').prop('checked', false);
            this.setState({ isMultiSelectChecked: false });
        }

        this.setState({ delAltBudCheck: tempArray });
    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R -To trigger on the click of delete icon
    handleDelIconAndPopup = (event, value, index) => {
        let tempArray = this.state.delAltBudIcon;
        if (event == "Delete") {
            tempArray = tempArray.filter((val, ind) => ind !== index);
            this.setState({ delAltBudIcon: tempArray });
            $('#delete-alt-approver').modal('show');
        }
        else if (event == "Yes") {
            $('#delete-alt-approver').modal('hide');
            this.UpdateApprovals(this.state.delAltBudIcon)
        }
        else {
            this.setState({ delAltBudIcon: this.state.ExistApproveValue });
            $('#delete-alt-approver').modal('hide');
        }
    }
    //PC_1044_153 WW-1044 Approval   [07/05/2024] Pavithra R
    handleMultiCheckOnchange = (event) => {
        let tempArray = JSON.parse(JSON.stringify(this.state.delAltBudCheck));
        if (event.target.checked) {
            checkboxCount = tempArray.length;
            tempArray.forEach((value, index) => {
                tempArray[index] = { value: " ", label: " " };
                $(`#AltBudgCheckbox${index + 1}`).prop('checked', true);
                $(`#AltBudgDelIcon${index + 1}`).addClass('del-icon-disable');
            })
            this.setState({ delAltBudCheck: tempArray, isMultiSelectChecked: true });
        }
        else {
            tempArray.forEach((value, index) => {
                checkboxCount = 0;
                /*tempArray[index] = value;*/
                $(`#AltBudgCheckbox${index + 1}`).prop('checked', false);
                $(`#AltBudgDelIcon${index + 1}`).removeClass('del-icon-disable');
            })
            this.setState({ delAltBudCheck: this.state.ExistApproveValue, isMultiSelectChecked: false });
        }
    }
    /*
    * Ref no:UP_PC_76
    * In this method the requestor approvals from is binded with the action response.
    * 
    * */
    BuildReqApprovalForm = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateStatus = JSON.parse(ProfileStore.LoadReqApprovalsBO);
        document.getElementById("ApprLabel").innerText = "Alternate Requestor Approval by"
        let ReqApprover = []
        ReqApprover = UpdateStatus.ReqApproverDD
        let ExistApprover = []
        ExistApprover = UpdateStatus.ExistReqApprover

        //if (this.state.LoginUserType) {
        //    $('#BudBtn').addClass('hide');
        //}
        let ExistReqApprL = "";
        let ApproveValue = []
        let ExistApp = []
        ReqApprover.map((val, index) => {
            if (index == 0) {
                let localArray1 = {
                    value: 0,
                    label: "--------Select Approver-------"
                }
                ApproveValue.push(localArray1)
                if (ExistApprover.length == 0) {
                    ExistApp = localArray1
                    $('#removeApprover').addClass('hide');
                }
            }
            let localArray = {
                value: val.ISA_EMPLOYEE_ID,
                label: val.EMP_TEXT
            }
            if (ExistApprover.length > 0) {
                if (val.ISA_EMPLOYEE_ID == ExistApprover[0].ISA_REQ_APR_ALT) {
                    ExistApp = localArray
                    ExistReqApprL = ExistApprover[0].ISA_REQ_APR_ALT
                    $('#removeApprover').removeClass('hide');
                }

            }
            else {
                $('#removeApprover').addClass('hide');
            }
            ApproveValue.push(localArray)
        });
        ////2377 - User Profile_ After selecting Remove checkbox alternate requestor approval dropdown value should be in disable mode.-Dhamotharan P
        //if (ExistApprover == this.state.initialApprover) {
        //    $('#removeApprover').removeClass('hide');
        //}
        //else {
        //    $('#removeApprover').addClass('hide');
        //}

        this.setState({
            ApproverList: ApproveValue, ExistApproveValue: ExistApp, ExistReqAppr: ExistReqApprL
        })
    }
    /*
    * Ref no:UP_PC_78
    * In this method the budgetary approvals from is binded with the action response.
    * 
    * */
    BuildBudApprovalForm = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateStatus = JSON.parse(ProfileStore.LoadBudApprovalsBO);
        document.getElementById("ApprLabel").innerText = "Budgetary Approval by"
        let ApproverList = UpdateStatus.BudApproverDD;
        let ExistApprover = [];
        ExistApprover = UpdateStatus.ExistBudApprover
        let ApproveValue = []
        let ExistApp = []
        let LimitValue = ""
        let ExistBudApprL = "";
        ApproverList.map((val, index) => {
            if (index == 0) {
                let localArray1 = {
                    value: 0,
                    label: "--------Select Approver-------"
                }
                ApproveValue.push(localArray1)
                if (ExistApprover.length == 0) {
                    ExistApp = localArray1
                    $('#removeApprover').addClass('hide');
                }
            }
            let localArray = {
                value: val.ISA_EMPLOYEE_ID,
                label: val.EMP_TEXT
            }
            if (ExistApprover.length > 0) {
                if (val.ISA_EMPLOYEE_ID == ExistApprover[0].ISA_IOL_APR_EMP_ID) {
                    ExistApp = localArray
                    LimitValue = ExistApprover[0].ISA_IOL_APR_LIMIT
                    ExistBudApprL = ExistApprover[0].ISA_IOL_APR_EMP_ID
                    $('#BUdLimitData').val(LimitValue)
                    $('#removeApprover').removeClass('hide');

                }
            }
            else {
                $('#removeApprover').addClass('hide');
            }
            ApproveValue.push(localArray)
        });
        this.setState({
            ApproverList: ApproveValue, ExistApproveValue: ExistApp, ExistAppLimit: LimitValue, ExistBudAppr: ExistBudApprL
        })
    }
    /*
    * Ref no:UP_PC_90
    * 
    * In this method the user SDI Track is updated to the database.
    * */
    UpdateTST = (Key) => {
        document.getElementById('StatusMsg').innerText = ""
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        window.scrollTo(0, 0)
        let selecteuserid = ""
        let SDITrackUserId = ""
        let SDItrackPassword = ""
        if (Key == "1") {
            selecteuserid = document.getElementById('TSTCurentUser').innerText
            SDITrackUserId = $('#TSTUSERID1').val()
            SDItrackPassword = $('#TSTPASSWORD1').val()
        }
        else {
            selecteuserid = document.getElementById('TSTUserName').innerText
            SDITrackUserId = $('#TSTOTHERID').val()
            SDItrackPassword = $('#TSTOTHERPASS').val()
        }
        let AddUserSDITrackBO = {
            Session_TrackDBType: CookieService.getLocalStorageValues("Session_TrackDBType"),
            Session_TrackDBGUID: CookieService.getLocalStorageValues("Session_TrackDBGUID"),
            Session_TrackDBUser: CookieService.getLocalStorageValues("Session_TrackDBUser"),
            Session_TrackDBPassword: CookieService.getLocalStorageValues("Session_TrackDBPassword"),
            SelectedUser: selecteuserid,
            SDITrack_UserId: SDITrackUserId,
            SDITrack_PassWord: SDItrackPassword,
        }
        ProfileAction.AddTrackUser(AddUserSDITrackBO)
    }
    /*
    * Ref no:UP_PC_91
    * In this the SDI track update response from the action is received and the status message is binded.
    * 
    * */
    ShowTrackMessage = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let UpdateStatus = JSON.parse(ProfileStore.LoadBudApprovalsBO);
        AddTSTUSERSuccess = 0;
        let AdduserDetail = []
        AdduserDetail = UpdateStatus.AddedUserDetails
        let SuceessMessage = []
        SuceessMessage = UpdateStatus.SuceessMessage
        if (SuceessMessage.length > 0) {
            if (SuceessMessage[0].UpdateSuccess == null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: SuceessMessage[0].UpdateFailed
                });
                //  alert(SuceessMessage[0].UpdateFailed)
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: SuceessMessage[0].UpdateSuccess
                });
                // alert(SuceessMessage[0].UpdateSuccess)
                if (AdduserDetail.length > 0) {
                    document.getElementById('ADDUserID').innerText = AdduserDetail[0].UserName
                    document.getElementById('ADDGUID').innerText = AdduserDetail[0].GUIDVal
                    document.getElementById('ADDEDON').innerText = AdduserDetail[0].DateTime
                    $('#ADDEDUSERDiv').removeClass('hide')
                    $('#SDITrackPassDiv').addClass('hide')

                }
            }
        }
    }
    /*
    * Ref no:UP_PC_89
    * This method is invoked when the store emits
    * The SDI track User from is binded with selected user sdi track details
    * */
    BindSelectUserTrackData = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let TSTValue1 = JSON.parse(ProfileStore.SelecttrackBO);
        let TSTValue = TSTValue1.ADDUserFormTable
        console.log("TSTValue", TSTValue)
        let ErrorMessage = ""
        if (TSTValue[0].OtherUserBUMessage != null || TSTValue[0].OtherUserNoBU != null) {
            ErrorMessage = TSTValue[0].OtherUserBUMessage != null ? TSTValue[0].OtherUserBUMessage : TSTValue[0].OtherUserNoBU
            document.getElementById("TSTError").innerText = ErrorMessage;
            $('#AddTSTUserDiv').addClass('hide');
            $('#AddUserDiv').addClass('hide');
        }
        document.getElementById("TSTUserName").innerText = TSTValue[0].OtherUserID;
        document.getElementById("TSTuserBu").innerText = TSTValue[0].BusinessUnit;
        $('#ADDEDUSERDiv').addClass('hide')
    }
    /*
    * Ref no:UP_PC_65
    * 
    * This method is invoked when the cancel button is clicked.
    * Redirected to the homepage.
    * */
    COStatus = () => {
        document.getElementById('EmpLabel').innerText = ""
        document.getElementById('AcctLabel').innerText = ""

        if (this.state.PageAction != "ADD") {
            this.props.history.push({
                pathname: "/HomePage",
            });
        }
        else if (this.state.PageAction == "ADD") {
            let Departmentdefault = {
                value: "",
                label: "-----Select Department-----"

            }
            let siteclear = {
                value: "Select",
                label: "Select Site"
            }
            let Selectvalue = {
                value: "Select",
                label: "Select Type",
                key: "",
                Role: "",
                Third: "",
            }
            let DisableTypeDDL = true
            document.getElementById("VendorGroupValue").innerHTML = "";
            document.getElementById("ErrorMagFirstName").innerHTML = "";
            document.getElementById("ErrorMagLastName").innerHTML = "";
            document.getElementById("ErrorMagEMailAdd").innerHTML = "";
            document.getElementById("ErrorMagPhone").innerHTML = "";
            document.getElementById("ErrorMagConfPass").innerHTML = "";
            document.getElementById("ErrorMagPass").innerHTML = "";
            document.getElementById("ErrorMegSite").innerHTML = "";
            this.setState({
                SelectedUserId: "", FirstName: "", LastName: "", SelectUsertype: "S",
                EmailAddres: "", PhoneNum: "", PassNTB: "", ConPasNTB: "", PageAction: "ADD", ChangePasswordEnable: "Y", adduser: true, SelectUserRole: Selectvalue,
                SelectSite: siteclear, VendorId: "", DepartMent: Departmentdefault, DisableTypeDD: DisableTypeDDL, MultiSiteChecked: false, SDIEMp: true, Customer: false, vendor: false
            })
        }
        else {
            window.location.reload(false);
        }
    }
    /*
    * This method is invoked when the check all or expand all or select all 
    * or deselect all button is clicked in the user privileges page.
    * By using the key value find the button clicked and respectively set the value.
    * */
    PrivTreeAction = (Key) => {
        let PrivTreeList = this.state.PrivTree
        let checkvalues = []
        switch (Key) {
            case "E": {
                PrivTreeList.map((val, index) => {
                    //WW-703 Menu Revamping-Deepthi N H
                    let iscat = PrivTreeList.filter((x) => x.ISA_CATEGORY_ID == val.ISA_CATEGORY_ID);
                    let isParent = PrivTreeList.filter((x) => x.ISA_PARENT_IDENT == val.ISA_PARENT_IDENT);
                    if (iscat.length > 0) {
                        let ispresent = checkvalues.some((x) => x == val.CATSECALIAS);
                        if (checkvalues.length == 0 || ispresent == false) {
                            checkvalues.push(val.CATSECALIAS)
                        }

                    }
                    if (isParent.length > 0) {
                        let ispresent = checkvalues.some((x) => x == val.PARENTSECALIAS);
                        if (checkvalues.length == 0 || ispresent == false) {
                            checkvalues.push(val.PARENTSECALIAS)
                        }
                    }
                    //Disrole = true
                });
                this.setState({ expanded: checkvalues, isExpandAll: false })
                break
            }
            case "C": {
                this.setState({ expanded: checkvalues, isExpandAll: true })
                break
            }
            case "D": {
                checkvalues.push("HOME")
                //WW-1229 Home tiles -Nandhini L
                let userHomeTilesMap = [];
                if (this.state.TilesList && this.state.TilesList.length > 0) {
                    userHomeTilesMap = this.state.TilesList.filter((tile) => tile.DEFAULT_TILE === 'Y');
                }
                this.setState({ checked: checkvalues, isSelectAll: true, selectDisplay: true, UserHomeTilesList: userHomeTilesMap })
                break
            }
            case "S": {
                PrivTreeList.map((val, index) => {
                    checkvalues.push(val.SECURITYALIAS)
                    //Disrole = true
                });
                //WW-1229 Home tiles -Nandhini L
                let UserHomeTilesList = this.state.UserHomeTilesList;
                let userHomeTilesMap = [];

                if (this.state.TilesList && this.state.TilesList.length > 0) {
                    userHomeTilesMap = new Map(this.state.UserHomeTilesList.map(tile => [tile.SECURITYALIAS, tile]));
                    this.state.TilesList.forEach(tile => {
                        if (checkvalues.includes(tile.SECURITYALIAS.slice(3)) && !userHomeTilesMap.has(tile.SECURITYALIAS)) {
                            const temp = this.state.TilesList.find(Temptile => Temptile.SECURITYALIAS === tile.SECURITYALIAS);
                            let updatedTile = { ...temp, tilePrivCheck: false };
                            UserHomeTilesList.push(updatedTile);
                            userHomeTilesMap.set(tile.SECURITYALIAS, tile);
                        }
                    });
                }
                this.setState({ checked: checkvalues, isSelectAll: false, selectDisplay: true, UserHomeTilesList: UserHomeTilesList })
                break
            }
        }

    }
    /*
    * Ref no:UP_PC_99 && UP_PC_101 && UP_PC_103 && UP_PC_105
    * 
    * This method is invoked when the activate site or de active site or activate employee account or de activate employee account is click.
    * Api call is method from the action to update the employee status to the database.
    * */
    ActiveEmployeeAccount = (Key) => {

        let SiteSelected = ""
        let AccountActiveL = 0
        if (this.state.SiteList.length > 0) {
            SiteSelected = this.state.SelectSite.value
        }
        else {
            SiteSelected = this.state.GroupID
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (Key == 1) {
            let ButtonValue = document.getElementById('EmpyAcctBtn').innerText

            let ActiveEmpAccountBo = {
                HidenUserId: this.state.HideuserId,
                UserId: this.state.SelectedUserId,
                UserBu: this.state.selectSiteID,
                SessionUserId: this.state.Login_UserId,
                ActiveStatus: this.state.EmployeeAccountActiveStatus,
                Page_Action: "EDIT",
                UserType: this.state.UserType,
                Session_USERTYPE: this.state.LoginUserType,
                Session_UserRole: this.state.LoginUserRole,
                Query_IsMexico: "False",
                Query_IsVendor: "False",
                SiteValue: SiteSelected,
                Session_WEBSITED: CookieService.getLocalStorageValues("Session_WEBSITED"),
            }
            if (ButtonValue == "In-Activate Employee Account") {
                AccountActiveL = 1
                ProfileAction.DeActivateEmpyAcc(ActiveEmpAccountBo)
            }
            else {
                AccountActiveL = 2
                ProfileAction.ActivateEmpyAcc(ActiveEmpAccountBo)
            }
        }
        else {
            let ButtonValue = document.getElementById('AcctBtn').innerText
            let ActiveAccountBo = {
                HidenUserId: this.state.HideuserId,
                UserId: this.state.SelectedUserId,
                SessionUserId: this.state.Login_UserId,
                ActiveStatus: this.state.UserActiveStatus,
                Page_Action: "EDIT",
                UserType: this.state.UserType,
                Session_USERTYPE: this.state.LoginUserType,
                Session_UserRole: this.state.LoginUserRole,
                Query_IsMexico: "False",
                Query_IsVendor: "False",
                SiteValue: SiteSelected,
                Session_WEBSITED: CookieService.getLocalStorageValues("Session_WEBSITED"),
            }
            if (ButtonValue == "In-Activate Account") {
                AccountActiveL = 3
                ProfileAction.DeActivateSite(ActiveAccountBo)
            }
            else {
                AccountActiveL = 4
                ProfileAction.ActivateSite(ActiveAccountBo)
            }
        }
        this.setState({ AccountActive: AccountActiveL })
    }
    /*
    * Ref no:UP_PC_100 && UP_PC_102 && UP_PC_104 && UP_PC_106
    * This is invoked when action response is emit with store listner once the employee account activated or deactivated and
    * similarily the site account is activated or deactivated.
    * 
    * */
    ShowActivateStatus = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let status = JSON.parse(ProfileStore.ActivateSiteAcctBO);
        console.log(status)
        let UpdateStatus = status.SuceessMessage
        let UpdateActiveStatus = status.updateStatus

        //$('#EmpLabel').removeClass('hide');
        //$('#AcctLabel').removeClass('hide');
        if (UpdateStatus[0].UpdateSuccess != null && UpdateStatus[0].UpdateSuccess != undefined) {
            if (this.state.AccountActive == 1) {
                document.getElementById('EmpyAcctBtn').innerText = "Activate Employee Account"
                $('#EmpLabel').removeClass('hide');
                document.getElementById('EmpLabel').innerText = UpdateStatus[0].UpdateSuccess
                $('#AcctLabel').addClass('hide');
                this.setState({ EmployeeAccountActiveStatus: UpdateActiveStatus[0].ActiveStatus })
            }
            else if (this.state.AccountActive == 2) {
                document.getElementById('EmpyAcctBtn').innerText = "In-Activate Employee Account"
                $('#EmpLabel').removeClass('hide');
                document.getElementById('EmpLabel').innerText = UpdateStatus[0].UpdateSuccess
                $('#AcctLabel').addClass('hide');
                this.setState({ EmployeeAccountActiveStatus: UpdateActiveStatus[0].ActiveStatus })
            }
            else if (this.state.AccountActive == 3) {
                document.getElementById('AcctBtn').innerText = "Activate Account"
                $('#AcctLabel').removeClass('hide');
                document.getElementById('AcctLabel').innerText = UpdateStatus[0].UpdateSuccess
                $('#EmpLabel').addClass('hide');
                this.setState({ UserActiveStatus: UpdateActiveStatus[0].ActiveStatus })
            }
            else if (this.state.AccountActive == 4) {
                document.getElementById('AcctBtn').innerText = "In-Activate Account"
                $('#AcctLabel').removeClass('hide');
                document.getElementById('AcctLabel').innerText = UpdateStatus[0].UpdateSuccess
                $('#EmpLabel').addClass('hide');
                this.setState({ UserActiveStatus: UpdateActiveStatus[0].ActiveStatus })
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue"
            });
            // alert("Technical issue")
        }
    };
    handlePaste = (e) => {
        e.preventDefault();
    };
    //handleKeyDown = (e) => {
    //    //debugger
    //    let val = e.key;
    //    //[15/08/23, 3962 - Removed the condition that checks for whitespace, Vishwa S]
    //    if (e.key === "'" || e.key==='"') {
    //        e.preventDefault();
    //    }
    //};
    handleProfileFormChange = (event) => {
        //debugger
        let id = event.target.id;
        let targetval = event.target.value;
        //let targetval = $('#' + id).val();

        switch (id) {
            case "FirstNTB": {
                if (targetval == "") {
                    document.getElementById("ErrorMagFirstName").innerHTML = "Please enter first name";
                }
                else {
                    document.getElementById("ErrorMagFirstName").innerHTML = "";
                }
                break;
            }
            case "LastNTB": {
                if (targetval == "") {
                    document.getElementById("ErrorMagLastName").innerHTML = "Please enter last name";
                }
                else {
                    document.getElementById("ErrorMagLastName").innerHTML = "";
                }
                break;
            }
            case "EmailNTB": {
                console.log("On pageloadEmailNTB:", targetval);
                if (targetval == "") {
                    document.getElementById("ErrorMagEMailAdd").innerHTML = "Please enter email address";
                }
                else {
                    document.getElementById("ErrorMagEMailAdd").innerHTML = "";
                    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                    if (!pattern.test(targetval)) {

                        document.getElementById("ErrorMagEMailAdd").innerHTML = "Please enter valid email address";

                    }
                }
                break;
            }
            case "PhoneNumNTB": {
                ///*console*/.log("PhoneNum",this.state.PhoneNum);
                console.log("On pageloadPhoneNumNTB:", targetval);
                const NumRegex = SDIConstants.quantityRegEX;
                if (targetval == "" || !NumRegex.test(targetval)) {

                    if (!NumRegex.test(targetval)) {
                        document.getElementById("ErrorMagPhone").innerHTML = "Please enter phone number";
                    }

                }
                else {
                    document.getElementById("ErrorMagPhone").innerHTML = "";
                    if (targetval.length < 10 && NumRegex.test(targetval)) {
                        document.getElementById("ErrorMagPhone").innerHTML = "Please enter valid phone number";
                    }
                }
                break;
            }
            case "PassNTB": {
                let Password = this.state.ConPasNTB;
                //debugger
                if (targetval == "" && Password != null && Password != "") {
                    document.getElementById("ErrorMagPass").innerHTML = "Please enter password";
                }
                else if (targetval != "" && Password == null && Password == "") {
                    document.getElementById("ErrorMagConfPass").innerHTML = "Please enter confirm password";
                }
                else if (Password != targetval && Password != null && Password != "") {
                    document.getElementById("ErrorMagConfPass").innerHTML = "Password doesn't match";
                }
                else {
                    document.getElementById("ErrorMagPass").innerHTML = "";
                    //debugger
                    //*************************Commented below password strength validation & added new Regex validation************************************

                    //let firstletter1 = targetval.slice(0, 1)
                    //let Numtest = targetval.match(/[0-9]/g)
                    //if (targetval.length < 6) {
                    //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!"
                    //}
                    //else if ((/[a-zA-Z]/).test(firstletter1) == false || Numtest == null || Numtest == undefined || Numtest == "") {
                    //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least 1 number and 1 letter - must start with a letter!"
                    //}

                    //****************************End of commenting password validation*********************************************************

                    //Added below Regex password strength validation
                    if (passwrdRegex.test(targetval) == false) {
                        document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters."
                    }
                    else if (targetval.length > 128) {
                        document.getElementById("ErrorMagPass").innerHTML = "Password must be within 128 characters!"
                    }
                    else if (Password == targetval) {
                        document.getElementById("ErrorMagPass").innerHTML = "";
                        document.getElementById("ErrorMagConfPass").innerHTML = "";
                    }
                    else {
                        document.getElementById("ErrorMagPass").innerHTML = "";
                    }
                }
                break;
            }
            case "ConPasNTB": {
                //debugger
                let Password = document.getElementById("PassNTB").innerText
                //let Passwordl = $('#PassNTB').val()
                let Passwordl = this.state.PassNTB

                if (targetval == "" && Passwordl != null && Passwordl != "") {
                    document.getElementById("ErrorMagConfPass").innerHTML = "Please enter confirm password";
                }
                else if (Passwordl == null || Passwordl == "") {
                    document.getElementById("ErrorMagPass").innerHTML = "Please enter password";
                }

                else if (Passwordl != targetval) {
                    document.getElementById("ErrorMagConfPass").innerHTML = "Password doesn't match";
                }
                else {
                    document.getElementById("ErrorMagConfPass").innerHTML = "";

                    //*************************Commented below password strength validation & added new Regex validation************************************

                    //let firstletter = targetval.slice(0, 1)
                    //let NumtestC = targetval.match(/[0-9]/g)
                    //if (targetval.length < 6) {
                    //    document.getElementById("ErrorMagConfPass").innerHTML = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!"
                    //}
                    //else if ((/[a-zA-Z]/).test(firstletter) == false || NumtestC == null || NumtestC == undefined || NumtestC == "") {
                    //    document.getElementById("ErrorMagConfPass").innerHTML = "Password must contain at least 1 number and 1 letter - must start with a letter!"
                    //}

                    //****************************End of commenting password validation*********************************************************

                    //Added below Regex password strength validation

                    if (passwrdRegex.test(targetval) == false) {
                        document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters."
                    }
                    else if (targetval.length > 128) {
                        document.getElementById("ErrorMagPass").innerHTML = "Password must be within 128 characters!"
                    }
                    else if (targetval == Passwordl) {
                        document.getElementById("ErrorMagPass").innerHTML = "";
                    }
                    else {
                        document.getElementById("ErrorMagConfPass").innerHTML = "";
                    }
                }
                break;
            }
            case "CribField": {
                let CribValueL = this.state.CribValue.value
                if (CribValueL == "" || CribValueL == null || CribValueL == undefined) {
                    document.getElementById('CribValidate').innerText = "Please select a crib";
                }
                else {
                    document.getElementById('CribValidate').innerText = "";
                }
            }
        }



        if (event.target.name == "PhoneNum" || event.target.name == "ExistAppLimit") {
            //*******NEW****

            if ((!isNaN(event.target.value)) && event.target.name == "PhoneNum") {
                this.setState({ [event.target.name]: event.target.value });
            }
            else if ((!isNaN(event.target.value) || event.target.value == "") && event.target.name == "ExistAppLimit") {
                this.setState({ [event.target.name]: event.target.value });
            }
        }
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    handleClickShowPassword = (values, label) => {
        if (label == "PASS") {
            this.setState({ showPassword: !this.state.showPassword })
        }
        else {
            this.setState({ showConPassword: !this.state.showConPassword })
        }
    };

    handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    //5723 - onchange validation for user id pop up [4/18/2025] Nachiappan
    handleUserIdValidation = (event) => {
        const userId = event.target.value; // Get the current value of the input

        // Check if the input value is not empty or null
        if (userId.trim() !== "") {
            // Clear the error message if the input is valid
            document.getElementById("ErrorMagUserId").innerText = "";
        }
    }
    /*
    * Ref no:UP_PC_38 &&UP_PC_38
    * Render is called when ever the variable is setstated
    * Render returns the html with data binded of the user profile page
    * */
    render() {
        const { t } = this.props;
        $(".changeevent").on("load", function (event) {


            let id = $(this).attr('id');
            let targetval = $('#' + id).val();
            console.log("id", id);
            console.log("targetval", targetval);
            switch (id) {
                case "FirstNTB": {
                    if (targetval == "") {
                        document.getElementById("ErrorMagFirstName").innerHTML = "Please enter first Name";
                    }
                    else {
                        document.getElementById("ErrorMagFirstName").innerHTML = "";
                    }
                    break;
                }
                case "LastNTB": {
                    if (targetval == "") {
                        document.getElementById("ErrorMagLastName").innerHTML = "Please enter Last Name";
                    }
                    else {
                        document.getElementById("ErrorMagLastName").innerHTML = "";
                    }
                    break;
                }
                case "EmailNTB": {
                    console.log("On pageloadEmailNTB:", targetval);
                    if (targetval == "") {
                        document.getElementById("ErrorMagEMailAdd").innerHTML = "Please enter email Address";
                    }
                    else {
                        document.getElementById("ErrorMagEMailAdd").innerHTML = "";
                        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                        if (!pattern.test(targetval)) {

                            document.getElementById("ErrorMagEMailAdd").innerHTML = "Please enter valid email address";

                        }
                    }
                    break;
                }
                case "PhoneNumNTB": {
                    ///*console*/.log("PhoneNum",this.state.PhoneNum);
                    console.log("On pageloadPhoneNumNTB:", targetval);
                    const NumRegex = SDIConstants.quantityRegEX;
                    if (targetval == "" || !NumRegex.test(targetval)) {

                        document.getElementById("ErrorMagPhone").innerHTML = "Please enter phone Number";
                    }
                    else {
                        document.getElementById("ErrorMagPhone").innerHTML = "";
                        if (targetval.length < 10 && NumRegex.test(targetval)) {
                            document.getElementById("ErrorMagPhone").innerHTML = "Please enter valid phone Number";
                        }
                    }
                    break;
                }
                case "PassNTB": {
                    if (targetval == "") {
                        document.getElementById("ErrorMagPass").innerHTML = "Please enter password";
                    }
                    else {
                        document.getElementById("ErrorMagPass").innerHTML = "";

                        //*************************Commented below password strength validation & added new Regex validation************************************

                        //let firstletter1 = targetval.slice(0, 1)
                        //let Numtest = targetval.match(/[0-9]/g)
                        //if (targetval.length < 6) {
                        //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!"
                        //}
                        //else if ((/[a-zA-Z]/).test(firstletter1) == false || Numtest == null || Numtest == undefined || Numtest == "") {
                        //    document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least 1 number and 1 letter - must start with a letter!"
                        //}

                        //****************************End of commenting password validation*********************************************************

                        //Added below Regex password strength validation

                        if (passwrdRegex.test(targetval) == false) {
                            document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters."
                        }
                        else if (targetval.length > 128) {
                            document.getElementById("ErrorMagPass").innerHTML = "Password must be within 128 characters!"
                        }
                        else {
                            document.getElementById("ErrorMagPass").innerHTML = "";
                        }
                    }
                    break;
                }
                case "ConPasNTB": {
                    let Password = document.getElementById("PassNTB").innerText
                    let Passwordl = $('#PassNTB').val()
                    console.log("Password", Passwordl)
                    if (targetval == "" && Passwordl != null && Passwordl != "") {
                        document.getElementById("ErrorMagConfPass").innerHTML = "Please enter Confirm password";
                    }
                    else if (Passwordl == null || Passwordl == "") {
                        document.getElementById("ErrorMagPass").innerHTML = "Please enter password";
                    }
                    else if (Passwordl != targetval) {
                        document.getElementById("ErrorMagConfPass").innerHTML = "Password doesn't match";
                    }
                    else {
                        document.getElementById("ErrorMagConfPass").innerHTML = "";

                        //*************************Commented below password strength validation & added new Regex validation************************************
                        //let firstletter = targetval.slice(0, 1)
                        //let NumtestC = targetval.match(/[0-9]/g)
                        //if (targetval.length < 6) {
                        //    document.getElementById("ErrorMagConfPass").innerHTML = "Password must contain at least six characters with 1 number and 1 letter - must start with a letter!"
                        //}
                        //else if ((/[a-zA-Z]/).test(firstletter) == false || NumtestC == null || NumtestC == undefined || NumtestC == "") {
                        //    document.getElementById("ErrorMagConfPass").innerHTML = "Password must contain at least 1 number and 1 letter - must start with a letter!"
                        //}

                        //****************************End of commenting password validation*********************************************************

                        //Added below Regex password strength validation

                        if (passwrdRegex.test(targetval) == false) {
                            document.getElementById("ErrorMagPass").innerHTML = "Password must contain at least ten characters with 1 number, 1 uppercase, 1 lowercase, 1 special character. Max length for password is 128 characters."
                        }
                        else if (targetval.length > 128) {
                            document.getElementById("ErrorMagPass").innerHTML = "Password must be within 128 characters!"
                        }
                        else {
                            document.getElementById("ErrorMagConfPass").innerHTML = "";
                        }
                    }
                    break;
                }
                case "CribField": {
                    let CribValueL = this.state.CribValue.value
                    if (CribValueL == "" || CribValueL == null || CribValueL == undefined) {
                        document.getElementById('CribValidate').innerText = "Please select a crib";
                    }
                    else {
                        document.getElementById('CribValidate').innerText = "";
                    }
                }
            }
        });

        return (

            <div className="container-fluid content-margin Top-margin custom-mb">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3 my-2">
                        <h5 className="page-title"><Trans>Profile Update</Trans></h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-1">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 mb-sm-5 mb-lg-0" style={{ "marginBottom": "65px" }}>
                        <ul className="nav nav-tabs catalog-tabs  custom-tab-style  catalog-tabs-mobile profile-update-tab" id="myTab" role="tablist">
                            <li className="nav-item" id="ProfileTab">
                                <a className="nav-link active" id="user-details-tab" data-toggle="tab" href="#user-details" role="tab" aria-controls="user-details" aria-selected="true" onClick={() => this.TabClick("UD")}><Trans>User details</Trans></a>
                            </li>
                            <li className="nav-item" id="privilegesTab">
                                <a className="nav-link" id="user-privileges-tab" data-toggle="tab" href="#user-privilege" role="tab" aria-controls="user-privilege" aria-selected="false" onClick={() => this.TabClick("UPVL")}><Trans>User privileges</Trans></a>
                            </li>
                            <li className="nav-item" id="approvalsTab">
                                <a className="nav-link" id="approvals" data-toggle="tab" href="#approvals-link" role="tab" aria-controls="approvals-link" aria-selected="false" onClick={() => this.TabClick("APP")}><Trans>Approvals</Trans></a>
                            </li>
                            <li className="nav-item" id="orderSETab">
                                <a className="nav-link" id="order-status-emails" data-toggle="tab" href="#order-status-link" role="tab" aria-controls="order-status-link" aria-selected="false" onClick={() => this.TabClick("OSE")}><Trans>order_status</Trans><span> </span><Trans>emails</Trans></a>
                            </li>
                            <li className="nav-item" id="preferencesTab">
                                <a className="nav-link" id="preferences" data-toggle="tab" href="#preferences-link" role="tab" aria-controls="preferences-link" aria-selected="false" onClick={() => this.TabClick("PREF")}><Trans>Preferences</Trans></a>
                            </li><li className="nav-item" id="mobilityTab">
                                <a className="nav-link" id="mobility" data-toggle="tab" href="#mobility-link" role="tab" aria-controls="mobility-link" aria-selected="false" onClick={() => this.TabClick("MOB")}><Trans>Mobility</Trans></a>
                            </li>
                            {/* <li className="nav-item" id="zeusTab">
                                <a className="nav-link" id="zeus" data-toggle="tab" href="#zeus-link" role="tab" aria-controls="zeus-link" aria-selected="false" onClick={() => this.TabClick("ZEUS")}>Zeus</a>
                            </li>
                            <li className="nav-item" id="sditrackTab">
                                <a className="nav-link" id="sdi-track" data-toggle="tab" href="#sdi-track-link" role="tab" aria-controls="sdi-track-link" aria-selected="false" onClick={() => this.TabClick("TST")}><span>SDI </span><Trans>Track</Trans></a>
                            </li>*/}
                        </ul>
                        <div className="tab-content catalog-tab-content Catalog-Items" id="myTabContent">
                            <div className="errorspan" > <span id="StatusMsg"></span></div>
                            <div className="tab-pane p-3 fade show active" id="user-details" role="tabpanel" aria-labelledby="user-details-tab">
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="float-right">
                                            <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 ml-2" id="ChangePasBtn" onClick={() => this.ChgPwd()}><Trans>change_pwd</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 ml-2" id="AddUserBtn" onClick={() => this.AddUser()}><Trans>Add</Trans><span> </span><Trans>user</Trans></button>
                                            <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 hide" id="EditMode" onClick={() => this.EditUser()}><Trans>Edit</Trans><span> </span><Trans>Mode</Trans></button>
                                        </div>
                                    </div>
                                    <div className="col-md-12 border-bottom mb-4">
                                        <div className="row">
                                            <div className="col-md-6 mb-4 Ipad-UI">
                                                <label className="float-left col-md-4 form-label catalog-label"><Trans>User ID</Trans></label>
                                                {/*11/11/22, PS_WW-538_01 - Adding the maxlength as 30 characters for the user ID, Dhevanesam R]*/}
                                                <div className="float-left col-md-8">
                                                    <input type="text" id="TBUserid" maxLength="30" className="form-control w-75" placeholder="Enter Value" value={this.state.SelectedUserId} disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-4 Ipad-UI" id="UserTypeDiv">
                                                <label className="float-left col-md-4 form-label catalog-label"><Trans>User Type</Trans></label>
                                                <div className="float-left col-md-8">
                                                    <label className="custom-radiobtn mr-2 my-2"><span>SDI </span><Trans>Employee</Trans>
                                                        <input type="radio" name="radio" checked={this.state.SDIEMp} id="UtypeSDI" onChange={() => this.UserTypeRadio("S")} />
                                                        <span className="checkmark" />
                                                    </label>
                                                     <label className="custom-radiobtn d-none mr-2 my-2"><Trans>Vendor</Trans>
                                                        <input type="radio" name="radio" checked={this.state.vendor} id="UtypeCustomer" onChange={() => this.UserTypeRadio("V")} />
                                                        <span className="checkmark" />
                                                    </label> 
                                                    <label className="custom-radiobtn ml-5 my-2"><Trans>Customer</Trans>
                                                        <input type="radio" name="radio" checked={this.state.Customer} id="UtypeVendor" onChange={() => this.UserTypeRadio("C")} />
                                                        <span className="checkmark" />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-4 Ipad-UI" id="SearchDIv">
                                                <label className="float-left col-md-4 form-label catalog-label "><Trans>Search User</Trans></label>
                                                <div className="float-left col-md-8">
                                                    <Select
                                                        className="w-75 DropDown-Font-Size"
                                                        value={this.state.selectedOption}
                                                        onChange={this.handleChange}
                                                        options={this.state.SearchUser}
                                                    />
                                                </div>
                                            </div>
                                             <div className="col-md-6 mb-4 Ipad-UI d-none" id="VendorDiv">
                                                <label className="float-left col-md-4 form-label catalog-label"><Trans>Vendor</Trans><span> </span><Trans>ID</Trans></label>
                                                <div className="float-left col-md-8">
                                                    <input type="text" id="VendorID" className="form-control w-75" placeholder="Enter Value" maxLength="30" name="VendorId" value={this.state.VendorId} onBlur={() => this.VendorIdChaneg()} onChange={this.handleProfileFormChange} />
                                                    <span id="VendorGroupValue" className="DropDown-Font-Size errorcolour">{this.state.VendorGroup}</span>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>f_name</Trans></label>
                                        <div className="float-left col-md-8">
                                            <input type="text" className="form-control w-75 changeevent" placeholder="Enter First name" maxLength="30" name="FirstName" id="FirstNTB" value={this.state.FirstName} onChange={this.handleProfileFormChange} disabled={this.state.DisableFields} />
                                            <span id="ErrorMagFirstName" className="DropDown-Font-Size errorcolour"></span>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>l_name</Trans></label>
                                        <div className="float-left col-md-8">
                                            <input type="text" className="form-control w-75 changeevent" placeholder="Enter Last name" name="LastName" id="LastNTB" maxLength="30" value={this.state.LastName} onChange={this.handleProfileFormChange} disabled={this.state.DisableFields} />
                                            <span id="ErrorMagLastName" className="DropDown-Font-Size errorcolour"></span>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Email Address</Trans></label>
                                        <div className="float-left col-md-8">
                                            <input type="text" className="form-control w-75 changeevent" placeholder="Enter E-Mail address" name="EmailAddres" id="EmailNTB" maxLength="30" value={this.state.EmailAddres} onChange={this.handleProfileFormChange} disabled={this.state.DisableFields} />
                                            <span id="ErrorMagEMailAdd" className="DropDown-Font-Size errorcolour"></span>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Phone</Trans></label>
                                        <div className="float-left col-md-8">
                                            <input type="text" className="form-control w-75 changeevent" placeholder="Enter Phone number" name="PhoneNum" id="PhoneNumNTB" maxLength="10" value={this.state.PhoneNum} onChange={this.handleProfileFormChange} disabled={this.state.DisableFields} />
                                            <span id="ErrorMagPhone" className="DropDown-Font-Size errorcolour"></span>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mb-4 Ipad-UI" id="PassDiv">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Password</Trans></label>
                                        <div className="float-left col-md-8">
                                            <Input type={this.state.showPassword ? "text" : "password"} inputProps={{
                                                maxLength: 128
                                            }} className="form-control w-75 changeevent pr-0" id="PassNTB" name="PassNTB" onPaste={this.handlePaste} onKeyDown={this.handleKeyDown} placeholder="Enter password" value={this.state.PassNTB} onChange={this.handleProfileFormChange}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={(e) => this.handleClickShowPassword(e, "PASS")}
                                                            onMouseDown={this.handleMouseDownPassword}
                                                        >
                                                            {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                } />
                                            <div className="errorSpanWidth"><span id="ErrorMagPass" className="DropDown-Font-Size errorcolour"></span></div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mb-4 Ipad-UI" id="ConfPassDiv">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Confirm Password</Trans></label>
                                        <div className="float-left col-md-8">
                                            <Input type={this.state.showConPassword ? "text" : "password"} inputProps={{
                                                maxLength: 128
                                            }} className="form-control w-75 changeevent pr-0" maxLength="128" id="ConPasNTB" name="ConPasNTB" onPaste={this.handlePaste} onKeyDown={this.handleKeyDown} placeholder="Enter confirm password" value={this.state.ConPasNTB} onChange={this.handleProfileFormChange}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={(e) => this.handleClickShowPassword(e, "CONPASS")}
                                                            onMouseDown={this.handleMouseDownPassword}
                                                        >
                                                            {this.state.showConPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                            <div className="errorSpanWidth"><span id="ErrorMagConfPass" className="DropDown-Font-Size errorcolour"></span></div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Site</Trans></label>
                                        <div className="float-left col-md-8">
                                            {this.state.SiteList.length > 0 ? <div><Select
                                                className="w-75 DropDown-Font-Size changeevent"
                                                value={this.state.SelectSite}
                                                onChange={this.handleChangeSite}
                                                options={this.state.SiteList}
                                                isDisabled={this.state.DisableFields}
                                            /> </div> : <input type="text" id="SiteGroup" className="form-control w-75" value={this.state.SiteTitleValue} disabled />}
                                            <span id="ErrorMagSite" className="DropDown-Font-Size errorcolour"></span>
                                            <div id="MultiDiv">
                                                <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block ">
                                                    <input type="checkbox" className="custom-control-input" id="MultiSelectUP" name="example4" checked={this.state.MultiSiteChecked == true ? true : false} onChange={() => this.MultiSiteCheckBtn()} />{/*NEW***(1/25/2021)changed**(id)customCheck7-->MultiSelectUP*/}
                                                    <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor="MultiSelectUP">Enable Multisite Access</label>{/*NEW***(1/25/2021)changed**(htmlfor)customCheck7-->MultiSelectUP*/}
                                                </div>
                                                <div id="MultiSelectDD">
                                                    <MultiSelect
                                                        options={this.state.MultiSite}
                                                        value={this.state.MultiSiteSelected}
                                                        onChange={this.handleMultiSiteDD}
                                                        labelledBy={"Select"}
                                                        className="w-75 DropDown-Font-Size"
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-6  mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>type</Trans></label>
                                        <div className="float-left col-md-8">
                                            <Select
                                                isDisabled={this.state.DisableTypeDD || this.state.DisableFields}
                                                className="w-75 DropDown-Font-Size changeevent"
                                                value={this.state.SelectUserRole}
                                                onChange={this.handleChangeUserROle}
                                                options={this.state.UserRoleDD}
                                            />
                                            <span id="ErrorMegSite" className="DropDown-Font-Size errorcolour"></span>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI" id="DepartDiv">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>dept</Trans></label>
                                        <div className="float-left col-md-8">
                                            <Select
                                                placeholder="Select department"
                                                className="w-75 DropDown-Font-Size"
                                                value={this.state.DepartMent}
                                                onChange={this.handleChangeDepart}
                                                options={this.state.Depart}
                                                isDisabled={this.state.DisableFields}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI" id="DepartDiv">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Site language</Trans></label>
                                        <div className="float-left col-md-8">
                                            <Select
                                                placeholder="Select department"
                                                className="w-75 DropDown-Font-Size"
                                                value={this.state.language}
                                                onChange={(e) => this.setState({ language: e })}
                                                options={languageOptions}
                                                components={{ Option: IconOption }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12 my-3">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 mb-2" id="EmpyAcctBtn" onClick={() => this.ActiveEmployeeAccount(1)}>In-Active Employee Account</button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 mr-2" id="AcctBtn" onClick={() => this.ActiveEmployeeAccount(2)}>In-Active Account</button>

                                    </div>
                                    <div className="col-md-12">
                                        <span id="EmpLabel" className="float-right px-4 DropDown-Font-Size errorcolour"></span>
                                        <span id="AcctLabel" className="float-right px-4 mr-2 DropDown-Font-Size errorcolour"></span>
                                    </div>

                                    <div className="col-md-12 my-3">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => this.btnSave_Click()} data-backdrop="static" data-keyboard="false"><Trans>Submit</Trans></button>
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}>{this.state.PageAction == "ADD" ? <Trans> Clear </Trans> : <Trans>Cancel</Trans>}</button>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane p-3 mob-table-spacing-none fade" id="user-privilege" role="tabpanel" aria-labelledby="user-privileges-tab">
                                <div className="row">
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>User ID</Trans></label>
                                        {/*11/11/22, PS_WW-538_01 - Adding the maxlength as 30 characters for the user ID, Dhevanesam R]*/}
                                        <div className="float-left col-md-8">
                                            <input type="text" className="form-control w-75" maxLength="30" placeholder="Enter Value" value={this.state.SelectedUserId} disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI" id="PrivTypeDIv">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Privilege type</Trans></label>
                                        <div className="float-left col-md-8">
                                            <label className="custom-radiobtn mr-2 my-2"><Trans>A la Carte</Trans>
                                                <input type="radio" id="Alacart" name="radio2" onClick={() => this.OnchangePrivType("0")} />
                                                <span className="checkmark" />
                                            </label>
                                            <label className="custom-radiobtn mr-2 my-2"><Trans>Role</Trans>
                                                <input type="radio" id="Role" name="radio2" onClick={() => this.OnchangePrivType("1")} />
                                                <span className="checkmark" />
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>user_group</Trans></label>
                                        <div className="float-left col-md-8">
                                            <input type="text" className="form-control w-75" value={this.state.Tab2SiteTitle} disabled onChange={this.handleProfileFormChange} />
                                        </div>
                                    </div>
                                    {!this.state.DisablePrivRole ? 
                                    <div className="col-md-6 mb-4 Ipad-UI" id="PrivRoleTypeDD">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Role</Trans></label>
                                        <div className="float-left col-md-8">
                                            <Select
                                                isDisabled={this.state.DisablePrivRole}
                                                className="w-75 DropDown-Font-Size"
                                                value={this.state.SelectROleList}
                                                onChange={this.handleChangeTab2Role}
                                                options={this.state.Tab2RoleList}
                                            />
                                        </div>
                                    </div> :
                                    this.state.LoginUserRole.toUpperCase() != "CORP ADMIN" && this.state.tabrole.toUpperCase() != "USER" ?
                                    <div className="col-md-6 mb-4 Ipad-UI" id="PrefFlagsDD">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Preference flags</Trans></label>
                                        <div className="float-left col-md-8 w-55">
                                            <MultiSelect
                                                options={this.state.flagOptions}
                                                value={this.state.flagValues}
                                                onChange={(e) => { this.setState({ flagValues: e }) }}
                                                labelledBy={"Select"}
                                                overrideStrings={{ selectSomeItems: t("Select...") }}
                                            />
                                        </div>
                                    </div> : null }
                                    <div className="container-fluid profile-update">
                                        <div className="row px-4 custom-program-parent pt-4">
                                            {this.state.tabrole != "USER" ?

                                                <div className="col-md-6 p-0 custom-program-left" id="ProgramleftId">
                                                    <div className="custom-program-section custom-border-bottom" id="PrivtopButton">
                                                        <div className="d-grid d-md-flex justify-content-md-between align-items-center grid-resp-style">
                                                            <h5 className="font-bold font-14 m-0">Programs</h5>
                                                            <div className="profile-btn-space">
                                                                {this.state.isExpandAll ?
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary custom-btn-primary primary-btn px-3 custom-dt-mr-2 primary-btn-responsive" id="ExpandALL" onClick={() => this.PrivTreeAction("E")}><Trans>Expand</Trans><span> </span><Trans>all</Trans></button>
                                                                    :
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary custom-btn-primary primary-btn px-3 custom-dt-mr-2 primary-btn-responsive" id="CollapseALL" onClick={() => this.PrivTreeAction("C")}> <Trans>Collapse</Trans><span> </span><Trans>all</Trans></button>}
                                                                {SelectAll ?
                                                                    this.state.isSelectAll ?
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary custom-btn-primary primary-btn px-3 primary-btn-responsive" id="SelPrivBtn" onClick={() => this.PrivTreeAction("S")}> <Trans>Select</Trans><span> </span><Trans>all</Trans></button>
                                                                        :
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary custom-btn-primary primary-btn px-3 primary-btn-responsive" id="DeSelPrivBtn" onClick={() => this.PrivTreeAction("D")}> <Trans>Unselect</Trans><span> </span><Trans>all</Trans></button>
                                                                    : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="custom-program-title" id="PrivProgramTitle">
                                                        <p>
                                                            <img
                                                                src="images/tooltip-icon-yellow.svg"
                                                                alt="tooltip-icon-yellow"
                                                                className="custom-tooltip-icon mr-2"
                                                            /> Select atleast two programs  </p>
                                                        <div className="custom-program-list popup-scroll">
                                                            <div className="col-md-12" id="PrivProgramTree">
                                                                <CheckboxTree
                                                                    nodes={this.state.Tab2BindTree}
                                                                    iconsClass="fa4"
                                                                    showNodeIcon={true}
                                                                    checked={this.state.checked}
                                                                    expanded={this.state.expanded}
                                                                    onCheck={this.OnCheckTree}
                                                                    onExpand={expanded => this.setState({ expanded })}
                                                                    disabled={this.state.PrivTreeDisable}
                                                                    icons={{
                                                                        check: <span className="rct-icon rct-icon-check" />,
                                                                        uncheck: <span className="rct-icon rct-icon-uncheck" />,
                                                                        halfCheck: <span className="rct-icon rct-icon-half-check" />,
                                                                        expandClose: <span className="rct-icon rct-icon-expand-close" />,
                                                                        expandOpen: <span className="rct-icon rct-icon-expand-open" />,
                                                                        expandAll: <span className="rct-icon rct-icon-expand-all" />,
                                                                        collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
                                                                        parentClose: <span className="rct-icon rct-icon-parent-close" />,
                                                                        parentOpen: <span className="rct-icon rct-icon-parent-open" />,
                                                                        leaf: <span className="rct-icon rct-icon-leaf" />,
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : null}
                                            {((this.state.selectSiteID == 'I0W01') && (this.state.UserHomeTilesList.length > 0)) ?
                                                <div className={`${(this.state.onlyHomeTile == "") ? 'col-md-6 p-0 custom-program-right' : 'home-width'}`}>
                                                    <div className="custom-program-section custom-border-bottom">
                                                        <div className="d-grid d-md-flex justify-content-md-between align-items-center grid-resp-style">
                                                            <h5 className="font-bold font-14">Home tile</h5>
                                                        </div>
                                                    </div>
                                                    <div className="custom-program-title">
                                                        {this.state.UserHomeTilesList.length > 12 ?
                                                            <p>
                                                                <img
                                                                    src="images/tooltip-icon-yellow.svg"
                                                                    alt="tooltip-icon-yellow"
                                                                    className="custom-tooltip-icon mr-2"
                                                                /> A maximum of 12 tiles can be chosen.</p> : null}
                                                        <div className="row program-home-tile scroll-hometile custom-program-list-scroll">
                                                            <div className="col-md-12 scroll-hometile">
                                                                <div className="row">
                                                                    {this.BindHomeTiles()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                    <div className="col-md-12 d-flex justify-content-end mt-5" id="privsavecandiv">
                                        <button className="btn custom-btn-secondary secondary-btn px-4 mr-3 primary-btn-responsive" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                        <button className="btn custom-btn-primary px-4 m-0 primary-btn-responsive" onClick={() => this.updatePrivilege()}><Trans>Submit</Trans></button>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane p-3 fade" id="approvals-link" role="tabpanel" aria-labelledby="approvals">

                                <div style={{ "margin-bottom": "1%" }}>
                                    {this.state.ApproverPopupFlag ? <button className="btn btn-primary custom-btn-primary primary-btn ml-auto float-right" data-toggle="modal" data-target=".my-approver-details">Approver Info</button> : null}
                                </div>
                                <div id="budApproval" className="hide">
                                    <div className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, "BudReq", 1)} style={{ "display": "inline-block" }} >
                                        <span className="accordion-arrow header-arrow" id="arrow-BudReq" />
                                    </div>
                                    <span style={{ "margin-left": "1%", "font-size": "15px", "font-weight": "bold" }}><Trans>Budgetary Approval</Trans></span>
                                    <hr className="accordion-line" />
                                    <div className="p d-none content-row" id="contentrow-BudReq">
                                        <div colSpan={8} className="py-0">
                                            <div className="accordian-body  py-1" id="order-row-1">
                                                <div className="row pl-4">
                                                    <div className="col-md-12 p-0">
                                                        <div className="col-md-7 mb-4 float-left Approval-mainDiv mt-3">
                                                            <label className="float-left col-md-4 form-label catalog-label pl-0" id="ApprLabel"><Trans>Budgetary Approval by</Trans></label>
                                                            <div className="float-left col-md-8 delete-checkbox p-0">
                                                                <Select
                                                                    className="w-75 DropDown-Font-Size"
                                                                    value={this.state.ExistApproveValue}
                                                                    onChange={this.handleChangeAppro}
                                                                    options={this.state.ApproverList}
                                                                />
                                                                {/*[8/10/22, Bug - 2349, PS_UP_02, Dhevanesam R]*/}
                                                                {approvalAccordian == 1 ? <div className="custom-control custom-checkbox my-2 item-custom-control hide" id="removeApprover">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheckk" name="example1" />
                                                                    <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor="customCheckk"><Trans>Delete</Trans></label>
                                                                </div> : null}

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 p-0" id="BudLimitDiv">
                                                        <div className="col-md-7 mb-4 float-left Ipad-UI">
                                                            <label className="float-left col-md-4 form-label catalog-label p-0"><Trans>Order Total Requiring Approval</Trans> ($)</label>
                                                            <div className="float-left col-md-8 p-0">
                                                                <input type="text" className="form-control w-25" placeholder={t("Enter Value")} id="BUdLimitData" name="ExistAppLimit" maxLength="10" value={this.state.ExistAppLimit} onChange={this.handleProfileFormChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 my-3">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={(e) => this.UpdateApprovals(e)}><Trans>Submit</Trans></button>
                                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="reqApproval">
                                    <div className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, "AltReq", 2)} style={{ "display": "inline-block", "margin-top": "1%" }} >
                                        <span className="accordion-arrow header-arrow" id="arrow-AltReq" />
                                    </div>
                                    <span style={{ "margin-left": "1%", "font-size": "15px", "font-weight": "bold" }}><Trans>Alternate Requestor Approval</Trans></span>
                                    <hr className="accordion-line" />
                                    <div className="p d-none content-row" id="contentrow-AltReq">
                                        <div colSpan={8} className={`py-0`}>
                                            <div className="accordian-body  py-1" id="order-row-1">
                                                <div className={`row pl-4`}>
                                                    <div className={`col-md-12 p-0 ${this.state.ApproverList.length > 0 ? '' : 'hide'}`}>
                                                        <div className="col-md-7 mb-4 float-left Approval-mainDiv mt-3">
                                                            <label className="float-left col-md-4 form-label catalog-label pl-0" id="ApprLabel"><Trans>Alternate Requestor Approval by</Trans></label>
                                                            <div className="float-left col-md-8 delete-checkbox p-0">
                                                                <Select
                                                                    className="w-75 DropDown-Font-Size"
                                                                    value={this.state.ExistApproveValue}
                                                                    onChange={this.handleChangeAppro}
                                                                    options={this.state.ApproverList}
                                                                />
                                                                {/*[8/10/22, Bug - 2349, PS_UP_02, Dhevanesam R]*/}
                                                                {approvalAccordian == 2 ? <div className="custom-control custom-checkbox my-2 item-custom-control hide" id="removeApprover">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheckk" name="example1" />
                                                                    <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor="customCheckk"><Trans>Delete</Trans></label>
                                                                </div> : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`col-md-12 my-3 ${this.state.ApproverList.length > 0 ? '' : 'hide'}`}>
                                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={(e) => this.UpdateApprovals(e)}><Trans>Submit</Trans></button>
                                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                                    </div>

                                                </div>
                                                <div className={`row pl-4 ${this.state.ApproverList.length > 0 ? 'hide' : ''}`}>
                                                    <p className={`search-result-content pt-2 `} style={{ "padding-left": "40%" }}><Trans>No alternate requestor approver found</Trans></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="altBudApproval">
                                    <div className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, "AltBud", 3)} style={{ "display": "inline-block", "margin-top": "1%" }} >
                                        <span className="accordion-arrow header-arrow" id="arrow-AltBud" />
                                    </div>
                                    <span style={{ "margin-left": "1%", "font-size": "15px", "font-weight": "bold" }}><Trans>Alternate Budgetary Approval</Trans></span>
                                    <hr className="accordion-line" />
                                    <div className="p d-none content-row" id="contentrow-AltBud">
                                        <div colSpan={8} className="py-0">
                                            <div className="accordian-body  py-1" id="order-row-1">
                                                <div className={`row pl-4`}>
                                                    <div className={`col-md-12 p-0 ${this.state.ApproverList.length > 0 ? '' : 'hide'}`}>
                                                        <div className="col-md-7 mb-4 float-left Approval-mainDiv mt-3">
                                                            <label className="float-left col-md-4 form-label catalog-label pl-0" id="ApprLabel"><Trans>Alternate Budgetary Approval by</Trans></label>
                                                            <div className="float-left col-md-8 delete-checkbox p-0">
                                                                <MultiSelect
                                                                    options={this.state.ApproverList}
                                                                    className="DropDown-Font-Size UserCSS-alt-budg "
                                                                    id="REG"
                                                                    value={this.state.selectedApprvValue}
                                                                    onChange={this.handleChangeAppro}
                                                                    labelledBy={"-------Select Approver------"}
                                                                    overrideStrings={{ selectSomeItems: "-------Select Approver------" }}
                                                                    hasSelectAll={false}
                                                                />
                                                                {/*[8/10/22, Bug - 2349, PS_UP_02, Dhevanesam R]*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.ExistApproveValue.length > 0 ?
                                                        <div className="container-fluid">
                                                            <div className="row">
                                                                <div className="col-md-6 mt-3">
                                                                    <div class="table-responsive mb-3">
                                                                        <table className="table split-delv-table">
                                                                            <thead >
                                                                                <tr>
                                                                                    <th className="text-nowrap text-center"><input type="checkbox" className="custom-control-del" id="AltBudgMultiselect" style={{ "opacity": "5", "height": '1.25rem', "width": '1rem' }} onChange={(e) => this.handleMultiCheckOnchange(e)} /></th>
                                                                                    <th className="text-nowrap">Alternate Approver</th>
                                                                                    <th className="text-nowrap text-center">Action</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {this.bindAlternateGrid()}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> : null}

                                                    <div className={`col-md-12 my-3 ${this.state.ApproverList.length > 0 ? '' : 'hide'}`}>
                                                        {((JSON.stringify(this.state.ExistApproveValue) !== JSON.stringify(this.state.updateAltBudgetary)) && (JSON.stringify(this.state.ExistApproveValue) === JSON.stringify(this.state.delAltBudCheck))) ?
                                                            <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => this.UpdateApprovals(this.state.updateAltBudgetary)}><Trans>Submit</Trans></button> : null}
                                                        {(JSON.stringify(this.state.ExistApproveValue) !== JSON.stringify(this.state.delAltBudCheck)) || (this.state.isMultiSelectChecked) ?
                                                            <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => this.UpdateApprovals(this.state.delAltBudCheck)}><Trans>Delete</Trans></button> : null}
                                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                                    </div>
                                                </div>
                                                <div className={`row pl-4 ${this.state.ApproverList.length > 0 ? 'hide' : ''}`}>
                                                    <p className={`search-result-content pt-2 `} style={{ "padding-left": "40%" }}><Trans>No alternate budgetary approver found</Trans></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tab-pane p-3 fade" id="order-status-link" role="tabpanel" aria-labelledby="order-status-emails">
                                <div className="row">

                                    <div className="col-md-12 mb-3">
                                        <label className="fav-item-title mt-2"><span><Trans> Order status emails</Trans></span></label>
                                    </div>
                                    {this.state.RoleExist != "" ? <div className="col-md-12 mb-3">
                                        <label className="mt-2 font-style catalog-details-title">{this.state.RoleExist}</label>
                                    </div> : null}
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Created</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbCRE" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbCRE" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Customer information</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbCST" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbCST" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Quote rejected</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbQTR" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbQTR" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Fully received</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbRCF" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbRCF" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Waiting approval chain</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbQTW" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbQTW" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Vendor information</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbVND" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbVND" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><span><Trans>RFQ approved</Trans></span></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbRFA" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbRFA" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Partial received</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbRCP" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbRCP" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Waiting customer approval</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbQTC" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbQTC" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Approval</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbAPR" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbAPR" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><span> </span><Trans>Rejected</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbRFR" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbRFR" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Cancelled</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbCNC" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbCNC" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Requestor approval</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbQTS" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbQTS" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Quote approved</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbQTA" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbQTA" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><span><Trans>RFQ complete</Trans></span></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbRFC" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbRFC" />
                                        </div>
                                    </div>
                                    <div className="col-md-3 Ipad-OSE">
                                        <label className="col-md-8 catalog-label float-left mt-1 pl-0 Mobile-OSE"><Trans>Delivered</Trans></label>
                                        <div className="col-md-4 custom-control custom-checkbox mb-3 item-custom-control mt-0 float-left mobile-chk-box">
                                            <input type="checkbox" className="custom-control-input" id="chbDLF" name="example1" />
                                            <label className="custom-control-label" htmlFor="chbDLF" />
                                        </div>
                                    </div>
                                    <div className="col-md-12 my-3">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" id="OSESubmitBtn" onClick={() => this.UpdateOSE()}><Trans>Submit</Trans></button>
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane p-3 fade" id="preferences-link" role="tabpanel" aria-labelledby="preferences">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="col-lg-6 col-md-12 float-left p-0 mb-4">
                                            <label className="col-md-4 catalog-label float-left mt-1"><Trans>Product display type</Trans></label>
                                            <div className="float-left col-md-8">
                                                <label className="custom-radiobtn mr-2 my-2" ><Trans>Catalog</Trans>
                                                    <input type="radio" name="type" id="CataDesp" />
                                                    <span className="checkmark" />
                                                </label>
                                                <label className="custom-radiobtn mr-2 my-2" ><Trans>Client</Trans>
                                                    <input type="radio" name="type" id="ClientDesp" />
                                                    <span className="checkmark" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-none">
                                        <div className="col-lg-6 col-md-6 float-left p-0 mb-4">
                                            <label className="col-md-4 catalog-label float-left mt-1"><Trans>Block Price Display</Trans></label>
                                            <div className="col-md-8 custom-control custom-checkbox float-left">
                                                <input type="checkbox" className="custom-control-input" id="PriceDisplay" name="example1" />
                                                <label className="custom-control-label" htmlFor="PriceDisplay" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12" id="DepartPrefDiv">
                                        <div className="col-lg-6 col-md-12 float-left p-0 mb-4">
                                            <label className="float-left col-md-4 form-label catalog-label"><Trans>dept</Trans></label>
                                            <div className="float-left col-md-8 pl-1">
                                                <Select
                                                    className="w-75 DropDown-Font-Size"
                                                    value={this.state.DepartmentPref}
                                                    onChange={this.handleChangeDepartPref}
                                                    options={this.state.DepartPref}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.ShiptoList.length > 0 ? <div className="col-md-12">
                                        <div className="col-lg-6 col-md-12 float-left p-0 mb-4">
                                            {/*[04/05/22,A1QA-163-label change from Home store to Default shipto], Priyanka D */}
                                            <label className="float-left col-md-4 form-label catalog-label"><Trans>Default ship to</Trans></label>
                                            <div className="float-left col-md-8 pl-1">
                                                <Select
                                                    className="w-75 DropDown-Font-Size"
                                                    value={this.state.Shipto}
                                                    onChange={this.handleChangeShipto}
                                                    options={this.state.ShiptoList}
                                                />
                                            </div>
                                        </div>
                                    </div> : null}
                                    <div className="col-md-12 mb-3">
                                        {/*[04/05/22,A1QA-163-label change from Home store to Default shipto], Priyanka D */}
                                        {/*9/21/22, Bug - 2665, To add mandatory symbol to home store, Dhevanesam R]*/}

                                        {/*[07/19/22, PC_WW-448_05], Priyanka D */}
                                        {CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" || CookieService.getLocalStorageValues("Session_USERTYPE") == "CORPADMIN" ?
                                            <div>
                                                <label className="float-left col-md-2 form-label catalog-label mandatory-after"><Trans>Home store</Trans></label>
                                                <div className="float-left col-md-4 pl-1">
                                                    <Select
                                                        className="w-75 DropDown-Font-Size"
                                                        value={this.state.HomeStoreValue}
                                                        onChange={this.handleChangeHomeStore}
                                                        options={this.state.HomeStoreDD}
                                                    />
                                                </div>
                                            </div> :
                                            <div>
                                                <label className="float-left col-md-2 form-label catalog-label"><Trans>Home store</Trans></label>
                                                <label className="float-left col-md-4 form-label ml-1" style={{ fontSize: "14px", fontFamily: 'RobotoRegular' }}>{(this.state.HomeStore == "" || this.state.HomeStore == null || this.state.HomeStore == "0") ? "_" : this.state.HomeStore}</label>
                                            </div>
                                        }

                                    </div>


                                    <div className="col-md-12 mb-3">
                                        {CookieService.getLocalStorageValues("Session_SDIEMP") == "SDI" || CookieService.getLocalStorageValues("Session_USERTYPE") == "CORPADMIN" ?
                                            <div>
                                                <label className="float-left col-md-2 form-label catalog-label mandatory-after"><Trans>Division</Trans></label>
                                                <div className="float-left col-md-4 pl-1">
                                                    <Select
                                                        className="w-75 DropDown-Font-Size height-set"
                                                        value={this.state.DivisionValue}
                                                        onChange={this.handleChangeDivision}
                                                        options={this.state.DivisionDD}
                                                    />
                                                </div>
                                            </div> :
                                            <div>
                                                <label className="float-left col-md-2 form-label catalog-label"><Trans>Division</Trans></label>
                                                <label className="float-left col-md-4 form-label ml-1" style={{ fontSize: "14px", fontFamily: 'RobotoRegular' }}>{(this.state.DivisionValue != undefined && this.state.DivisionValue != null) ? (this.state.DivisionValue.value == "" || this.state.DivisionValue.value == null || this.state.DivisionValue.value == undefined || this.state.DivisionValue.value == "0") ? "_" : this.state.DivisionValue.value : "-"}</label>
                                            </div>
                                        }
                                    </div>
                                    <div className="col-md-12">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => this.UpdatePref()}><Trans>Submit</Trans></button>
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane p-3 fade" id="mobility-link" role="tabpanel" aria-labelledby="mobility">
                                <div className="row">
                                    <div className="col-md-6 mb-4 Ipad-UI">
                                        <label className="float-left col-md-4 form-label catalog-label"><Trans>Crib Identifier</Trans></label>
                                        <div className="float-left col-md-8">
                                            <Select
                                                placeholder="Select crib"
                                                id="CribField"
                                                className="w-75 DropDown-Font-Size changeevent pr-0"
                                                value={this.state.CribValue}
                                                onChange={this.handleChangeCrib}
                                                options={this.state.CribList}
                                            />
                                            <span id="CribValidate" className="DropDown-Font-Size errorcolour"></span>
                                        </div>

                                    </div>
                                    <div className="col-md-12 my-3">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => this.UpdateCrib()}><Trans>Submit</Trans></button>
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane p-3 fade" id="zeus-link" role="tabpanel" aria-labelledby="zeus">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="col-md-6 float-left p-0">
                                            <label className="col-md-4 catalog-label float-left mt-1" id="ZeusLabel">{t(this.state.ZeusTitle)}</label>
                                            <div className="col-md-8 custom-control custom-checkbox mb-3 item-custom-control float-left">
                                                <input type="checkbox" className="custom-control-input" id="Disable-Zeus" name="example1" />
                                                <label className="custom-control-label" htmlFor="Disable-Zeus" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 my-3">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 Zeus-Tab-Btn" onClick={() => this.UpdateZeus()}><Trans>Submit</Trans></button>
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane p-3 fade" id="sdi-track-link" role="tabpanel" aria-labelledby="sdi-track">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="fav-item-title mt-2"><span>SDI </span><Trans>Track</Trans></label>
                                            </div>
                                            <div className="col-md-12 mb-4">
                                                <label className="col-md-4 float-left catalog-label "><Trans>Current</Trans><span> </span><Trans>User</Trans></label>
                                                <label className="col-md-8 float-left item-details-value" id="TSTCurentUser"></label>
                                            </div>
                                            <div className="col-md-12 mb-4 ">
                                                <label className="float-left col-md-4 form-label catalog-label"><span>SDI </span><Trans>Track</Trans><span> </span><Trans>User</Trans><span> </span><Trans>ID</Trans></label>
                                                {/*11/11/22, PS_WW-538_01 - Adding the maxlength as 30 characters for the user ID, Dhevanesam R]*/}
                                                <div className="float-left col-md-8">
                                                    <input type="text" className="form-control w-75" maxLength="30" placeholder="Enter SDITrack User ID" id="TSTUSERID1" defaultValue={this.state.TSTUserID} />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-4 ">
                                                <label className="float-left col-md-4 form-label catalog-label"><Trans>Password</Trans></label>
                                                <div className="float-left col-md-8">
                                                    <input type="password" className="form-control w-75" pattern="[a-zA-Z]" placeholder="Enter password" id="TSTPASSWORD1" defaultValue={''} />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-4 ">
                                                <label className="col-md-4 float-left catalog-label"><span>SDI </span><Trans>Track</Trans><span> </span><Trans>User</Trans><span> </span><Trans>ID</Trans></label>
                                                <label className="col-md-8 float-left item-details-value" id="LoginUserId"></label>
                                            </div>
                                            <div className="col-md-12 mb-4  ">
                                                <label className="col-md-4 float-left catalog-label"><Trans>Added On</Trans></label>
                                                <label className="col-md-8 float-left item-details-value" id="LoginUserADDOn"></label>
                                            </div>
                                            <div className="col-md-12 mb-4  ">
                                                <label className="col-md-4 float-left catalog-label"><span>SDI </span><Trans>Track</Trans><span> GUID</span></label>
                                                <label className="col-md-8 float-left item-details-value" id="LoginUserGuid"></label>
                                            </div>
                                            <div className="col-md-12 mb-4">
                                                <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => this.UpdateTST("1")}><Trans>Add</Trans><span> </span><Trans>To</Trans><span> SDI </span><Trans>Track</Trans></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="fav-item-title mt-2"><Trans>Add</Trans><span> </span><Trans>Other</Trans><span> </span><Trans>User</Trans><span> </span><Trans>To</Trans><span> SDI </span><Trans>Track</Trans></label>
                                            </div>
                                            <div className="col-md-12 mb-4">
                                                <label className="float-left col-md-4 form-label catalog-label"><Trans>Other</Trans><span> </span><Trans>User</Trans></label>
                                                <div className="float-left col-md-8">
                                                    <Select
                                                        className="w-75 DropDown-Font-Size"
                                                        value={this.state.TSTDefaultValue}
                                                        onChange={this.handleChangeEmplyee}
                                                        options={this.state.TSTEmployeeValue}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-4">
                                                <label className="col-md-4 float-left catalog-label "><Trans>user</Trans><span> </span><Trans>ID</Trans></label>
                                                <label className="col-md-8 float-left item-details-value" id="TSTUserName"></label>
                                            </div>
                                            <div className="col-md-12 mb-4">
                                                <label className="col-md-4 float-left catalog-label"><Trans>Business</Trans><span> </span><Trans>Unit</Trans></label>
                                                <label className="col-md-8 float-left item-details-value" id="TSTuserBu"></label>
                                            </div>
                                            <div className="col-md-12 mb-4">
                                                <label className="float-left DropDown-Font-Size" id="TSTError"></label>
                                            </div>
                                            <div id="AddTSTUserDiv" className="row">
                                                <div className="col-md-12 mb-4" id="SDITrackIdDiv">
                                                    <label className="float-left col-md-4 form-label catalog-label"><span>SDI </span><Trans>Track</Trans><span> </span><Trans>User</Trans><span> </span><Trans>ID</Trans></label>
                                                    {/*11/11/22, PS_WW-538_01 - Adding themaxlength as 30 characters for the user ID, Dhevanesam R]*/}
                                                    <div className="float-left col-md-8">
                                                        {AddTSTUSERSuccess == 1 ? <input type="text" className="form-control w-75" id="TSTOTHERID" maxLength="30" placeholder="Enter SDITrack User ID" defaultValue={''} />
                                                            : <label className="col-md-8 float-left item-details-value" id="ADDUserID"></label>}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-4" id="SDITrackPassDiv">
                                                    <label className="float-left col-md-4 form-label catalog-label "><Trans>Password</Trans></label>
                                                    <div className="float-left col-md-8">
                                                        <input type="password" className="form-control w-75 pr-0" id="TSTOTHERPASS" placeholder="Enter password" defaultValue={''} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="ADDEDUSERDiv">
                                                <div className="col-md-12 mb-4">
                                                    <label className="col-md-4 float-left catalog-label"><Trans>Added On</Trans></label>
                                                    <label className="col-md-8 float-left item-details-value" id="ADDEDON"></label>
                                                </div>
                                                <div className="col-md-12 mb-4">
                                                    <label className="col-md-4 float-left catalog-label"><span>SDI </span><Trans>Track</Trans><span> GUID</span></label>
                                                    <label className="col-md-8 float-left item-details-value" id="ADDGUID"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 my-3" id="AddUserDiv">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => this.UpdateTST("2")}><Trans>Add</Trans><span> </span><Trans>To</Trans><span> SDI </span><Trans>Track</Trans></button>
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-2" onClick={() => this.COStatus()}><Trans>Cancel</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal userid" id="UserIdModal" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog  custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Add</Trans><span> </span><Trans>User</Trans><span> </span><Trans>ID</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-10 float-left my-5">
                                        <label className="float-left col-md-3 form-label catalog-label pl-0"><Trans>user</Trans><span> </span><Trans>ID</Trans></label>
                                        {/*11/11/22, PS_WW-538_01 - Adding the maxlength as 30 characters for the user ID, Dhevanesam R]*/}
                                        <div className="float-left col-md-9">
                                            <input type="text" className="form-control " placeholder="Enter User Id" id="ManuallyUserIdTb" maxLength="30" onChange={this.handleUserIdValidation}/>
                                            <span id="ErrorMagUserId" className="DropDown-Font-Size errorcolour"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn px-4 mr-2" data-dismiss="modal"><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={() => this.UpdateUserProfile()}><Trans>save_key</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/**WW-887 (12/28/2023)-Nandhini L*/}
                <div className="modal" id="changePassword_Popup" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content-password">
                            <div className="modal-body">
                                <div className="row text-center-popup text-center">
                                    <div className="col-12 col-popup margin-pop">
                                        <label className="confirm-label-popup d-block"><Trans>Password updated successfully, again login the application</Trans></label>
                                    </div>
                                    <div className="col-md-12 col-popup text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn primary-btn-popup px-5-popup" data-dismiss="modal" onClick={this.logout}><Trans>OK</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="modal fade my-approver-details"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered custom-success-width"
                        role="document"
                    >
                        <div className="modal-content">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Approver Info
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <img src="Images/close-icon.svg" alt="close" />
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center d-flex flex-column justify-content-center align-items-center mt-2">
                                            {/*Current user start here*/}
                                            <p className="Font-14 font-bold mb-2 text-black">
                                                Current User
                                            </p>
                                            <div className="custom-approver-card-style next-approver-card-after w-55 pr-4 pl-4">
                                                <div className="d-flex align-items-center justify-content-center float-left ">
                                                    <div className="d-block mr-2">
                                                        <img
                                                            className=""
                                                            src="Images/user-icon.svg"
                                                            alt="user-icon"
                                                        />
                                                    </div>
                                                    <div className="d-block text-left">
                                                        <p className="font-medium font-12 mb-0 mt-3 text-black order-status-workorder" data-toggle="tooltip" title={this.state.CurrentUserName} data-label="CURRENTUSER">
                                                            {this.state.CurrentUserName.length > 19 ? `${this.state.CurrentUserName.substring(0, 19)}...` : this.state.CurrentUserName}
                                                        </p>
                                                        <p className="mb-3">
                                                            <span className="font-regular font-10 color-grey mr-1">
                                                                Budgetary Limit:
                                                            </span>
                                                            <span className="Font-14 font-bold text-black">
                                                                ${this.state.CurrentUserLimit}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*Current user ends here*/}
                                            {/*Next Approver starts here*/}
                                            <p className="Font-14 font-bold mb-2 text-black">
                                                Next Approver
                                            </p>
                                            <div className="custom-approver-card-style w-55 pr-4 pl-4">
                                                <div className="d-flex align-items-center justify-content-center float-left">
                                                    <div className="d-block mr-2">
                                                        <img
                                                            className=""
                                                            src="Images/user-icon.svg"
                                                            alt="user-icon"
                                                        />
                                                    </div>
                                                    <div className="d-block text-left">
                                                        <p className="font-medium font-12 mb-0 mt-3 text-black order-status-workorder" data-toggle="tooltip" title={this.state.NextApprover} data-label="NEXTAPPROVER">
                                                            {this.state.NextApprover.length > 19 ? `${this.state.NextApprover.substring(0, 19)}...` : this.state.NextApprover}
                                                        </p>
                                                        <p className="mb-3">
                                                            <span className="font-regular font-10 color-grey mr-1">
                                                                Budgetary Limit:
                                                            </span>
                                                            <span className="Font-14 font-bold text-black">
                                                                {this.state.NextApproverLimit != null ? `$${this.state.NextApproverLimit}` : "-"}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*Next Approver ends here*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*My Approver Modal Ends here*/}
                {/*Delete alternate approver starts here*/}
                <div className="modal fade delete-alternate-approver" id="delete-alt-approver" tabIndex={-1} role="dialog" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md modal-dialog-centered custom-delete-width custom-popup" role="document">
                        <div className="modal-content py-2">
                            {/*Delete alternate approver starts here*/}
                            <div className="modal-body pb-0">
                                <div className="row">
                                    <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/trash.svg" alt="delete" />
                                        <h5 className="mb-2 font-16 font-bold color-light-black">Confirm</h5>
                                        <p className="mb-1 font-13 font-regular color-light-black">Are you sure you want to delete the selected alternate approvers?</p>
                                    </div>
                                </div>
                            </div>
                            {/*Delete alternate approver ends here*/}
                            <div className="modal-footer border-0 d-flex justify-content-center">
                                <button className="btn btn-custom-secondary-altbudg  font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={(e) => this.handleDelIconAndPopup("No", e, 1)}> No </button>
                                <button className="btn btn-custom-primary-altbudg font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={(e) => this.handleDelIconAndPopup("Yes", e, 1)}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );

    };
}
export default withTranslation()(Profile);
